import React from "react";

// components
import PageTitle from "../../components/PageTitleCorsi/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import MyDatePicker from "../../widgets/DatePicker";
import InsertEsame from "../../widgets/InsertEsame";
import FixButton from "../../widgets/Button";
import DetailsDialog from "../../widgets/DetailsDialog";
import getCorso from "../../services/getCorso";
import getLezioni from "../../services/getLezioni";
import getMaterie from "../../services/getMaterie";
import updateCorso from "../../services/updateCorso";
import FileUploader from "../../widgets/FileUploader";
import getStudenti from "../../services/getStudenti";
import getLezioniSvolte from "../../services/getLezioniSvolte";
import getPresenzeCorso from "../../services/getPresenzeCorso";
import getPresenzeStudente from "../../services/getPresenzeStudente"; // 🆕 API unificata per presenze
import getAllPresenzeStudenti from "../../services/getAllPresenzeStudenti"; // 🆕 API per precaricare TUTTE le presenze
import CheckBox from "../../widgets/CheckBox";
import updateCorsiRitiroStudente from "../../services/updateCorsiRitiroStudente";
import setSospensioneStudente from "../../services/setSospensioneStudente";
import moment from "moment";
import "moment/locale/it";
import Table from "../../widgets/tables/Table";
import addEsame from "../../services/addEsame";
import getEsami from "../../services/getEsami";
import deleteEsame from "../../services/deleteEsame";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import getCategorieCorsi from "../../services/getCategorieCorsi";
import SelectInput from "../../widgets/SelectInput";
import getDispense from "../../services/getDispense";
import UploadDocument from "../../widgets/uploadDispense";
import UploadCompiti from "../../widgets/UploadCompiti";
import getCompiti from "../../services/getCompiti";
import deleteCompito from "../../services/deleteCompito";
import deleteDispensa from "../../services/deleteDispensa";
import viewCompito from "../../services/viewCompito";
import viewDispensa from "../../services/viewDispensa";
import getCompitoStudenti from "../../services/getCompitoStudenti";
import CompitoStudentiModal from "../../widgets/CompitoStudentiModal";
import getEsamiValutazioni from "../../services/getEsamiVotazioni";
import getRataStatusCorso from "../../services/getRataStatusCorso";
import getPresenze from "../../services/getPresenze";
import updateCorsoStatus from "../../services/updateCorsoStatus";
import SendMailToClassWidget from "../../widgets/SendMailToClassWidget";
import getSetting from "../../services/getSetting";
import saveFile from "../../services/saveFile";
import Utils from "../../utils/utils";
import sendMail from "../../services/sendMail";
import getCambioCorsoStudente from "../../services/getCambioCorsoStudente";
import { getAssenzeCrossCorso } from "../../services/addPresenzaCrossCorso";
import getLezioneRecuperata from "../../services/getLezioneRecuperata";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import Brightness3Icon from "@material-ui/icons/Brightness3";
import getSessioniLezione from "../../services/getSessioniLezione";
import getRecuperi from "../../services/getRecuperi";
import CambioClasseWidget from "../../widgets/CambioClasseWidget";
import getCorsi from "../../services/getCorsi";
import updateScontisticheCorso from "../../services/updateScontisticheCorso";
import getScontisticheCorso from "../../services/getScontisticheCorso";
import getPianoPagamentiCorsoStudenti from "../../services/getPianoPagamentiCorsoStudenti";
import getRataStatus from "../../services/getRataStatus";
import getPianoPagamentiCorso from "../../services/getPianoPagamentiCorso";
import getChiusura from "../../services/getChiusura";
import deleteCorso from "../../services/deleteCorso";

export default class AddCorso extends React.Component {
  constructor(props) {
    super(props);

    // Configura moment.js per l'italiano
    moment.locale("it");

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.userslist = [];
    this.studenti = [];
    this.categorieCorsi = [];

    // 🆕 Inizializza mappe per sistema unificato presenze
    this.presenzeStudenteMap = {}; // id_studente => {tutte, corsoCorrente, corsiPrecedenti, statistiche}
    this.assenzePrecedentiMap = {}; // id_studente => numero assenze precedenti
    this.dettagliAssenzePrecedenti = {}; // id_studente => array dettagli assenze
    this.recuperiPrecedentiMap = {}; // id_studente => array recuperi completati
    this.cambioCorsoData = []; // Cache con flag mantieni_assenze per studente
    this.cambioCorsoMantieniMap = {}; // id_studente (string) => flag numerico 1/0

    this.grid = 2;

    this.pageTitle = "Scheda classe";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {
      details: [],
      insertEsameShow: false,
      exams: [],
      retiredDetails: "",
      showRitirati: false,
      showText: "MOSTRA",
      files: null,
      categorieCorso: [],
      selectedCategoriaCorso: null,
      dispense: [],
      compiti: [],
      headCellsVotiEsami: [],
      esami: [],
      showCambioClasseWidget: false,
      selectedStudent: null,
      corsiPrecedenti: [],
      votiPrecedenti: [],
      headCellsVotiPrecedenti: [],
      votiUnificati: [], // Nuova tabella unificata
      headCellsVotiUnificati: [], // Intestazioni tabella unificata
      scontistiche: "", // Aggiungo lo stato per le scontistiche
      showCompitoStudentiModal: false,
      selectedCompitoTitolo: "",
      compitoStudenti: [],
      loadingCompitoStudenti: false,
      _dummyUpdate: 0, // Per forzare re-render della tabella studenti
      singleMode: false, // Flag per mostrare solo una tab nel modal
    };
  }

  async loadEsami() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    this.esami = await getEsami(username, token, this.corso.id);

    // Formatta le date in formato DD/MM/YYYY
    this.esami = this.esami.map((esame) => ({
      ...esame,
      data: esame.data ? moment(esame.data).format("DD/MM/YYYY") : "",
    }));
  }

  async loadDispense() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    this.dispense = await getDispense(username, token, this.corso.id);

    // Formatta le date con ora quando disponibile
    this.dispense = this.dispense.map((dispensa) => {
      if (dispensa.data) {
        const dataMoment = moment(dispensa.data);

        // Se la data contiene l'ora (non è mezzanotte 00:00)
        if (dataMoment.format("HH:mm") !== "00:00") {
          dispensa.data = dataMoment.format("DD/MM/YYYY HH:mm");
        } else {
          // Se è mezzanotte, mostra solo la data
          dispensa.data = dataMoment.format("DD/MM/YYYY");
        }
      } else {
        dispensa.data = "";
      }

      return dispensa;
    });

    this.setState({
      dispense: this.dispense,
    });
  }

  async loadCompiti() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    this.compiti = await getCompiti(username, token, this.corso.id);

    // Formatta le date con ora quando disponibile
    this.compiti = this.compiti.map((compito) => {
      // Formatta data_creazione
      if (compito.data_creazione) {
        const dataMoment = moment(compito.data_creazione);
        if (dataMoment.format("HH:mm") !== "00:00") {
          compito.data_creazione = dataMoment.format("DD/MM/YYYY HH:mm");
        } else {
          compito.data_creazione = dataMoment.format("DD/MM/YYYY");
        }
      } else {
        compito.data_creazione = "";
      }

      // Formatta data_consegna
      if (compito.data_consegna) {
        const dataMoment = moment(compito.data_consegna);
        if (dataMoment.format("HH:mm") !== "00:00") {
          compito.data_consegna = dataMoment.format("DD/MM/YYYY HH:mm");
        } else {
          compito.data_consegna = dataMoment.format("DD/MM/YYYY");
        }
      } else {
        compito.data_consegna = "";
      }

      return compito;
    });

    this.setState({
      compiti: this.compiti,
    });
  }

  async handleCompitoClick(idCompito) {
    console.log("🔵 handleCompitoClick chiamato con ID:", idCompito);

    // Trova il compito cliccato per ottenere il titolo
    const compito = this.compiti.find((c) => c.id === idCompito);
    console.log("🔵 Compito trovato:", compito);

    if (!compito) {
      console.error("❌ Compito non trovato!");
      return;
    }

    this.setState({
      showCompitoStudentiModal: true,
      selectedCompitoTitolo: compito.titolo,
      loadingCompitoStudenti: true,
      compitoStudenti: [],
    });

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    console.log("🔵 Chiamata API con:", { username, idCompito });

    try {
      const studenti = await getCompitoStudenti(username, token, idCompito);
      console.log("✅ Risposta API studenti:", studenti);
      console.log(
        "✅ Numero studenti ricevuti:",
        studenti ? studenti.length : 0,
      );

      this.setState({
        compitoStudenti: studenti || [],
        loadingCompitoStudenti: false,
      });
    } catch (error) {
      console.error(
        "❌ Errore nel caricamento degli studenti del compito:",
        error,
      );
      this.setState({
        compitoStudenti: [],
        loadingCompitoStudenti: false,
      });
    }
  }

  async loadVotiPrecedenti() {
    try {
      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });
      const currentCourse = cookies.get("currentCourse", { path: "/" });

      const corsiData = await getCambioCorsoStudente(
        username,
        token,
        currentCourse,
      );

      console.log("[loadVotiPrecedenti] Dati ricevuti dal backend:", corsiData);

      // ✅ VALIDAZIONE: Verifica che corsiData sia un array valido
      if (!corsiData || !Array.isArray(corsiData)) {
        console.error(
          "[loadVotiPrecedenti] ERRORE: corsiData non è un array valido",
          corsiData,
        );
        this.setState({ votiPrecedenti: [] });
        return;
      }

      if (corsiData.length === 0) {
        console.log("[loadVotiPrecedenti] Nessun cambio corso trovato");
        this.setState({ votiPrecedenti: [] });
        return;
      }

      // AGGREGAZIONE: Raggruppa i cambi corso per studente
      const studentiMap = {};

      corsiData.forEach((cambio) => {
        const idStudente = cambio.id_studente;

        console.log(`[loadVotiPrecedenti] Studente ${idStudente}:`, {
          hasInfoCorsoPrecedente: !!cambio.info_corso_precedente,
          hasVoti: !!cambio.info_corso_precedente?.voti_corso_precedente,
          numVoti:
            cambio.info_corso_precedente?.voti_corso_precedente?.length || 0,
          votiRaw: cambio.info_corso_precedente?.voti_corso_precedente,
        });

        // Se lo studente non esiste ancora nella mappa, crealo
        if (!studentiMap[idStudente]) {
          const foundStud = this.studenti.find((s) => s.id === idStudente);
          studentiMap[idStudente] = {
            id_studente: idStudente,
            nome: foundStud?.nome || "",
            cognome: foundStud?.cognome || "",
            _esamiOriginali: {}, // Mappa chiave normalizzata -> {nome, data, valutazione}
          };
        }

        // ✅ FIX: SOVRASCRIVI sempre i voti (per cambi corso multipli A→B→C)
        // L'ultimo voto trovato ha priorità (corso più recente)
        if (
          cambio.info_corso_precedente &&
          cambio.info_corso_precedente.voti_corso_precedente
        ) {
          cambio.info_corso_precedente.voti_corso_precedente.forEach(
            (esame) => {
              const chiaveEsame = esame.nome_esame
                .replace(/\s+/g, "")
                .toLowerCase(); // ✅ Case-insensitive
              const esisteGia = !!studentiMap[idStudente][chiaveEsame];

              // SEMPRE sovrascrivi per dare priorità ai voti più recenti
              studentiMap[idStudente][chiaveEsame] = esame.valutazione;
              studentiMap[idStudente]._esamiOriginali[chiaveEsame] = {
                nome: esame.nome_esame,
                data: esame.data || null,
                valutazione: esame.valutazione,
              };

              if (esisteGia) {
                console.log(
                  `[loadVotiPrecedenti] ✓ SOVRASCRITTO esame "${esame.nome_esame}" per studente ${idStudente}: ${esame.valutazione} (corso più recente)`,
                  studentiMap[idStudente]._esamiOriginali[chiaveEsame],
                );
              } else {
                console.log(
                  `[loadVotiPrecedenti] ✓ Aggiunto esame "${esame.nome_esame}" per studente ${idStudente}:`,
                  studentiMap[idStudente]._esamiOriginali[chiaveEsame],
                );
              }
            },
          );
        }
      });

      // Converti la mappa in array
      const esamiVoti = Object.values(studentiMap);

      console.log("[loadVotiPrecedenti] Studenti aggregati:", {
        numStudenti: esamiVoti.length,
        studenti: esamiVoti.map((s) => ({
          id: s.id_studente,
          nome: s.cognome + " " + s.nome,
          numEsami: Object.keys(s._esamiOriginali).length,
        })),
      });

      const headCellsBase = [
        {
          id: "cognome",
          numeric: false,
          disablePadding: true,
          label: "Cognome",
        },
        { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      ];

      const examNamesSet = new Set();
      corsiData.forEach((stud) => {
        if (
          stud.info_corso_precedente &&
          stud.info_corso_precedente.voti_corso_precedente
        ) {
          stud.info_corso_precedente.voti_corso_precedente.forEach((esame) => {
            examNamesSet.add(esame.nome_esame);
          });
        }
      });

      const examCells = Array.from(examNamesSet).map((examName) => ({
        id: examName.replace(/\s+/g, "").toLowerCase(), // ✅ Case-insensitive
        numeric: true,
        disablePadding: false,
        label: examName,
      }));

      const headCellsVotiPrecedenti = headCellsBase.concat(examCells);

      console.log("[loadVotiPrecedenti] Salvando in state:", {
        numStudenti: esamiVoti.length,
        primoStudente: esamiVoti[0],
        studente2660: esamiVoti.find((s) => s.id_studente === 2660),
      });

      this.setState({
        votiPrecedenti: esamiVoti,
        headCellsVotiPrecedenti,
      });

      return esamiVoti;
    } catch (error) {
      console.error("[loadVotiPrecedenti] ERRORE CATCH:", error);
      this.setState({ votiPrecedenti: [] });
      return [];
    }
  }

  /**
   * Carica i voti unificati (corso attuale + corsi precedenti) con indicatori di colore:
   * - Verde: voto EFFETTIVO trasferito da un corso precedente (lo studente AVEVA il voto, non NC)
   * - Rosso: voto recuperato (lo studente NON aveva il voto, poi lo ha recuperato)
   * - Normale: voto inserito normalmente nel corso attuale
   */
  async loadVotiUnificati() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    // Carica gli esami del corso attuale
    const esamiCorsoAttuale = await getEsami(username, token, currentCourse);

    // Carica le valutazioni del corso attuale
    let valutazioniAttuali = await getEsamiValutazioni(
      username,
      token,
      currentCourse,
    );

    // Carica i dati dei corsi precedenti
    const corsiData = await getCambioCorsoStudente(
      username,
      token,
      currentCourse,
    );

    // Mappa nome esame -> id esame nel corso attuale
    const esamiAttualiMap = {};
    esamiCorsoAttuale.forEach((esame) => {
      const nomeNormalizzato = esame.nome.replace(/\s+/g, "").toLowerCase();
      esamiAttualiMap[nomeNormalizzato] = {
        id: esame.id,
        nome: esame.nome,
      };
    });

    // ✅ FIX: Mappa studente -> esami corso precedente (AGGREGA da tutti i cambi corso)
    // Per cambi multipli A→B→C, prende i voti da TUTTI i corsi, dando priorità ai più recenti
    const votiPrecedentiMap = {};
    corsiData.forEach((item) => {
      if (
        item.info_corso_precedente &&
        item.info_corso_precedente.voti_corso_precedente
      ) {
        const idStudente = item.id_studente;

        // Se lo studente non esiste ancora nella mappa, inizializza un array vuoto
        if (!votiPrecedentiMap[idStudente]) {
          votiPrecedentiMap[idStudente] = [];
        }

        // Per ogni voto del corso precedente, controlla se già esiste (stesso esame)
        item.info_corso_precedente.voti_corso_precedente.forEach(
          (votoNuovo) => {
            const nomeNormalizzato = votoNuovo.nome_esame
              .replace(/\s+/g, "")
              .toLowerCase();

            // Cerca se esiste già un voto per questo esame
            const indiceEsistente = votiPrecedentiMap[idStudente].findIndex(
              (v) =>
                v.nome_esame.replace(/\s+/g, "").toLowerCase() ===
                nomeNormalizzato,
            );

            if (indiceEsistente >= 0) {
              // Esame già presente: SOVRASCRIVI con il voto più recente
              console.log(
                `[loadVotiUnificati] ✓ SOVRASCRITTO voto precedente per ${votoNuovo.nome_esame}: ${votiPrecedentiMap[idStudente][indiceEsistente].valutazione} → ${votoNuovo.valutazione}`,
              );
              votiPrecedentiMap[idStudente][indiceEsistente] = votoNuovo;
            } else {
              // Esame nuovo: aggiungi alla lista
              votiPrecedentiMap[idStudente].push(votoNuovo);
            }
          },
        );
      }
    });

    // Crea la struttura dati unificata
    const votiUnificati = [];
    const allEsamiSet = new Set();

    // Raccogli tutti gli esami (attuali + precedenti)
    esamiCorsoAttuale.forEach((esame) => {
      allEsamiSet.add(esame.nome);
    });

    corsiData.forEach((item) => {
      if (
        item.info_corso_precedente &&
        item.info_corso_precedente.voti_corso_precedente
      ) {
        item.info_corso_precedente.voti_corso_precedente.forEach((esame) => {
          allEsamiSet.add(esame.nome_esame);
        });
      }
    });

    // Per ogni studente, crea la riga con tutti i voti
    this.studenti.forEach((studente) => {
      const rowData = {
        id_studente: studente.id,
        nome: studente.nome,
        cognome: studente.cognome,
        voti: {}, // Mappa nome_esame -> { valore, colore, recupero }
      };

      console.log(
        `[loadVotiUnificati] Processando studente: ${studente.nome} ${studente.cognome} (ID: ${studente.id})`,
      );

      // STEP 1: Inizializza tutti gli esami del corso attuale (anche senza voto)
      esamiCorsoAttuale.forEach((esame) => {
        const chiave = esame.nome.replace(/\s+/g, "").toLowerCase(); // ✅ Case-insensitive
        rowData[chiave] = null; // Inizializza a null
        rowData.voti[chiave] = {
          valore: null,
          colore: "normale",
          recupero: false,
          nomeOriginale: esame.nome,
        };
      });

      console.log(
        `[loadVotiUnificati] Esami corso attuale inizializzati: ${esamiCorsoAttuale.length}`,
      );

      // STEP 2: Prima identifica quali esami provengono da cambi corso
      // IMPORTANTE: Solo se lo studente AVEVA EFFETTIVAMENTE UN VOTO (non NC/-1)
      const votiPrec = votiPrecedentiMap[studente.id] || [];
      const nomiEsamiTrasferiti = new Set();

      votiPrec.forEach((esamePrec) => {
        // Considera solo voti effettivi (non NC, non -1, non null)
        if (
          esamePrec.valutazione &&
          esamePrec.valutazione !== -1 &&
          esamePrec.valutazione !== "-1" &&
          esamePrec.valutazione !== "NC"
        ) {
          const nomeNormalizzato = esamePrec.nome_esame
            .replace(/\s+/g, "")
            .toLowerCase();
          nomiEsamiTrasferiti.add(nomeNormalizzato);

          console.log(
            `[loadVotiUnificati] ✓ Voto VALIDO trasferito (da JSON): ${esamePrec.nome_esame} = ${esamePrec.valutazione}`,
          );
        } else {
          console.log(
            `[loadVotiUnificati] ✗ Voto NON valido (NC), non marca come trasferito: ${esamePrec.nome_esame} = ${esamePrec.valutazione}`,
          );
        }
      });

      console.log(
        `[loadVotiUnificati] Esami con voti VALIDI trasferiti (da JSON): ${nomiEsamiTrasferiti.size}`,
        Array.from(nomiEsamiTrasferiti),
      );

      // STEP 3: Popola i voti del corso attuale che lo studente ha
      if (valutazioniAttuali && valutazioniAttuali.length > 0) {
        const votiStudente = valutazioniAttuali.filter(
          (v) => v.id_studente == studente.id,
        );
        console.log(
          `[loadVotiUnificati] Voti trovati per studente: ${votiStudente.length}`,
        );

        if (votiStudente.length > 0) {
          // I voti sono già organizzati come proprietà dell'oggetto con il nome esame come chiave
          const votoObj = votiStudente[0]; // Prendi il primo (e unico) oggetto voto
          console.log(`[loadVotiUnificati] Oggetto voto COMPLETO:`, votoObj);
          console.log(
            `[loadVotiUnificati] Proprietà voto:`,
            Object.keys(votoObj),
          );

          // Itera su tutti gli esami del corso attuale
          esamiCorsoAttuale.forEach((esame) => {
            const chiave = esame.nome.replace(/\s+/g, "").toLowerCase(); // ✅ Case-insensitive
            const nomeNormalizzato = esame.nome
              .replace(/\s+/g, "")
              .toLowerCase();

            // ✅ FIX: Cerca la chiave nel votoObj in modo case-insensitive
            // perché il DB potrebbe avere salvato "Esame3" mentre ora cerchiamo "esame3"
            const chiaveReale = Object.keys(votoObj).find(
              (k) => k.toLowerCase() === chiave,
            );
            const chiaveRecuperato = chiaveReale
              ? `${chiaveReale}_recuperato`
              : `${chiave}_recuperato`;
            const chiaveTrasferito = chiaveReale
              ? `${chiaveReale}_trasferito`
              : `${chiave}_trasferito`; // ✅ NUOVO

            // Controlla se esiste un voto per questo esame nell'oggetto voto
            if (chiaveReale && votoObj[chiaveReale] !== undefined) {
              const valoreVoto =
                votoObj[chiaveReale] === -1 ||
                votoObj[chiaveReale] === "-1" ||
                votoObj[chiaveReale] === "N/A"
                  ? null
                  : votoObj[chiaveReale];

              // Controlla se il voto è marcato come recuperato
              const isRecuperato =
                votoObj[chiaveRecuperato] == 1 ||
                votoObj[chiaveRecuperato] == "1";

              // ✅ NUOVO: Controlla se il voto è marcato come trasferito dal DB
              const isTrasferitoDB =
                votoObj[chiaveTrasferito] == 1 ||
                votoObj[chiaveTrasferito] == "1";

              // IMPORTANTE: Usa PRIMA il campo trasferito dal DB, poi fallback su JSON
              const isTrasferito =
                isTrasferitoDB || nomiEsamiTrasferiti.has(nomeNormalizzato);

              let colore = "normale";
              if (isTrasferito) {
                colore = "verde"; // SEMPRE verde se trasferito (da DB o JSON)
              } else if (isRecuperato) {
                colore = "rosso"; // Rosso solo se recuperato E non trasferito
              }

              console.log(
                `[loadVotiUnificati] ✓ Voto per ${
                  esame.nome
                } (chiave: ${chiave}, DB: ${chiaveReale}) = ${valoreVoto}, recuperato: ${isRecuperato}, trasferito_DB: ${isTrasferitoDB}, trasferito_JSON: ${nomiEsamiTrasferiti.has(
                  nomeNormalizzato,
                )}, colore: ${colore}`,
              );

              rowData[chiave] = valoreVoto;
              rowData.voti[chiave] = {
                valore: valoreVoto,
                colore: colore,
                recupero: false,
                nomeOriginale: esame.nome,
              };
            } else {
              console.log(
                `[loadVotiUnificati] ✗ Voto non trovato per ${esame.nome} (chiave: ${chiave})`,
              );
            }
          });
        }
      } else {
        console.log(`[loadVotiUnificati] Nessun voto attuale per studente`);
      }

      // STEP 4: Aggiungi voti del corso precedente che NON sono stati mappati nel corso attuale
      // (Esami che esistevano nel corso vecchio ma non nel nuovo)
      votiPrec.forEach((esamePrec) => {
        const chiave = esamePrec.nome_esame.replace(/\s+/g, "").toLowerCase(); // ✅ Case-insensitive
        const nomeNormalizzato = esamePrec.nome_esame
          .replace(/\s+/g, "")
          .toLowerCase();

        // Verifica se l'esame esiste anche nel corso attuale
        const esamePresenteInCorsoAttuale = esamiAttualiMap[nomeNormalizzato];

        // Verifica se lo studente ha già un voto nel corso attuale per questo esame
        const haVotoAttuale =
          rowData.voti[chiave] &&
          rowData.voti[chiave].valore !== null &&
          rowData.voti[chiave].valore !== "";

        if (!haVotoAttuale) {
          // Non ha voto nel corso attuale -> aggiungi quello precedente (VERDE)
          console.log(
            `[loadVotiUnificati] ${esamePrec.nome_esame}: esame non presente nel corso attuale, aggiungo voto precedente (VERDE)`,
          );
          rowData[chiave] = esamePrec.valutazione;
          rowData.voti[chiave] = {
            valore: esamePrec.valutazione,
            colore: "verde", // Verde: voto dal corso precedente
            recupero: false,
            nomeOriginale: esamePrec.nome_esame,
          };
        }
        // Se haVotoAttuale è true, è già stato gestito nello STEP 3 con colore verde

        // Se l'esame non esiste nel corso attuale, aggiungilo alla lista
        if (!esamePresenteInCorsoAttuale) {
          allEsamiSet.add(esamePrec.nome_esame);
        }
      });

      // STEP 4: Non serve più - il rosso viene gestito dalla checkbox "recuperato"
      // Tutti i voti sono già impostati: verde per corso precedente, normale per corso attuale

      votiUnificati.push(rowData);
      console.log(
        `[loadVotiUnificati] Studente completato, voti finali:`,
        rowData.voti,
      );
    });

    // Crea le intestazioni della tabella
    const headCellsBase = [
      { id: "cognome", numeric: false, disablePadding: true, label: "Cognome" },
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
    ];

    const esamiCells = Array.from(allEsamiSet).map((nomeEsame) => ({
      id: nomeEsame.replace(/\s+/g, "").toLowerCase(),
      numeric: true,
      disablePadding: false,
      label: nomeEsame,
    }));

    const headCellsVotiUnificati = headCellsBase.concat(esamiCells);

    this.setState({
      votiUnificati,
      headCellsVotiUnificati,
    });

    return votiUnificati;
  }

  async loadAssenzePrecedenti() {
    try {
      console.log(
        "[loadAssenzePrecedenti] === INIZIO CARICAMENTO ASSENZE PRECEDENTI ===",
      );
      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });
      const currentCourse = cookies.get("currentCourse", { path: "/" });

      console.log("[loadAssenzePrecedenti] Corso attuale:", currentCourse);

      const corsiData = await getCambioCorsoStudente(
        username,
        token,
        currentCourse,
      );

      console.log(
        "[loadAssenzePrecedenti] Dati cambio corso ricevuti:",
        corsiData?.length || 0,
        "studenti",
      );
      console.log("[loadAssenzePrecedenti] Dati completi:", corsiData);

      // Se non ci sono dati, esci
      if (!corsiData || corsiData.length === 0) {
        console.log(
          "[loadAssenzePrecedenti] Nessun dato di cambio corso trovato",
        );
        this.assenzePrecedentiMap = {};
        this.dettagliAssenzePrecedenti = {};
        this.cambioCorsoData = [];
        this.cambioCorsoMantieniMap = {};
        return;
      }

      this.cambioCorsoData = [];
      this.cambioCorsoMantieniMap = {};

      // Carica tutti i corsi per avere accesso ai nomi
      const tuttiCorsi = await getCorsi(username, token);
      console.log(
        "[loadAssenzePrecedenti] Corsi disponibili:",
        tuttiCorsi?.length || 0,
      );

      // Funzione helper per estrarre parole chiave da un nome corso
      // ❌ LOGICA VECCHIA: Confronto automatico dei nomi dei corsi
      // Ora usiamo il flag mantieni_assenze dal database invece del confronto automatico
      /*
      const estraiParoleChiave = (nomeCorso) => {
        if (!nomeCorso) return [];
        // Rimuove orari (es. "10.00-13.00") e date (es. "del 05/10/2024")
        // e estrae solo le parole significative
        return nomeCorso
          .replace(/\(\d{2}\.\d{2}-\d{2}\.\d{2}\)/g, "") // Rimuove orari tra parentesi
          .replace(/del \d{2}\/\d{2}\/\d{4}/g, "") // Rimuove date
          .replace(/[()]/g, "") // Rimuove parentesi rimanenti
          .trim()
          .split(/\s+/)
          .filter((parola) => parola.length > 2) // Solo parole con più di 2 caratteri
          .map((parola) => parola.toLowerCase());
      };

      // Ottiene il nome del corso attuale
      const corsoAttuale = tuttiCorsi.find((c) => c.id == currentCourse);
      const paroleChiaveAttuali = corsoAttuale
        ? estraiParoleChiave(corsoAttuale.name)
        : [];

      console.log("Corso attuale:", corsoAttuale?.name);
      console.log("Parole chiave corso attuale:", paroleChiaveAttuali);
      */

      // ✅ AGGREGAZIONE: Raggruppa tutti i cambi corso per ogni studente
      const studentiAggregati = new Map();
      corsiData.forEach((item) => {
        const idStudente = item.id_studente;

        if (!studentiAggregati.has(idStudente)) {
          studentiAggregati.set(idStudente, [item]);
        } else {
          studentiAggregati.get(idStudente).push(item);
        }
      });

      console.log(
        `[loadAssenzePrecedenti] ✅ AGGREGAZIONE: ${corsiData.length} record → ${studentiAggregati.size} studenti unici con cambi multipli`,
      );

      // ✅ Le mappe sono già inizializzate nel constructor, qui le resettiamo solo se necessario
      // (Manteniamo i dati se già caricati da getAllPresenzeStudenti)
      if (!this.assenzePrecedentiMap) this.assenzePrecedentiMap = {};
      if (!this.dettagliAssenzePrecedenti) this.dettagliAssenzePrecedenti = {};
      if (!this.recuperiPrecedentiMap) this.recuperiPrecedentiMap = {};
      if (!this.presenzeStudenteMap) this.presenzeStudenteMap = {};

      // Per ogni studente, aggrega assenze da TUTTI i cambi corso
      studentiAggregati.forEach((cambiCorso, idStudente) => {
        console.log(
          `[loadAssenzePrecedenti] === Processando studente ${idStudente} con ${cambiCorso.length} cambi corso ===`,
        );

        // Ordina i cambi per data (dal più vecchio al più recente)
        cambiCorso.sort((a, b) => {
          const dataA = a.data_cambio || a.info_corso_precedente?.data_cambio;
          const dataB = b.data_cambio || b.info_corso_precedente?.data_cambio;
          return dataA > dataB ? 1 : -1;
        });

        let ultimoFlagMantieni = true;
        let haFlagEsplicito = false;
        let assenzeAggregate = [];
        let pesoTotaleStudente = 0;

        // Processa ogni cambio corso
        cambiCorso.forEach((item, indexCambio) => {
          console.log(
            `[loadAssenzePrecedenti] Cambio ${indexCambio + 1}/${
              cambiCorso.length
            }: Corso ${item.id_corso_precedente} → ${item.id_nuovo_corso}`,
          );
          console.log(
            `[loadAssenzePrecedenti] ID corso precedente:`,
            item.id_corso_precedente,
          );
          console.log(
            `[loadAssenzePrecedenti] Nome corso precedente:`,
            item.nome_corso_precedente,
          );
          console.log(
            `[loadAssenzePrecedenti] Info corso precedente:`,
            item.info_corso_precedente,
          );

          if (
            item.info_corso_precedente &&
            item.info_corso_precedente.assenze_corso_precedente &&
            Array.isArray(item.info_corso_precedente.assenze_corso_precedente)
          ) {
            const mantieniAssenze = this.normalizeMantieniAssenze(
              item.mantieni_assenze,
            );
            const flagEsplicito =
              item.mantieni_assenze !== undefined &&
              item.mantieni_assenze !== null;

            if (flagEsplicito || !haFlagEsplicito) {
              ultimoFlagMantieni = mantieniAssenze;
            }
            if (flagEsplicito) {
              haFlagEsplicito = true;
            }

            console.log(
              `[loadAssenzePrecedenti] Assenze trovate:`,
              item.info_corso_precedente.assenze_corso_precedente.length,
            );

            // Verifica se il corso precedente ha un ID e nome
            let corsoPrecedente = null;
            if (item.id_corso_precedente) {
              corsoPrecedente = tuttiCorsi.find(
                (c) => c.id == item.id_corso_precedente,
              );
              console.log(
                `[loadAssenzePrecedenti] Corso trovato per ID ${item.id_corso_precedente}:`,
                corsoPrecedente?.name,
              );
            }

            // Se non abbiamo l'ID del corso precedente, proviamo a trovarlo tramite il nome
            // Questa è una fallback strategy nel caso i dati non contengano l'ID
            if (!corsoPrecedente && item.nome_corso_precedente) {
              corsoPrecedente = tuttiCorsi.find(
                (c) => c.name === item.nome_corso_precedente,
              );
            }

            // FALLBACK: Se non troviamo il corso precedente nei dati,
            // per ora includiamo le assenze precedenti per retrocompatibilità
            // TODO: in futuro modificare il backend per includere sempre l'info del corso precedente
            if (!corsoPrecedente) {
              // ✅ CONTROLLO FLAG: Anche in retrocompatibilità, rispetta mantieni_assenze
              const mantieniAssenze = this.normalizeMantieniAssenze(
                item.mantieni_assenze,
              );

              console.log(
                `Studente ${item.id_studente}: info corso precedente non disponibile (retrocompatibilità)`,
              );
              console.log(
                "  Flag mantieni_assenze:",
                item.mantieni_assenze,
                "→",
                mantieniAssenze,
              );

              // Solo se il flag mantieni_assenze è attivo
              if (!mantieniAssenze) {
                console.log(
                  `[loadAssenzePrecedenti] Flag mantieni_assenze=0, saltando assenze per retrocompatibilità`,
                );
                return; // Esci dal forEach per questo item
              }

              console.log(
                `[loadAssenzePrecedenti] Flag mantieni_assenze=1, includendo assenze per retrocompatibilità`,
              );

              // FILTRO: Escludi assenze già recuperate (presenza = 1)
              const assenzeNonRecuperate = (
                item.info_corso_precedente.assenze_corso_precedente || []
              ).filter((assenza) => {
                console.log(
                  `[DEBUG FILTRO] Assenza lezione ${assenza.id_lezione}:`,
                  assenza,
                );
                console.log(
                  `[DEBUG FILTRO] Campo presenza:`,
                  assenza.presenza,
                  typeof assenza.presenza,
                );

                // Se l'assenza ha presenza = 1, è stata recuperata
                const recuperata =
                  assenza.presenza === 1 ||
                  assenza.presenza === "1" ||
                  assenza.presenza === true;
                if (recuperata) {
                  console.log(
                    `[loadAssenzePrecedenti] ✅ Assenza lezione ${assenza.id_lezione} già recuperata, escludendo`,
                  );
                } else {
                  console.log(
                    `[loadAssenzePrecedenti] ❌ Assenza lezione ${assenza.id_lezione} NON recuperata, includendo`,
                  );
                }
                return !recuperata;
              });

              // MODIFICA: Accumula assenze precedenti invece di sostituirle (retrocompatibilità)
              // Prima deduplicazione: controlla se queste assenze sono già state elaborate
              const dettagliAttuali =
                this.dettagliAssenzePrecedenti[item.id_studente] || [];

              // Formattiamo le assenze non recuperate
              const assenzePrecedentiFormattate = assenzeNonRecuperate.map(
                (assenza) => {
                  // Calcola il peso: 0.5 se ha id_sessione, altrimenti 1.0
                  const hasSessione =
                    assenza.id_sessione &&
                    assenza.id_sessione !== null &&
                    assenza.id_sessione !== "null" &&
                    assenza.id_sessione !== "";
                  const peso = hasSessione ? 0.5 : 1.0;

                  return {
                    data:
                      assenza.data_assenza ||
                      assenza.assenza ||
                      assenza.data ||
                      assenza.data_lezione ||
                      "Data non disponibile",
                    argomento:
                      assenza.argomento ||
                      assenza.materia ||
                      "Lezione da corso precedente",
                    nomeCorso: "Corso precedente (nome non disponibile)",
                    idLezione:
                      assenza.id_lezione ||
                      assenza.id ||
                      Math.random()
                        .toString(36)
                        .substr(2, 9),
                    id_sessione: assenza.id_sessione, // Preserva id_sessione
                    peso: peso, // Aggiungi il peso calcolato
                    sessione_ora_inizio:
                      assenza.sessione_ora_inizio || assenza.ora_inizio || null,
                    sessione_label:
                      assenza.sessione_label || assenza.label_sessione || null,
                  };
                },
              );

              // Deduplicazione: filtra solo assenze non già presenti
              // Usa id_lezione + id_sessione come chiave per distinguere le mezze giornate
              const assenzeGiaPresenti = new Set(
                dettagliAttuali.map(
                  (a) => `${a.data}_${a.idLezione}_${a.id_sessione || "null"}`,
                ),
              );
              const assenzeNuove = assenzePrecedentiFormattate.filter(
                (assenza) =>
                  !assenzeGiaPresenti.has(
                    `${assenza.data}_${
                      assenza.idLezione
                    }_${assenza.id_sessione || "null"}`,
                  ),
              );

              console.log(
                `[loadAssenzePrecedenti] Retrocompatibilità - assenze filtrate: ${assenzeNuove.length} nuove su ${assenzePrecedentiFormattate.length} totali`,
              );

              // Accumula solo le assenze veramente nuove
              const assenzePrecedentiAttuale =
                this.assenzePrecedentiMap[item.id_studente] || 0;
              // MODIFICA: Somma i pesi invece di contare i record
              const nuoveAssenzePeso = assenzeNuove.reduce(
                (sum, a) => sum + a.peso,
                0,
              );

              this.assenzePrecedentiMap[item.id_studente] =
                assenzePrecedentiAttuale + nuoveAssenzePeso;

              // Accumula i dettagli solo delle assenze nuove
              this.dettagliAssenzePrecedenti[item.id_studente] = [
                ...dettagliAttuali,
                ...assenzeNuove,
              ];

              console.log(
                `[loadAssenzePrecedenti] Retrocompatibilità - assenze totali: ${item.info_corso_precedente.assenze_corso_precedente.length}, non recuperate: ${assenzeNonRecuperate.length}`,
              );
              console.log(
                `[loadAssenzePrecedenti] Retrocompatibilità - dettagli assenze formattate:`,
                assenzePrecedentiFormattate,
              );
              console.log(
                `[loadAssenzePrecedenti] Retrocompatibilità - totale assenze accumulate per studente ${
                  item.id_studente
                }: ${this.assenzePrecedentiMap[item.id_studente]}`,
              );
              return; // Esci dal forEach per questo item
            }

            if (corsoPrecedente) {
              // ✅ NUOVA LOGICA: Usa il flag mantieni_assenze dal database invece del confronto dei nomi
              const mantieniAssenze = this.normalizeMantieniAssenze(
                item.mantieni_assenze,
              );

              console.log(`Studente ${item.id_studente}:`);
              console.log("  Corso precedente:", corsoPrecedente.name);
              console.log(
                "  Flag mantieni_assenze:",
                item.mantieni_assenze,
                "→",
                mantieniAssenze,
              );

              // FILTRO: Escludi assenze già recuperate (presenza = 1)
              const assenzeNonRecuperate = (
                item.info_corso_precedente.assenze_corso_precedente || []
              ).filter((assenza) => {
                console.log(
                  `[DEBUG FILTRO MAIN] Assenza lezione ${assenza.id_lezione}:`,
                  assenza,
                );
                console.log(
                  `[DEBUG FILTRO MAIN] Campo presenza:`,
                  assenza.presenza,
                  typeof assenza.presenza,
                );

                const recuperata =
                  assenza.presenza === 1 ||
                  assenza.presenza === "1" ||
                  assenza.presenza === true;
                if (recuperata) {
                  console.log(
                    `[loadAssenzePrecedenti] ✅ Assenza lezione ${assenza.id_lezione} già recuperata, escludendo`,
                  );
                } else {
                  console.log(
                    `[loadAssenzePrecedenti] ❌ Assenza lezione ${assenza.id_lezione} NON recuperata, includendo`,
                  );
                }
                return !recuperata;
              });

              // MODIFICA: Accumula assenze precedenti invece di sostituirle
              // Prima deduplicazione: controlla se queste assenze sono già state elaborate
              const dettagliAttuali =
                this.dettagliAssenzePrecedenti[item.id_studente] || [];

              // Trasforma le assenze non recuperate nel formato corretto per il modal
              const assenzePrecedentiFormattate = assenzeNonRecuperate.map(
                (assenza) => {
                  // Calcola il peso: 0.5 se ha id_sessione, altrimenti 1.0
                  const hasSessione =
                    assenza.id_sessione &&
                    assenza.id_sessione !== null &&
                    assenza.id_sessione !== "null" &&
                    assenza.id_sessione !== "";
                  const peso = hasSessione ? 0.5 : 1.0;

                  return {
                    data:
                      assenza.data_assenza ||
                      assenza.assenza ||
                      assenza.data ||
                      assenza.data_lezione ||
                      "Data non disponibile",
                    argomento:
                      assenza.argomento ||
                      assenza.materia ||
                      ` ${corsoPrecedente.name}`,
                    nomeCorso: corsoPrecedente.name,
                    idLezione:
                      assenza.id_lezione ||
                      assenza.id ||
                      Math.random()
                        .toString(36)
                        .substr(2, 9),
                    id_sessione: assenza.id_sessione, // Preserva id_sessione
                    peso: peso, // Aggiungi il peso calcolato
                    sessione_ora_inizio:
                      assenza.sessione_ora_inizio || assenza.ora_inizio || null,
                    sessione_label:
                      assenza.sessione_label || assenza.label_sessione || null,
                  };
                },
              );

              // Deduplicazione: filtra solo assenze non già presenti
              // Usa id_lezione + id_sessione come chiave per distinguere le mezze giornate
              const assenzeGiaPresenti = new Set(
                dettagliAttuali.map(
                  (a) => `${a.data}_${a.idLezione}_${a.id_sessione || "null"}`,
                ),
              );
              const assenzeNuove = assenzePrecedentiFormattate.filter(
                (assenza) =>
                  !assenzeGiaPresenti.has(
                    `${assenza.data}_${
                      assenza.idLezione
                    }_${assenza.id_sessione || "null"}`,
                  ),
              );

              console.log(
                `[loadAssenzePrecedenti] Studente ${item.id_studente} - assenze filtrate: ${assenzeNuove.length} nuove su ${assenzePrecedentiFormattate.length} totali`,
              );

              // ✅ SEMPRE accumula i dettagli per il modal (indipendentemente da mantieni_assenze)
              this.dettagliAssenzePrecedenti[item.id_studente] = [
                ...dettagliAttuali,
                ...assenzeNuove,
              ];

              // ✅ SOLO se mantieni_assenze è true, aggiorna il counter
              if (mantieniAssenze) {
                const assenzePrecedentiAttuale =
                  this.assenzePrecedentiMap[item.id_studente] || 0;
                // MODIFICA: Somma i pesi invece di contare i record
                const nuoveAssenzePeso = assenzeNuove.reduce(
                  (sum, a) => sum + a.peso,
                  0,
                );

                this.assenzePrecedentiMap[item.id_studente] =
                  assenzePrecedentiAttuale + nuoveAssenzePeso;

                console.log(
                  `  -> Assenze precedenti accumulate (ore): ${
                    this.assenzePrecedentiMap[item.id_studente]
                  } (precedenti: ${assenzePrecedentiAttuale}, nuove peso: ${nuoveAssenzePeso})`,
                );
              } else {
                // Se mantieni_assenze è false, azzera il counter ma MANTIENI i dettagli
                console.log(
                  `  -> Counter assenze AZZERATO (mantieni_assenze=false), ma dettagli mantenuti per modal`,
                );
                this.assenzePrecedentiMap[item.id_studente] = 0;
              }

              console.log(
                `[loadAssenzePrecedenti] Studente ${item.id_studente} - assenze totali: ${item.info_corso_precedente.assenze_corso_precedente.length}, non recuperate: ${assenzeNonRecuperate.length}`,
              );
              console.log(
                `[loadAssenzePrecedenti] Studente ${item.id_studente} - dettagli assenze formattate:`,
                assenzeNuove,
              );

              // ✅ NUOVO: Carica anche i recuperi del corso precedente
              if (
                item.info_corso_precedente.recuperi_corso_precedente &&
                Array.isArray(
                  item.info_corso_precedente.recuperi_corso_precedente,
                )
              ) {
                console.log(
                  `[loadAssenzePrecedenti] 🔄 Caricamento recuperi corso precedente per studente ${item.id_studente}`,
                );

                const recuperiPrecedenti =
                  item.info_corso_precedente.recuperi_corso_precedente;
                console.log(
                  `[loadAssenzePrecedenti] Trovati ${recuperiPrecedenti.length} recuperi nel corso precedente`,
                );

                // Inizializza array recuperi per questo studente se non esiste
                if (!this.recuperiPrecedentiMap[item.id_studente]) {
                  this.recuperiPrecedentiMap[item.id_studente] = [];
                }

                // Aggiungi i recuperi alla mappa (con deduplicazione)
                recuperiPrecedenti.forEach((recupero) => {
                  const key = `${
                    recupero.id_assenza_originale
                  }_${recupero.id_sessione_assenza || "null"}`;

                  // Verifica se questo recupero non è già presente
                  const esisteGia = this.recuperiPrecedentiMap[
                    item.id_studente
                  ].some(
                    (r) =>
                      `${r.id_assenza_originale}_${r.id_sessione_assenza ||
                        "null"}` === key,
                  );

                  if (!esisteGia) {
                    this.recuperiPrecedentiMap[item.id_studente].push({
                      ...recupero,
                      corso_origine: item.id_corso_precedente,
                      nome_corso_origine: corsoPrecedente.name,
                    });

                    console.log(
                      `[loadAssenzePrecedenti] ✓ Recupero aggiunto: lezione ${recupero.id_assenza_originale}, sessione ${recupero.id_sessione_assenza}, status: ${recupero.status}`,
                    );
                  } else {
                    console.log(
                      `[loadAssenzePrecedenti] ⚠ Recupero duplicato ignorato: lezione ${recupero.id_assenza_originale}`,
                    );
                  }
                });

                console.log(
                  `[loadAssenzePrecedenti] Totale recuperi per studente ${
                    item.id_studente
                  }: ${this.recuperiPrecedentiMap[item.id_studente].length}`,
                );
              }
            } else {
              // Se non riusciamo a trovare il corso precedente, non includiamo le assenze
              if (!this.assenzePrecedentiMap.hasOwnProperty(item.id_studente)) {
                this.assenzePrecedentiMap[item.id_studente] = 0;
                this.dettagliAssenzePrecedenti[item.id_studente] = [];
              }
              console.log(
                `Studente ${item.id_studente}: corso precedente non trovato`,
              );
            }
          } else {
            // Nessuna assenza precedente per questo studente, ma mantieni eventuali assenze accumulate
            if (!this.assenzePrecedentiMap.hasOwnProperty(item.id_studente)) {
              this.assenzePrecedentiMap[item.id_studente] = 0;
              this.dettagliAssenzePrecedenti[item.id_studente] = [];
            }
          }
        }); // Fine cambiCorso.forEach - processa ogni cambio corso

        const finalMantieniValue = ultimoFlagMantieni ? 1 : 0;
        const mapKey = String(idStudente);
        this.cambioCorsoMantieniMap[mapKey] = finalMantieniValue;
        this.cambioCorsoData.push({
          id_studente: Number(idStudente),
          mantieni_assenze: finalMantieniValue,
        });

        // Dopo aver processato tutti i cambi corso dello studente, log finale
        console.log(
          `[loadAssenzePrecedenti] Studente ${idStudente}: Totale assenze aggregate: ${this
            .assenzePrecedentiMap[idStudente] || 0} (ore)`,
        );
      }); // Fine studentiAggregati.forEach - processa ogni studente

      console.log(
        "Assenze precedenti per studente (finale):",
        this.assenzePrecedentiMap,
      );
      console.log(
        "Dettagli assenze precedenti:",
        this.dettagliAssenzePrecedenti,
      );

      // NUOVO: Verifica stati reali delle assenze cross-corso
      await this.verificaStatiAssenzeRecuperate();
    } catch (error) {
      console.error("[loadAssenzePrecedenti] ERRORE:", error);
      this.assenzePrecedentiMap = {};
      this.dettagliAssenzePrecedenti = {};
    }
  }

  /**
   * Verifica lo stato reale delle assenze cross-corso e filtra quelle già recuperate
   */
  async verificaStatiAssenzeRecuperate() {
    console.log(
      `[verificaStatiAssenzeRecuperate] Inizio verifica per ${
        Object.keys(this.assenzePrecedentiMap).length
      } studenti`,
    );

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    // Per ogni studente con assenze precedenti
    for (const idStudente of Object.keys(this.assenzePrecedentiMap)) {
      if (this.assenzePrecedentiMap[idStudente] > 0) {
        try {
          console.log(
            `[verificaStatiAssenzeRecuperate] Verifica studente ${idStudente}`,
          );
          console.log(
            `[verificaStatiAssenzeRecuperate] Parametri chiamata - username: ${username}, token: ${
              token ? "presente" : "assente"
            }, idStudente: ${idStudente}`,
          );

          const response = await getAssenzeCrossCorso(
            username,
            token,
            idStudente,
          );

          console.log(
            `[verificaStatiAssenzeRecuperate] Risposta API per studente ${idStudente}:`,
            response,
          );
          console.log(
            `[verificaStatiAssenzeRecuperate] Tipo response:`,
            typeof response,
          );
          console.log(
            `[verificaStatiAssenzeRecuperate] Response keys:`,
            response ? Object.keys(response) : "response è null/undefined",
          );

          if (response.result === "ok" && response.assenze_cross_corso) {
            // Crea mappa delle assenze recuperate
            const assenzeRecuperate = new Set();
            response.assenze_cross_corso.forEach((assenza) => {
              if (assenza.stato === "recuperata") {
                assenzeRecuperate.add(assenza.id_lezione.toString());
                console.log(
                  `[verificaStatiAssenzeRecuperate] Assenza lezione ${assenza.id_lezione} è recuperata`,
                );
              }
            });

            // Filtra i dettagli delle assenze precedenti
            if (this.dettagliAssenzePrecedenti[idStudente]) {
              const assenzeFiltrate = this.dettagliAssenzePrecedenti[
                idStudente
              ].filter((assenza) => {
                const recuperata = assenzeRecuperate.has(
                  assenza.idLezione.toString(),
                );
                if (recuperata) {
                  console.log(
                    `[verificaStatiAssenzeRecuperate] Rimuovendo assenza recuperata lezione ${assenza.idLezione}`,
                  );
                }
                return !recuperata;
              });

              // Aggiorna conteggi e dettagli
              const assenzeRimosse =
                this.dettagliAssenzePrecedenti[idStudente].length -
                assenzeFiltrate.length;
              this.dettagliAssenzePrecedenti[idStudente] = assenzeFiltrate;

              // ✅ FIX: Calcola il peso totale invece di usare .length
              // Somma i pesi: 0.5 per mezze giornate (con id_sessione), 1.0 per giornate intere
              const pesoTotaleAssenze = assenzeFiltrate.reduce((sum, a) => {
                return sum + (a.peso || 1.0);
              }, 0);

              this.assenzePrecedentiMap[idStudente] = pesoTotaleAssenze;

              console.log(
                `[verificaStatiAssenzeRecuperate] Studente ${idStudente}: ${assenzeRimosse} assenze recuperate rimosse, rimangono ${assenzeFiltrate.length} assenze (peso totale: ${pesoTotaleAssenze})`,
              );
            }
          }
        } catch (error) {
          console.error(
            `[verificaStatiAssenzeRecuperate] Errore per studente ${idStudente}:`,
            error,
          );
          console.error(
            `[verificaStatiAssenzeRecuperate] Tipo errore:`,
            typeof error,
          );
          console.error(
            `[verificaStatiAssenzeRecuperate] Messaggio errore:`,
            error?.message,
          );
          console.error(
            `[verificaStatiAssenzeRecuperate] Stack trace:`,
            error?.stack,
          );
          console.error(
            `[verificaStatiAssenzeRecuperate] Errore completo:`,
            JSON.stringify(error, null, 2),
          );
        }
      }
    }

    console.log(
      `[verificaStatiAssenzeRecuperate] Verifica completata. Nuovi conteggi:`,
      this.assenzePrecedentiMap,
    );
  }

  normalizeMantieniAssenze(flagValue) {
    if (flagValue === 0 || flagValue === "0" || flagValue === false) {
      return false;
    }
    if (flagValue === 1 || flagValue === "1" || flagValue === true) {
      return true;
    }
    // Per retrocompatibilità consideriamo true il valore mancante
    return true;
  }

  shouldMantainAssenze(idStudente) {
    if (!idStudente) return true;

    const key = String(idStudente);
    if (
      this.cambioCorsoMantieniMap &&
      Object.prototype.hasOwnProperty.call(this.cambioCorsoMantieniMap, key)
    ) {
      return this.normalizeMantieniAssenze(this.cambioCorsoMantieniMap[key]);
    }

    const fallbackRecord = this.cambioCorsoData?.find(
      (cc) => cc.id_studente == idStudente,
    );

    return this.normalizeMantieniAssenze(
      fallbackRecord ? fallbackRecord.mantieni_assenze : undefined,
    );
  }

  /**
   * 🆕 NUOVO SISTEMA UNIFICATO
   * Carica tutte le presenze di uno studente da tutti i corsi (corrente + precedenti)
   * Sostituisce la complessa logica di loadAssenzePrecedenti + aggregazioni JSON
   */
  async loadPresenzeUnificate(idStudente) {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    try {
      console.log(
        `[loadPresenzeUnificate] 🔄 Caricamento presenze unificate per studente ${idStudente}`,
      );

      // Carica TUTTE le presenze dello studente da tutti i corsi
      const tuttePresenze = await getPresenzeStudente(
        username,
        token,
        idStudente,
      );

      console.log(
        `[loadPresenzeUnificate] ✅ Ricevute ${tuttePresenze.length} presenze totali`,
      );

      // Separa presenze corso corrente e corsi precedenti
      const presenzeCorsoCorrente = tuttePresenze.filter(
        (p) => p.id_corso == currentCourse,
      );
      const presenzeCorsiPrecedenti = tuttePresenze.filter(
        (p) => p.id_corso != currentCourse,
      );

      console.log(
        `[loadPresenzeUnificate] Corso corrente: ${presenzeCorsoCorrente.length}, Corsi precedenti: ${presenzeCorsiPrecedenti.length}`,
      );

      // Calcola statistiche unificate PRIMA di salvare
      const stats = this.calcolaStatistichePresenze(
        tuttePresenze,
        currentCourse,
      );

      console.log(
        `[loadPresenzeUnificate] Statistiche: ${JSON.stringify(
          stats,
          null,
          2,
        )}`,
      );

      // Salva nella mappa per uso futuro (incluse le statistiche!)
      this.presenzeStudenteMap[idStudente] = {
        tutte: tuttePresenze,
        corsoCorrente: presenzeCorsoCorrente,
        corsiPrecedenti: presenzeCorsiPrecedenti,
        statistiche: stats, // 📊 AGGIUNTO: salva le statistiche
      };

      return {
        tuttePresenze,
        presenzeCorsoCorrente,
        presenzeCorsiPrecedenti,
        stats,
      };
    } catch (error) {
      console.error(
        `[loadPresenzeUnificate] ❌ Errore caricamento presenze per studente ${idStudente}:`,
        error,
      );
      return {
        tuttePresenze: [],
        presenzeCorsoCorrente: [],
        presenzeCorsiPrecedenti: [],
        stats: { assenzeCorrente: 0, assenzePrecedenti: 0, recuperi: 0 },
      };
    }
  }

  /**
   * 🆕 Calcola statistiche da array di presenze unificate
   *
   * Stati possibili per un'assenza:
   * 1. NON RECUPERATA: nessuna richiesta di recupero (id_richiesta_recupero = null)
   * 2. IN RICHIESTA: richiesta inviata ma non ancora completata (id_richiesta_recupero != null && id_lezione_recupero = null)
   * 3. RECUPERATA: recupero completato (id_lezione_recupero != null)
   */
  calcolaStatistichePresenze(presenze, idCorsoCorrente) {
    let assenzeCorrente = 0;
    let assenzePrecedenti = 0;
    let recuperiCompletati = 0;
    let richiesteInCorso = 0;

    presenze.forEach((p) => {
      // Determina il peso: 0.5 per mezze giornate, 1.0 per intere
      const peso =
        p.id_sessione &&
        p.id_sessione !== null &&
        p.id_sessione !== "" &&
        p.id_sessione !== "null"
          ? 0.5
          : 1.0;

      // Se è un'assenza
      if (p.presenza == -1) {
        // Verifica se è stata COMPLETAMENTE recuperata
        const isRecuperata =
          p.id_lezione_recupero &&
          p.id_lezione_recupero !== null &&
          p.id_lezione_recupero !== "" &&
          p.id_lezione_recupero !== 0;

        // Verifica se c'è una richiesta in corso (non ancora completata)
        const isInRichiesta =
          p.id_richiesta_recupero &&
          p.id_richiesta_recupero !== null &&
          p.id_richiesta_recupero !== 0 &&
          !isRecuperata;

        if (isRecuperata) {
          // Recupero completato - non conta come assenza
          recuperiCompletati += peso;
        } else {
          // Assenza (anche se in richiesta, conta come assenza fino al recupero effettivo)
          if (p.id_corso == idCorsoCorrente) {
            assenzeCorrente += peso;
          } else {
            assenzePrecedenti += peso;
          }

          // Se è in richiesta, la tracciamo separatamente
          if (isInRichiesta) {
            richiesteInCorso += peso;
          }
        }
      }
    });

    return {
      assenzeCorrente,
      assenzePrecedenti,
      assenzeTotali: assenzeCorrente + assenzePrecedenti,
      recuperiCompletati,
      richiesteInCorso,
      // Le assenze effettive sono quelle che non sono state recuperate
      // (assenze correnti + precedenti già escludono quelle recuperate, non serve sottrarre nulla)
      assenzeEffettive: assenzeCorrente + assenzePrecedenti,
    };
  }

  /**
   * 🆕 Costruisce l'array details dal formato unificato per il modal
   * Formato details richiesto dal modal:
   * [dataFormatted, argomento, stato, idRecupero, idLezione, idStudente, idSessione]
   */
  buildDetailsFromPresenzeUnificate(presenzeData, idStudente) {
    const details = [];

    // Ordina per data
    const presenzeSorted = [...presenzeData.tutte].sort((a, b) => {
      const dataA = new Date(a.data_lezione);
      const dataB = new Date(b.data_lezione);
      return dataA - dataB;
    });

    presenzeSorted.forEach((p) => {
      // Salta se è presente (presenza = 0 o 1)
      if (p.presenza != -1) {
        return;
      }

      // 🛡️ GUARD: salta record orfani (presenza che punta a una lezione
      // cancellata) — il backend fa LEFT JOIN lezioni quindi data_lezione
      // può essere NULL, causando crash su .replace()
      if (!p.data_lezione || typeof p.data_lezione !== "string") {
        console.warn(
          `[buildDetailsFromPresenzeUnificate] ⚠️ Presenza orfana ignorata (data_lezione mancante) per id_lezione=${p.id_lezione}, id_studente=${p.id_studente}`,
        );
        return;
      }

      // Formatta data
      let dataFormatted = "";
      let sessioneLabel = "";

      // Se è una lezione con sessione, usa l'orario della sessione specifica
      if (
        p.id_sessione &&
        this.sessioniMap &&
        this.sessioniMap[p.id_sessione]
      ) {
        const sessione = this.sessioniMap[p.id_sessione];
        const dataObj = new Date(p.data_lezione.replace(" ", "T"));
        const dataStr = dataObj.toLocaleDateString("it-IT", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });

        // Usa l'orario della sessione (rimuovi i secondi se presenti)
        const oraInizio = sessione.ora_inizio
          ? sessione.ora_inizio.substring(0, 5)
          : "";
        dataFormatted = `${dataStr} ${oraInizio}`;

        // Aggiungi label sessione
        const ordine = parseInt(p.sessione_ordine || sessione.ordine);
        sessioneLabel =
          ordine === 0 || ordine === 1 ? " (Prima metà)" : " (Seconda metà)";

        console.log(
          `[buildDetailsFromPresenzeUnificate] id_sessione=${p.id_sessione}, ora_inizio=${sessione.ora_inizio}, sessioneLabel=${sessioneLabel}`,
        );
      } else {
        // Lezione intera O sessione non in sessioniMap
        // Prova a usare sessione_ora_inizio se disponibile nei dati della presenza
        if (p.id_sessione && p.sessione_ora_inizio) {
          // Sessione con ora_inizio disponibile dalla query (es. corso precedente)
          const dataObj = new Date(p.data_lezione.replace(" ", "T"));
          const dataStr = dataObj.toLocaleDateString("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
          const oraInizio = p.sessione_ora_inizio.substring(0, 5);
          dataFormatted = `${dataStr} ${oraInizio}`;

          const ordine = parseInt(p.sessione_ordine);
          sessioneLabel =
            ordine === 0 || ordine === 1 ? " (Prima metà)" : " (Seconda metà)";
          console.log(
            `[buildDetailsFromPresenzeUnificate] Usando sessione_ora_inizio dalla presenza: ${oraInizio}, sessioneLabel=${sessioneLabel}`,
          );
        } else {
          // Lezione intera senza sessione: usa l'orario della lezione
          dataFormatted = new Date(
            p.data_lezione.replace(" ", "T"),
          ).toLocaleString("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });

          // Aggiungi indicatore mezza giornata se presente id_sessione ma manca ora_inizio
          if (
            p.id_sessione &&
            p.sessione_ordine !== undefined &&
            p.sessione_ordine !== null
          ) {
            const ordine = parseInt(p.sessione_ordine);
            sessioneLabel =
              ordine === 0 || ordine === 1
                ? " (Prima metà)"
                : " (Seconda metà)";
            console.log(
              `[buildDetailsFromPresenzeUnificate] ATTENZIONE: sessione senza ora_inizio, usando ordine da presenza: ${sessioneLabel}`,
            );
          }
        }
      }

      // Recupera nome della materia
      let nomeMateria = "";
      // Controlla se id_materia esiste ed è diverso da stringa vuota
      if (p.id_materia && p.id_materia.toString().trim() !== "") {
        const materia = this.state.materie?.find((m) => m.id == p.id_materia);
        nomeMateria = materia ? materia.materia : ""; // FIXED: campo si chiama 'materia', NON 'nome'
        console.log(
          `[buildDetailsFromPresenzeUnificate] p.id_materia=${p.id_materia}, nomeMateria=${nomeMateria}`,
        );
      } else {
        console.log(
          `[buildDetailsFromPresenzeUnificate] ATTENZIONE: p.id_materia mancante o vuoto per presenza (id_lezione=${p.id_lezione}, id_sessione=${p.id_sessione}):`,
          p,
        );
      }

      // Determina argomento/descrizione
      // Priorità: noteLezione → nome materia → nome corso (se precedente) → solo label sessione
      let argomento;
      if (p.argomento && p.argomento.trim() !== "") {
        argomento = p.argomento + sessioneLabel;
      } else if (nomeMateria && nomeMateria.trim() !== "") {
        // Fallback: usa il nome della materia (caso più comune, noteLezione è quasi sempre NULL)
        argomento = nomeMateria + sessioneLabel;
      } else if (p.id_corso != this.corso.id) {
        // Assenza da corso precedente senza materia: mostra nome corso
        argomento = `${p.nome_corso}${sessioneLabel}`;
      } else {
        argomento = sessioneLabel || "Lezione";
      }

      // Determina stato
      let stato;
      const isRecuperata =
        p.id_lezione_recupero &&
        p.id_lezione_recupero !== null &&
        p.id_lezione_recupero !== "" &&
        p.id_lezione_recupero !== 0;

      const isInRichiesta =
        p.id_richiesta_recupero &&
        p.id_richiesta_recupero !== null &&
        p.id_richiesta_recupero !== 0 &&
        !isRecuperata;

      if (isRecuperata) {
        stato = "RECUPERATA ✅";
      } else if (isInRichiesta) {
        stato = "ASSENTE 🔄 in richiesta recupero";
      } else {
        stato = "ASSENTE 🔄 recuperabile";
      }

      // ID recupero
      const idRecupero = p.id_richiesta_recupero || null;

      // ID lezione (aggiungi prefisso se corso precedente)
      const idLezione =
        p.id_corso != this.corso.id ? `prev_${p.id_lezione}` : p.id_lezione;

      // Costruisci array nel formato richiesto
      const nota = [
        dataFormatted, // 0: data formattata con orario sessione corretto
        argomento, // 1: argomento + sessioneLabel
        stato, // 2: stato
        idRecupero, // 3: id_richiesta_recupero
        idLezione, // 4: id_lezione
        idStudente, // 5: id_studente
        p.id_sessione || null, // 6: id_sessione
        nomeMateria || "", // 7: nome_materia
      ];

      console.log(
        `[buildDetailsFromPresenzeUnificate] Costruita nota con materia '${nomeMateria}' per lezione ${p.id_lezione}, sessione ${p.id_sessione}`,
      );

      details.push(nota);
    });

    console.log(
      `[buildDetailsFromPresenzeUnificate] Costruite ${details.length} righe details da ${presenzeData.tutte.length} presenze`,
    );
    return details;
  }

  async loadVotiEsami() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const corso = cookies.get("currentCourse", { path: "/" });
    let esamiData = await getEsamiValutazioni(username, token, corso);
    const esami = await getEsami(username, token, this.corso.id);

    if (esamiData && esamiData.length > 0) {
      esamiData = esamiData.map((esame) => {
        const transformedEsame = { ...esame };
        for (let key in transformedEsame) {
          if (transformedEsame[key] === -1) {
            transformedEsame[key] = "N/A";
          }
        }
        return transformedEsame;
      });

      const headCellsVotiEsami = [
        {
          id: "cognome",
          numeric: false,
          disablePadding: true,
          label: "Cognome",
        },
        { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      ];

      const esamiNomi = esami.map((esame, index) => ({
        id: esame.nome.replace(/\s+/g, "").toLowerCase(),
        numeric: true,
        disablePadding: false,
        label: esame.nome,
      }));

      this.setState({
        headCellsVotiEsami: headCellsVotiEsami.concat(esamiNomi),
        esami,
        loading: false,
      });
    } else {
      this.setState({ loading: false });
    }
    this.setState({ esami: esamiData });
  }

  async loadComponent() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });
    this.corso = await getCorso(username, token, currentCourse);
    this.lezioni = await getLezioni(username, token);
    this.rateCorso = await getRataStatusCorso(username, token, currentCourse);

    // Ottieni il piano generale del corso (fallback per studenti senza piano personalizzato)
    this.pianoPagamentiCorso = await getPianoPagamentiCorso(
      username,
      token,
      currentCourse,
    );

    this.studenti = await getStudenti(username, token, true); // include_disabled=true per mostrare studenti sospesi
    console.log(
      "[EditCorso] Studenti totali prima del filtro:",
      this.studenti.length,
    );
    console.log("[EditCorso] Corso corrente per filtro:", currentCourse);

    this.studenti = this.studenti.filter((s) => {
      if (!s.corsi) return false;

      // Gestisce diversi formati: singolo ID, con virgola, con punto e virgola
      const corsiList = s.corsi
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      // Converti currentCourse in stringa per il confronto
      const hasCorso = corsiList.includes(String(currentCourse));

      console.log(
        `[EditCorso] Studente ${s.nome} ${s.cognome} - corsi: "${s.corsi}" - corsiList:`,
        corsiList,
        "- hasCorso:",
        hasCorso,
      );
      return hasCorso;
    });

    console.log(
      "[EditCorso] Studenti filtrati per corso:",
      this.studenti.length,
    );

    // Formatta le date di nascita in formato DD/MM/YYYY
    this.studenti = this.studenti.map((studente) => ({
      ...studente,
      data_nascita: studente.data_nascita
        ? moment(studente.data_nascita).format("DD/MM/YYYY")
        : "",
    }));

    this.studenti = await Promise.all(
      this.studenti.map(async (studente) => {
        const rateForStudent = this.rateCorso.filter(
          (rate) => rate.id_studente === studente.id,
        );

        const today = new Date();
        const currentMonth = today.getMonth() + 1;
        const currentYear = today.getFullYear();

        let hasPaidCurrentMonth = false;
        let hasPaidPreviousMonth = false; // Calcolo delle rate pagate
        let ratePagate = 0;
        let totaleRate = 0;
        try {
          // Prova a ottenere il piano personalizzato dello studente
          let pianoStudente = await getPianoPagamentiCorsoStudenti(
            username,
            token,
            currentCourse,
            studente.id,
          );
          let ratePiano = null;

          // Se ha piano personalizzato, usalo
          if (pianoStudente && pianoStudente.rate) {
            ratePiano = pianoStudente.rate;
          }
          // Altrimenti, usa il piano generale del corso come fallback
          else if (this.pianoPagamentiCorso && this.pianoPagamentiCorso.rate) {
            ratePiano = this.pianoPagamentiCorso.rate;
          }

          // Se abbiamo un piano da utilizzare (personalizzato o generale)
          if (ratePiano) {
            totaleRate = ratePiano.length;

            const rateStatus = await getRataStatus(
              username,
              token,
              currentCourse,
              studente.id,
            );

            // Conta le rate pagate
            for (const r of rateStatus) {
              // Normalizza gli importi per il confronto (rimuove € e spazi, converte a numero)
              const importoRata = parseFloat(
                r.importo.toString().replace(/[€\s]/g, ""),
              );

              const rataCorrispondente = ratePiano.find((p) => {
                const importoPiano = parseFloat(
                  p.importo.toString().replace(/[€\s]/g, ""),
                );

                // Normalizzazione delle date per il confronto (stessa logica di loadRateUpdatedData)
                const normalizeDate = (dateStr) => {
                  if (!dateStr) return "";
                  let momentDate = moment(dateStr, "DD-MM-YYYY");
                  if (!momentDate.isValid()) {
                    momentDate = moment(dateStr, "DD-MMM-YYYY");
                  }
                  if (!momentDate.isValid()) {
                    momentDate = moment(dateStr);
                  }
                  return momentDate.isValid()
                    ? momentDate.format("DD-MM-YYYY")
                    : dateStr;
                };

                const dataMatch =
                  normalizeDate(p.data) === normalizeDate(r.data);
                const importoMatch =
                  Math.abs(importoPiano - importoRata) < 0.01; // tolleranza per differenze di arrotondamento

                console.log(
                  `[DEBUG] Confronto rata - Data: ${p.data} (${normalizeDate(
                    p.data,
                  )}) vs ${r.data} (${normalizeDate(
                    r.data,
                  )}) (${dataMatch}), Importo: ${importoPiano} vs ${importoRata} (${importoMatch}), Status: ${
                    r.status
                  }`,
                );

                return dataMatch && importoMatch;
              });

              if (!rataCorrispondente) {
                console.log(
                  `[DEBUG] Nessuna rata corrispondente trovata per data ${r.data} e importo ${importoRata}`,
                );
                continue;
              }
              if (r.status === "PAGATA") {
                ratePagate++;
                console.log(
                  `[DEBUG] Rata pagata trovata! Totale rate pagate: ${ratePagate}`,
                );
              }
            }

            console.log(
              `[DEBUG] Studente ${studente.nome} ${studente.cognome}: ${ratePagate}/${totaleRate} rate pagate`,
            );
          }
        } catch (error) {
          console.error(
            "Errore nel calcolo delle rate per studente",
            studente.id,
            error,
          );
        }

        // Gestione dello status quota basato su rateForStudent (sistema legacy)
        if (rateForStudent.length === 0) {
          studente.quote = "Da pagare";
        } else {
          rateForStudent.forEach((rate) => {
            const [day, month, year] = rate.data.split("-").map(Number);

            if (
              month === currentMonth &&
              year === currentYear &&
              rate.status === "PAGATA"
            ) {
              hasPaidCurrentMonth = true;
            }

            const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
            const previousYear =
              currentMonth === 1 ? currentYear - 1 : currentYear;

            if (
              month === previousMonth &&
              year === previousYear &&
              rate.status === "PAGATA"
            ) {
              hasPaidPreviousMonth = true;
            }
          });

          let statusQuota = "";
          if (hasPaidCurrentMonth) {
            statusQuota = "In regola";
          } else if (!hasPaidPreviousMonth) {
            statusQuota = "Non in regola";
          } else {
            statusQuota = "Da pagare";
          }
          studente.quote = statusQuota;
        }

        // Assegna sempre il rapporto delle rate pagate dal nuovo sistema
        if (totaleRate > 0) {
          studente.rate_pagate = `${ratePagate}/${totaleRate}`;
        } else {
          studente.rate_pagate = "N/A";
        }

        return studente;
      }),
    );

    this.studentiInattivi = this.studenti.filter((studente) => {
      if (!studente.corsi_ritiro) return false;

      // Gestisce diversi formati per i corsi di ritiro
      const corsiRitiroList = studente.corsi_ritiro
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      return corsiRitiroList.includes(String(currentCourse));
    });

    this.studentiAttivi = this.studenti.filter((s) => {
      if (!s.corsi_ritiro) return true;

      // Gestisce diversi formati per i corsi di ritiro
      const corsiRitiroList = s.corsi_ritiro
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      return !corsiRitiroList.includes(String(currentCourse));
    });
    this.lezioniSvolte = await getLezioniSvolte(username, token, currentCourse);
    this.chiusura = await getChiusura(username, token);

    // Filtra le lezioni svolte per escludere le scadenze di pagamento
    this.lezioniSvolteEffettive = this.lezioniSvolte.filter((lezione) => {
      const pagamentoQuota =
        lezione.pagamento_quota === "1" || lezione.pagamento_quota === 1;
      if (!pagamentoQuota) return true; // Se non è pagamento quota, mantieni

      // Se è pagamento quota, verifica se è in un periodo di chiusura
      const isInChiusura = this.chiusura.some((c) => {
        const dataChiusura = moment(c.day, "DD-MM-YYYY");
        const lezioneDate = moment(lezione.data, "YYYY-MM-DD HH:mm:ss");
        return (
          lezioneDate.format("YYYY-MM-DD") === dataChiusura.format("YYYY-MM-DD")
        );
      });

      // Mantieni solo se NON è una scadenza (non è pagamento quota in chiusura)
      return !isInChiusura;
    });

    try {
      this.presenzeCorso = await getPresenzeCorso(
        username,
        token,
        currentCourse,
      );
      console.log(
        "[getPresenzeCorso] Campioni di presenze ricevute:",
        this.presenzeCorso.slice(0, 5),
      );
    } catch (error) {
      console.error(
        "[EditCorso] Errore critico nel caricamento delle presenze del corso:",
        error,
      );
      alert(`Errore nel caricamento delle presenze del corso. 
      
Si prega di verificare i log della console (F12) e contattare il supporto tecnico.

Dettagli errore: ${error.message}`);
      // Inizializza array vuoto per evitare errori successivi
      this.presenzeCorso = [];
      this.presenzeCorsoEffettive = [];
      return; // Interrompe il caricamento
    }

    // Crea una lista degli ID delle lezioni effettive (escluse quelle di pagamento quota)
    const lezioniEffettiveIds = new Set(
      this.lezioniSvolteEffettive.map((l) => l.id),
    );

    // Filtra le presenze per includere solo quelle delle lezioni effettive
    this.presenzeCorsoEffettive = this.presenzeCorso.filter((presenza) =>
      lezioniEffettiveIds.has(presenza.id_lezione),
    );

    console.log(
      "[DEBUG] Filtro presenze - Totali:",
      this.presenzeCorso.length,
      "| Effettive:",
      this.presenzeCorsoEffettive.length,
    );
    console.log(
      "[DEBUG] Campioni di presenze effettive:",
      this.presenzeCorsoEffettive.slice(0, 5),
    );

    // Carica le sessioni per tutte le lezioni con presenze divise
    console.log("[loadSessioni] Caricamento sessioni per le lezioni...");
    this.sessioniMap = {}; // Mappa id_sessione -> oggetto sessione

    const lezioniConSessioni = new Set(
      this.presenzeCorsoEffettive
        .filter(
          (p) =>
            p.id_sessione && p.id_sessione !== null && p.id_sessione !== "null",
        )
        .map((p) => p.id_lezione),
    );

    console.log(
      `[loadSessioni] Lezioni con sessioni: ${lezioniConSessioni.size}`,
    );

    for (const idLezione of lezioniConSessioni) {
      try {
        const sessioni = await getSessioniLezione(username, token, idLezione);
        sessioni.forEach((sessione) => {
          this.sessioniMap[sessione.id] = sessione;
        });
        console.log(
          `[loadSessioni] Lezione ${idLezione}: ${sessioni.length} sessioni caricate`,
        );
      } catch (error) {
        console.error(
          `[loadSessioni] Errore caricamento sessioni lezione ${idLezione}:`,
          error,
        );
      }
    }

    console.log(
      `[loadSessioni] Totale sessioni caricate: ${
        Object.keys(this.sessioniMap).length
      }`,
    );

    this.valutazioni = await getValutazioniCorso(
      username,
      token,
      this.corso.id,
    );
    this.categorieCorsi = await getCategorieCorsi(username, token);

    // Carica le materie per risolvere i nomi nei dettagli presenza
    try {
      const materie = await getMaterie(username, token);
      this.setState({ materie: materie || [] });
      console.log(`[EditCorso] Materie caricate: ${materie?.length || 0}`);
    } catch (e) {
      console.error("[EditCorso] Errore caricamento materie:", e);
      this.setState({ materie: [] });
    }
    this.dispense = await getDispense(username, token, this.corso.id);
    this.compiti = await getCompiti(username, token, this.corso.id);
    this.esamiVotazioni = await getEsamiValutazioni(
      username,
      token,
      this.corso.id,
    );

    const categoria = this.categorieCorsi.find(
      (c) => c.id == this.corso.id_categoria,
    );
    const selectedCategoriaCorso = categoria
      ? { value: categoria.id, label: categoria.name }
      : null;

    await this.loadEsami();

    await this.loadCompiti();

    await this.loadVotiEsami();

    await this.loadDispense();

    await this.loadVotiPrecedenti();

    await this.loadVotiUnificati(); // Carica i voti unificati

    await this.loadAssenzePrecedenti();

    // Carica le informazioni di recupero COMPLETATO per tutti gli studenti
    // Mappa per tenere traccia delle lezioni effettivamente recuperate (completate)
    this.lezioniRecuperateMap = {};

    console.log(
      `[DEBUG GET RECUPERI - NUOVO METODO] Caricamento recuperi individuale per ogni assenza`,
    );

    // Per ogni assenza con id_recupero_lezioni, verifica se è stata effettivamente recuperata
    const assenzeConIdRecupero = this.presenzeCorso.filter(
      (p) =>
        p.presenza == -1 &&
        p.id_recupero_lezioni !== null &&
        p.id_recupero_lezioni !== "" &&
        p.id_recupero_lezioni !== undefined,
    );

    console.log(
      `[DEBUG ASSENZE CON RECUPERO] Trovate ${assenzeConIdRecupero.length} assenze con ID recupero`,
    );
    if (assenzeConIdRecupero.length > 0) {
      console.log(
        `[DEBUG ASSENZE CON RECUPERO] IDs recupero cercati:`,
        assenzeConIdRecupero.map((p) => ({
          studente: p.id_studente,
          id_recupero: p.id_recupero_lezioni,
        })),
      );
    }

    // Per ogni assenza con id_recupero_lezioni, carica il recupero specifico
    for (const presenza of assenzeConIdRecupero) {
      try {
        console.log(
          `[DEBUG RECUPERO INDIVIDUALE] Caricamento recupero ID ${presenza.id_recupero_lezioni} per studente ${presenza.id_studente}`,
        );

        const recuperoData = await getLezioneRecuperata(
          username,
          token,
          presenza.id_recupero_lezioni,
        );

        console.log(
          `[DEBUG RECUPERO INDIVIDUALE] Risposta per ID ${presenza.id_recupero_lezioni}:`,
          recuperoData,
        );

        // Verifica se il recupero è completato controllando se ha id_lezione_recupero
        const idLezioneRecupero =
          recuperoData?.id_lezione_recupero ||
          recuperoData?.id_recupero ||
          recuperoData?.idLezioneRecupero ||
          recuperoData?.idRecupero;

        if (idLezioneRecupero) {
          // Determina il peso del recupero: 0.5 per sessione, 1.0 per giornata intera
          const hasSessione =
            presenza.id_sessione &&
            presenza.id_sessione !== null &&
            presenza.id_sessione !== "null" &&
            presenza.id_sessione !== "";
          const pesoRecupero = hasSessione ? 0.5 : 1.0;

          console.log(
            `[DEBUG RECUPERO INDIVIDUALE] ✓ Recupero ID ${presenza.id_recupero_lezioni} COMPLETATO - id_lezione_recupero=${idLezioneRecupero}, id_sessione=${presenza.id_sessione}, peso=${pesoRecupero}`,
          );

          if (!this.lezioniRecuperateMap[presenza.id_studente]) {
            this.lezioniRecuperateMap[presenza.id_studente] = pesoRecupero;
          } else {
            this.lezioniRecuperateMap[presenza.id_studente] += pesoRecupero;
          }
        } else {
          console.log(
            `[DEBUG RECUPERO INDIVIDUALE] ✗ Recupero ID ${presenza.id_recupero_lezioni} NON completato - manca id_lezione_recupero`,
          );
          console.log(
            `[DEBUG RECUPERO INDIVIDUALE] Campi disponibili:`,
            recuperoData ? Object.keys(recuperoData) : "nessuno",
          );
        }
      } catch (error) {
        console.error(
          `[DEBUG RECUPERO INDIVIDUALE] ❌ Errore caricando recupero ID ${presenza.id_recupero_lezioni}:`,
          error,
        );
      }
    }

    console.log(
      `[DEBUG RECUPERI] Recuperi effettivamente completati per studente (corso corrente):`,
      this.lezioniRecuperateMap,
    );

    // ✅ NUOVO: Aggiungi anche i recuperi completati delle assenze precedenti
    // Usa i recuperi già caricati da loadAssenzePrecedenti invece di richiamare getRecuperi
    console.log(
      `[DEBUG RECUPERI PRECEDENTI] Inizio elaborazione recuperi precedenti da recuperiPrecedentiMap`,
    );

    // Per ogni studente con recuperi precedenti
    for (const idStudente of Object.keys(this.recuperiPrecedentiMap || {})) {
      const recuperiPrecedenti = this.recuperiPrecedentiMap[idStudente] || [];

      if (recuperiPrecedenti.length === 0) continue;

      console.log(
        `[DEBUG RECUPERI PRECEDENTI] Processando studente ${idStudente}, ${recuperiPrecedenti.length} recuperi precedenti caricati`,
      );

      // Per ogni recupero precedente, aggiungi al contatore se completato
      for (const recupero of recuperiPrecedenti) {
        // Verifica se il recupero è COMPLETATO
        const isCompletato =
          recupero.status === "COMPLETATO" &&
          recupero.id_lezione_recupero !== null &&
          recupero.id_lezione_recupero !== undefined &&
          recupero.id_lezione_recupero !== "" &&
          recupero.id_lezione_recupero !== "0";

        if (isCompletato) {
          // Determina il peso del recupero
          const hasSessione =
            recupero.id_sessione_assenza &&
            recupero.id_sessione_assenza !== null &&
            recupero.id_sessione_assenza !== "null" &&
            recupero.id_sessione_assenza !== "";
          const pesoRecupero = hasSessione ? 0.5 : 1.0;

          console.log(
            `[DEBUG RECUPERI PRECEDENTI] ✓ Recupero COMPLETATO lezione ${recupero.id_assenza_originale} sessione ${recupero.id_sessione_assenza} - peso=${pesoRecupero}, corso=${recupero.nome_corso_origine}`,
          );

          if (!this.lezioniRecuperateMap[idStudente]) {
            this.lezioniRecuperateMap[idStudente] = pesoRecupero;
          } else {
            this.lezioniRecuperateMap[idStudente] += pesoRecupero;
          }
        } else {
          console.log(
            `[DEBUG RECUPERI PRECEDENTI] ⏳ Recupero ${recupero.status} lezione ${recupero.id_assenza_originale} - non conta come completato`,
          );
        }
      }
    }

    console.log(
      `[DEBUG RECUPERI] Recuperi effettivamente completati per studente (corso corrente + precedenti):`,
      this.lezioniRecuperateMap,
    );

    // 🆕 CARICA TUTTE LE PRESENZE UNIFICATE PER TUTTI GLI STUDENTI
    // Questo permetterà di avere i contatori corretti già al caricamento della pagina
    console.log(
      "[EditCorso] 🔄 Caricamento presenze unificate per tutti gli studenti...",
    );
    const tuttePresenzeUnificate = await getAllPresenzeStudenti(
      username,
      token,
      currentCourse,
    );

    // Processa i dati e salva nella mappa presenzeStudenteMap
    for (const [idStudente, presenzeArray] of Object.entries(
      tuttePresenzeUnificate,
    )) {
      // Separa per corso
      const corsoCorrente = presenzeArray.filter(
        (p) => p.id_corso == currentCourse,
      );
      const corsiPrecedenti = presenzeArray.filter(
        (p) => p.id_corso != currentCourse,
      );

      // Calcola statistiche
      const stats = this.calcolaStatistichePresenze(
        presenzeArray,
        currentCourse,
      );

      // Salva nella mappa
      this.presenzeStudenteMap[idStudente] = {
        tutte: presenzeArray,
        corsoCorrente: corsoCorrente,
        corsiPrecedenti: corsiPrecedenti,
        statistiche: stats,
      };

      // ✅ FIX: Aggiorna assenzePrecedentiMap SOLO se non è stato esplicitamente azzerato
      // dal controllo del flag mantieni_assenze (rispetta il flag già processato da loadAssenzePrecedenti)
      // Se assenzePrecedentiMap è undefined o maggiore di 0, allora può essere aggiornato
      // Se è esattamente 0, significa che è stato azzerato per mantieni_assenze=0, non sovrascrivere!
      const esisteEAzzerato =
        this.assenzePrecedentiMap &&
        this.assenzePrecedentiMap.hasOwnProperty(idStudente) &&
        this.assenzePrecedentiMap[idStudente] === 0;

      if (stats.assenzePrecedenti > 0 && !esisteEAzzerato) {
        this.assenzePrecedentiMap[idStudente] = stats.assenzePrecedenti;
      } else if (esisteEAzzerato) {
        console.log(
          `[EditCorso] ⚠️ Studente ${idStudente}: assenze precedenti GIÀ AZZERATE da mantieni_assenze=0, mantengo a 0 (ignoro ${stats.assenzePrecedenti} da API)`,
        );
        // Forza anche le statistiche a 0 per coerenza
        stats.assenzePrecedenti = 0;
        stats.assenzeEffettive = Math.max(
          0,
          stats.assenzeCorrente - stats.recuperiCompletati,
        );
      }

      console.log(
        `[EditCorso] ✓ Studente ${idStudente}: ${stats.assenzeEffettive} assenze effettive (${stats.assenzeCorrente} correnti + ${stats.assenzePrecedenti} precedenti - ${stats.recuperiCompletati} recuperate)`,
      );
    }
    console.log(
      "[EditCorso] ✅ Presenze unificate caricate per",
      Object.keys(tuttePresenzeUnificate).length,
      "studenti",
    );

    this.studentiAttivi.forEach((studente, index) => {
      // --- Calcolo della % di assenze ---
      // Presenze attuali per lo studente:
      const presenze = this.presenzeCorsoEffettive.filter(
        (p) => p.id_studente == studente.id && p.presenza == 1,
      );

      // NUOVA LOGICA: conta TUTTE le assenze dello studente nel corso
      // Filtra direttamente da this.presenzeCorso (dati grezzi completi)
      // INCLUDE sia lezioni passate che future
      const oggi = moment();

      console.log(
        `[DEBUG FILTRO ASSENZE] Studente ${studente.nome} ${studente.cognome} (ID: ${studente.id})`,
      );
      console.log(
        `[DEBUG FILTRO ASSENZE] Data corrente (oggi): ${oggi.format(
          "YYYY-MM-DD HH:mm:ss",
        )}`,
      );
      console.log(
        `[DEBUG FILTRO ASSENZE] presenzeCorso totali: ${this.presenzeCorso.length}`,
      );
      console.log(
        `[DEBUG FILTRO ASSENZE] lezioniSvolteEffettive: ${this.lezioniSvolteEffettive.length}`,
      );

      // Conta tutte le assenze dello studente (presenza == -1 o presenza == 0)
      // SENZA filtro sulla data - include sia lezioni passate che future
      const assenzeStudente = this.presenzeCorso.filter((p) => {
        // Solo questo studente
        if (p.id_studente != studente.id) return false;

        // Solo assenze (presenza == -1 o presenza == 0)
        if (p.presenza != -1 && p.presenza != 0) return false;

        // Trova la lezione corrispondente per verificare che esista
        const lezione = this.lezioniSvolteEffettive.find(
          (l) => l.id == p.id_lezione,
        );
        if (!lezione) {
          console.log(
            `[DEBUG FILTRO ASSENZE] Lezione ${p.id_lezione} non trovata in lezioniSvolteEffettive`,
          );
          return false;
        }

        // RIMOSSO IL FILTRO SULLA DATA - conta tutte le assenze (passate e future)
        return true;
      });

      console.log(
        `[DEBUG FILTRO ASSENZE] Assenze trovate per studente: ${assenzeStudente.length}`,
      );
      if (assenzeStudente.length > 0) {
        console.log(
          `[DEBUG FILTRO ASSENZE] Dettagli assenze:`,
          assenzeStudente.map((a) => ({
            id_lezione: a.id_lezione,
            id_sessione: a.id_sessione,
            presenza: a.presenza,
          })),
        );
      }

      // Calcola il peso delle assenze: 0.5 per sessioni, 1.0 per lezioni intere
      const assenzeContatePerModal = assenzeStudente.reduce((sum, p) => {
        // Gestisce sia null che stringhe "null" o undefined
        const hasSessione =
          p.id_sessione &&
          p.id_sessione !== null &&
          p.id_sessione !== "null" &&
          p.id_sessione !== "";
        const peso = hasSessione ? 0.5 : 1.0;

        console.log(
          `[DEBUG Peso] Studente ${studente.nome} ${
            studente.cognome
          }, Presenza ID ${p.id}: id_lezione=${p.id_lezione}, id_sessione="${
            p.id_sessione
          }", tipo="${typeof p.id_sessione}", hasSessione=${hasSessione}, peso=${peso}, TOTALE PARZIALE=${sum +
            peso}`,
        );

        return sum + peso;
      }, 0);

      // Log finale per vedere il totale
      if (assenzeStudente.length > 0) {
        console.log(
          `[DEBUG Totale] Studente ${studente.nome} ${studente.cognome}: ${assenzeStudente.length} record di assenza, peso totale=${assenzeContatePerModal}`,
        );
      }

      // Recuperi EFFETTIVAMENTE COMPLETATI per lo studente (con lezione di recupero assegnata)
      const recuperiCompletati = this.lezioniRecuperateMap[studente.id] || 0;

      // ✅ FIX: NON sottrarre qui i recuperi completati!
      // Le assenze vanno sottratte SOLO alla fine nel calcolo di finalAbsences
      // Altrimenti vengono sottratte due volte causando un conteggio errato
      const currentAbsences = assenzeContatePerModal;

      // Il denominatore è sempre il numero totale di lezioni programmate (esclusi pagamenti quota)
      const totalRealLessons = this.lezioniSvolteEffettive.length;

      // Recupera le assenze precedenti dalla mappa (se esistono)
      const previousAbsences =
        this.assenzePrecedentiMap && this.assenzePrecedentiMap[studente.id]
          ? this.assenzePrecedentiMap[studente.id]
          : 0;
      // Totale assenze = assenze correnti + assenze precedenti
      const totalAbsences = currentAbsences + previousAbsences;
      // ✅ FIX: Il denominatore è SOLO le lezioni del corso ATTUALE, non sommare le assenze precedenti!
      // Es: 3 assenze precedenti + 10 lezioni attuali = 3/10 (NON 3/13)
      const totalLessons = totalRealLessons;

      // SCORCIATOIA: Se le assenze sono pari al totale delle lezioni, resetta a 0
      // Significa che sono tutti record auto-generati, non assenze reali
      // IMPORTANTE: NON resettare se ci sono presenze con id_sessione (lezioni divise realmente assenti)

      // Dato che ora contiamo anche le assenze future, usiamo il totale di tutte le lezioni
      const lezioniTotali = this.lezioniSvolteEffettive.length;

      // Verifica se ci sono assenze reali con sessioni (lezioni divise)
      const hasAssenzeConSessioni = assenzeStudente.some((p) => {
        const hasSessione =
          p.id_sessione &&
          p.id_sessione !== null &&
          p.id_sessione !== "null" &&
          p.id_sessione !== "";

        console.log(
          `[DEBUG hasAssenzeConSessioni] Studente ${studente.nome} ${studente.cognome}, Presenza ID ${p.id}: id_sessione="${p.id_sessione}", hasSessione=${hasSessione}`,
        );

        return hasSessione;
      });

      const sogliaSospetta = Math.floor(lezioniTotali * 0.5); // 50% delle lezioni totali

      console.log(
        `[DEBUG RESET LOGIC] Studente ${studente.nome} ${studente.cognome}:`,
        {
          currentAbsences,
          previousAbsences,
          totalAbsences,
          totalLessons,
          hasAssenzeConSessioni,
          presenze_length: presenze.length,
          sogliaSospetta,
          "currentAbsences >= totalLessons": currentAbsences >= totalLessons,
          "presenze.length === 0": presenze.length === 0,
          "currentAbsences > sogliaSospetta": currentAbsences > sogliaSospetta,
        },
      );

      // ✅ FIX: Non resettare a 0 se ci sono assenze precedenti (sono legittime!)
      // Il reset serve solo per eliminare assenze auto-generate del corso ATTUALE
      // ✅ NUOVO FIX: Sottrai i recuperi completati dalle assenze totali
      let finalAbsences =
        previousAbsences > 0
          ? totalAbsences // Se ci sono assenze precedenti, mantienile sempre
          : (currentAbsences >= totalLessons && !hasAssenzeConSessioni) ||
            (presenze.length === 0 &&
              currentAbsences > sogliaSospetta &&
              !hasAssenzeConSessioni)
          ? 0
          : totalAbsences;

      // Sottrai i recuperi completati (non può andare sotto zero)
      finalAbsences = Math.max(0, finalAbsences - recuperiCompletati);

      // Debug FORZATO per assenze precedenti
      if (previousAbsences > 0) {
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] Studente: ${studente.nome} ${studente.cognome}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Assenze contate corso attuale: ${assenzeContatePerModal}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Current absences: ${currentAbsences}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Previous absences: ${previousAbsences}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Total absences: ${totalAbsences}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Recuperi completati: ${recuperiCompletati}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Final absences: ${finalAbsences}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Total lessons: ${totalLessons}`,
        );
        console.log(
          `[DEBUG ASSENZE PRECEDENTI] - Risultato: ${finalAbsences}/${totalLessons}`,
        );
      }

      // Debug per tutti gli studenti con assenze
      if (
        currentAbsences > 0 ||
        assenzeContatePerModal > 0 ||
        finalAbsences != totalAbsences
      ) {
        console.log(`[DEBUG] Studente: ${studente.nome} ${studente.cognome}`);
        console.log(`[DEBUG] - Presenze: ${presenze.length}`);
        console.log(
          `[DEBUG] - Assenze contate (stile modal): ${assenzeContatePerModal}`,
        );
        console.log(`[DEBUG] - Lezioni totali: ${lezioniTotali}`);
        console.log(`[DEBUG] - Soglia sospetta (50%): ${sogliaSospetta}`);
        console.log(`[DEBUG] - Recuperi completati: ${recuperiCompletati}`);
        console.log(`[DEBUG] - Current absences: ${currentAbsences}`);
        console.log(`[DEBUG] - Total real lessons: ${totalRealLessons}`);
        console.log(`[DEBUG] - Previous absences: ${previousAbsences}`);
        console.log(`[DEBUG] - Assenze totali calcolate: ${totalAbsences}`);
        console.log(`[DEBUG] - Assenze finali (dopo reset): ${finalAbsences}`);
        console.log(`[DEBUG] - Risultato: ${finalAbsences}/${totalLessons}`);
      }

      // Formatta con decimali se necessario
      const finalAbsencesFormatted = Number.isInteger(finalAbsences)
        ? finalAbsences
        : finalAbsences.toFixed(1);

      // 🆕 USA I DATI UNIFICATI SE DISPONIBILI (più accurati perché includono assenze cross-corso)
      // Altrimenti usa il calcolo vecchio come fallback
      if (this.presenzeStudenteMap && this.presenzeStudenteMap[studente.id]) {
        const stats = this.presenzeStudenteMap[studente.id].statistiche;
        this.studentiAttivi[
          index
        ].frequencyPercent = `${stats.assenzeEffettive}/${totalLessons}`;
        console.log(
          `[CALC frequencyPercent UNIFICATO] ${studente.nome} ${studente.cognome}: ${stats.assenzeEffettive}/${totalLessons} (${stats.assenzeCorrente} correnti + ${stats.assenzePrecedenti} precedenti - ${stats.recuperiCompletati} recuperate)`,
        );
      } else {
        // Fallback al calcolo vecchio
        this.studentiAttivi[
          index
        ].frequencyPercent = `${finalAbsencesFormatted}/${totalLessons}`;
        console.log(
          `[CALC frequencyPercent VECCHIO] ${studente.nome} ${studente.cognome}: ${finalAbsencesFormatted}/${totalLessons}`,
        );
      }

      // --- Calcolo della media degli esami (voti) ---
      // Voti attuali
      const currentExams = this.valutazioni.filter(
        (e) => e.id_studente == studente.id && e.valutazione != -1,
      );
      let currentSum = 0;
      currentExams.forEach((e) => {
        currentSum += parseFloat(e.valutazione);
      });
      const currentCount = currentExams.length;

      // Voti dei corsi precedenti (ricavati da this.state.votiPrecedenti)
      // MA escludiamo quelli già contati nei voti attuali (trasferiti)
      const prevRecord = this.state.votiPrecedenti.find(
        (item) => item.id_studente == studente.id,
      );

      // Creiamo un Set con i nomi degli esami già contati nelle valutazioni attuali
      // Dobbiamo recuperare il nome dall'id_esame usando this.esami
      const esamiGiaContati = new Set();
      currentExams.forEach((valutazione) => {
        // Trova l'esame corrispondente usando id_esame
        const esame = this.esami.find((ex) => ex.id === valutazione.id_esame);
        if (esame && esame.nome) {
          const nomeNormalizzato = esame.nome.replace(/\s+/g, "").toLowerCase();
          esamiGiaContati.add(nomeNormalizzato);
        }
      });

      let prevSum = 0;
      let prevCount = 0;
      const votiPrecedentiValidi = []; // Per debug
      if (prevRecord) {
        console.log(
          `[DEBUG MEDIA] Studente ${studente.nome} ${studente.cognome} (ID: ${studente.id})`,
        );
        console.log(`[DEBUG MEDIA] prevRecord completo:`, prevRecord);
        console.log(
          `[DEBUG MEDIA] Esami già contati nei voti attuali:`,
          Array.from(esamiGiaContati),
        );

        // Escludiamo le proprietà fisse (id_studente, nome, cognome, _esamiOriginali)
        for (let key in prevRecord) {
          if (
            ["id_studente", "nome", "cognome", "_esamiOriginali"].includes(key)
          )
            continue;

          // Verifica se questo esame è già stato contato nei voti attuali
          const keyNormalizzata = key.replace(/\s+/g, "").toLowerCase();
          if (esamiGiaContati.has(keyNormalizzata)) {
            console.log(
              `[DEBUG MEDIA] Esame ${key} SALTATO (già nei voti attuali)`,
            );
            continue;
          }

          if (prevRecord[key] !== undefined && prevRecord[key] !== null) {
            const voto = parseFloat(prevRecord[key]);
            console.log(
              `[DEBUG MEDIA] Chiave: ${key}, Valore: ${
                prevRecord[key]
              }, parseFloat: ${voto}, isNaN: ${isNaN(voto)}`,
            );
            // Verifica che sia un numero valido e >= 0
            if (!isNaN(voto) && voto >= 0) {
              prevSum += voto;
              prevCount++;
              votiPrecedentiValidi.push(`${key}=${voto}`);
            }
          }
        }
        console.log(
          `[DEBUG MEDIA] Voti precedenti validi (NON duplicati): ${votiPrecedentiValidi.join(
            ", ",
          )}`,
        );
        console.log(
          `[DEBUG MEDIA] Somma voti precedenti: ${prevSum}, Count: ${prevCount}`,
        );
      }

      console.log(
        `[DEBUG MEDIA] Voti attuali: somma=${currentSum}, count=${currentCount}`,
      );
      console.log(
        `[DEBUG MEDIA] Voti precedenti (esclusi duplicati): somma=${prevSum}, count=${prevCount}`,
      );

      const totalCount = currentCount + prevCount;
      const totalSum = currentSum + prevSum;
      const overallAverage =
        totalCount > 0 ? (totalSum / totalCount).toFixed(2) : "N/A";

      console.log(
        `[DEBUG MEDIA] TOTALE: somma=${totalSum}, count=${totalCount}, media=${overallAverage}`,
      );

      this.studentiAttivi[index].mediaEsami = overallAverage;
    }); // Aggiorno anche gli studenti inattivi con le rate pagate
    this.studentiInattivi = await Promise.all(
      this.studentiInattivi.map(async (studente) => {
        // Calcolo delle rate pagate anche per studenti inattivi
        let ratePagate = 0;
        let totaleRate = 0;
        try {
          // Prova a ottenere il piano personalizzato dello studente
          let pianoStudente = await getPianoPagamentiCorsoStudenti(
            username,
            token,
            currentCourse,
            studente.id,
          );
          let ratePiano = null;

          // Se ha piano personalizzato, usalo
          if (pianoStudente && pianoStudente.rate) {
            ratePiano = pianoStudente.rate;
          }
          // Altrimenti, usa il piano generale del corso come fallback
          else if (this.pianoPagamentiCorso && this.pianoPagamentiCorso.rate) {
            ratePiano = this.pianoPagamentiCorso.rate;
          }

          // Se abbiamo un piano da utilizzare (personalizzato o generale)
          if (ratePiano) {
            totaleRate = ratePiano.length;
            const rateStatus = await getRataStatus(
              username,
              token,
              currentCourse,
              studente.id,
            );

            // Conta le rate pagate per studenti inattivi (usando la stessa logica di loadRateUpdatedData)
            for (const r of rateStatus) {
              // Normalizza gli importi per il confronto (rimuove € e spazi, converte a numero)
              const importoRata = parseFloat(
                r.importo.toString().replace(/[€\s]/g, ""),
              );

              const rataCorrispondente = ratePiano.find((p) => {
                const importoPiano = parseFloat(
                  p.importo.toString().replace(/[€\s]/g, ""),
                );

                // Normalizzazione delle date per il confronto
                const normalizeDate = (dateStr) => {
                  if (!dateStr) return "";
                  let momentDate = moment(dateStr, "DD-MM-YYYY");
                  if (!momentDate.isValid()) {
                    momentDate = moment(dateStr, "DD-MMM-YYYY");
                  }
                  if (!momentDate.isValid()) {
                    momentDate = moment(dateStr);
                  }
                  return momentDate.isValid()
                    ? momentDate.format("DD-MM-YYYY")
                    : dateStr;
                };

                const dataMatch =
                  normalizeDate(p.data) === normalizeDate(r.data);
                const importoMatch =
                  Math.abs(importoPiano - importoRata) < 0.01; // tolleranza per differenze di arrotondamento

                return dataMatch && importoMatch;
              });

              if (rataCorrispondente && r.status === "PAGATA") {
                ratePagate++;
              }
            }
          }
        } catch (error) {
          console.error(
            "Errore nel calcolo delle rate per studente inattivo",
            studente.id,
            error,
          );
        } // Aggiorna solo lo status quote (senza il rapporto delle rate)
        const originalQuote = studente.quote || "Ritirato";
        studente.quote = originalQuote;

        // Assegna il rapporto delle rate alla nuova colonna
        if (totaleRate > 0) {
          studente.rate_pagate = `${ratePagate}/${totaleRate}`;
        } else {
          studente.rate_pagate = "N/A";
        }

        return studente;
      }),
    );

    this.studentiInattivi.forEach((studente, index) => {
      var presenze = this.presenzeCorso.filter(
        (p) => p.id_studente == studente.id && p.presenza == 1,
      );
      var numeroOreTotali = 0;
      var numeroOreSvolte = 0;
      this.lezioniSvolteEffettive.forEach(
        (p) => (numeroOreTotali += p.durata / 60),
      );

      this.lezioniSvolteEffettive.forEach((l) => {
        var presenze = this.presenzeCorso.filter(
          (p) =>
            p.id_studente == studente.id &&
            p.presenza == 1 &&
            p.id_lezione == l.id,
        );
        numeroOreSvolte +=
          presenze[0] == undefined
            ? 0
            : presenze[0].ore != "" &&
              isNaN(parseFloat(presenze[0].ore)) == false
            ? parseFloat(presenze[0].ore)
            : l.durata / 60;
      });

      var esamiStudente = this.valutazioni.filter(
        (e) => e.id_studente == studente.id && e.valutazione != -1,
      );
      var sommatoriaVoti = 0;
      esamiStudente.forEach(
        (e) => (sommatoriaVoti += parseFloat(e.valutazione)),
      );

      // Calcolo assenze per studenti inattivi (stesso sistema degli attivi)
      // Conta TUTTE le assenze dello studente direttamente da presenzeCorso
      // INCLUDE sia lezioni passate che future
      const oggi = moment();

      const assenzeStudente = this.presenzeCorso.filter((p) => {
        if (p.id_studente != studente.id) return false;
        if (p.presenza != -1 && p.presenza != 0) return false;

        const lezione = this.lezioniSvolteEffettive.find(
          (l) => l.id == p.id_lezione,
        );
        if (!lezione) return false;

        // RIMOSSO IL FILTRO SULLA DATA - conta tutte le assenze (passate e future)
        return true;
      });

      // Calcola il peso delle assenze: 0.5 per sessioni, 1.0 per lezioni intere
      const assenzeContatePerModal = assenzeStudente.reduce((sum, p) => {
        // Gestisce sia null che stringhe "null" o undefined
        const hasSessione =
          p.id_sessione &&
          p.id_sessione !== null &&
          p.id_sessione !== "null" &&
          p.id_sessione !== "";
        const peso = hasSessione ? 0.5 : 1.0;

        console.log(
          `[DEBUG Peso INATTIVI] Studente ${studente.nome} ${
            studente.cognome
          }, Presenza ID ${p.id}: id_lezione=${p.id_lezione}, id_sessione="${
            p.id_sessione
          }", hasSessione=${hasSessione}, peso=${peso}, TOTALE PARZIALE=${sum +
            peso}`,
        );

        return sum + peso;
      }, 0);

      // Log finale per vedere il totale
      if (assenzeStudente.length > 0) {
        console.log(
          `[DEBUG Totale INATTIVI] Studente ${studente.nome} ${studente.cognome}: ${assenzeStudente.length} record di assenza, peso totale=${assenzeContatePerModal}`,
        );
      }

      const recuperiCompletati = this.lezioniRecuperateMap[studente.id] || 0;
      const currentAbsences = Math.max(
        0,
        assenzeContatePerModal - recuperiCompletati,
      );
      const totalRealLessons = this.lezioniSvolteEffettive.length;
      const previousAbsences =
        this.assenzePrecedentiMap && this.assenzePrecedentiMap[studente.id]
          ? this.assenzePrecedentiMap[studente.id]
          : 0;
      const totalAbsences = currentAbsences + previousAbsences;
      const totalLessons = totalRealLessons + previousAbsences;

      // SCORCIATOIA: Se le assenze sono pari al totale delle lezioni, resetta a 0
      // IMPORTANTE: NON resettare se ci sono presenze con id_sessione (lezioni divise realmente assenti)
      const hasAssenzeConSessioni = assenzeStudente.some((p) => {
        const hasSessione =
          p.id_sessione &&
          p.id_sessione !== null &&
          p.id_sessione !== "null" &&
          p.id_sessione !== "";
        return hasSessione;
      });

      const finalAbsences =
        totalAbsences >= totalLessons && !hasAssenzeConSessioni
          ? 0
          : totalAbsences;

      // Formatta con decimali se necessario
      const finalAbsencesFormatted = Number.isInteger(finalAbsences)
        ? finalAbsences
        : finalAbsences.toFixed(1);

      this.studentiInattivi[
        index
      ].frequencyPercent = `${finalAbsencesFormatted}/${totalLessons}`;

      this.studentiInattivi[index].mediaEsami =
        esamiStudente.length == 0
          ? "N/A"
          : (sommatoriaVoti / esamiStudente.length).toFixed(2);
    });

    this.numeroOre = 0;
    this.lezioni = this.lezioni.filter((l) => {
      if (l.id_corso == this.corso.id) return true;

      if (!l.altri_corsi) return false;

      // Gestisce diversi formati per altri_corsi
      const altriCorsiList = l.altri_corsi
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      return altriCorsiList.includes(this.corso.id);
    });
    this.lezioni.forEach((l) => {
      this.numeroOre += l.durata / 60;
    });

    this.setState({
      corso: this.corso,
      categorieCorso: this.categorieCorsi,
      selectedCategoriaCorso,
      dispense: this.dispense,
      compiti: this.compiti,
    });
  }

  async componentDidMount() {
    await this.loadComponent();
    await this.loadScontistiche(); // Aggiungo il caricamento delle scontistiche

    // Aggiungi listener per aggiornare i dati quando la finestra riceve focus
    window.addEventListener("focus", this.handleWindowFocus.bind(this));
  }

  componentWillUnmount() {
    // Rimuovi il listener quando il componente viene smontato
    window.removeEventListener("focus", this.handleWindowFocus.bind(this));
  }

  handleWindowFocus = async () => {
    // Ricarica i dati quando la finestra riceve focus (utente torna da altra scheda/finestra)
    console.log("EditCorso: Finestra ricevuto focus, ricaricando dati rate...");
    await this.loadRateUpdatedData();
  };

  // Metodo specifico per ricaricare solo i dati delle rate senza reload completo
  async loadRateUpdatedData() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    try {
      // Ricarica solo i dati necessari per le rate pagate
      this.rateCorso = await getRataStatusCorso(username, token, currentCourse);
      this.pianoPagamentiCorso = await getPianoPagamentiCorso(
        username,
        token,
        currentCourse,
      );

      // Ricarica i dati degli studenti con le rate aggiornate
      const updatedStudenti = await Promise.all(
        this.studenti.map(async (studente) => {
          let ratePagate = 0;
          let totaleRate = 0;

          try {
            let pianoStudente = await getPianoPagamentiCorsoStudenti(
              username,
              token,
              currentCourse,
              studente.id,
            );
            let ratePiano = null;

            if (pianoStudente && pianoStudente.rate) {
              ratePiano = pianoStudente.rate;
            } else if (
              this.pianoPagamentiCorso &&
              this.pianoPagamentiCorso.rate
            ) {
              ratePiano = this.pianoPagamentiCorso.rate;
            }

            if (ratePiano) {
              totaleRate = ratePiano.length;
              const rateStatus = await getRataStatus(
                username,
                token,
                currentCourse,
                studente.id,
              );

              for (const r of rateStatus) {
                // Normalizza gli importi per il confronto (rimuove € e spazi, converte a numero)
                const importoRata = parseFloat(
                  r.importo.toString().replace(/[€\s]/g, ""),
                );

                const rataCorrispondente = ratePiano.find((p) => {
                  const importoPiano = parseFloat(
                    p.importo.toString().replace(/[€\s]/g, ""),
                  );

                  // Normalizzazione delle date per il confronto
                  const normalizeDate = (dateStr) => {
                    if (!dateStr) return "";
                    let momentDate = moment(dateStr, "DD-MM-YYYY");
                    if (!momentDate.isValid()) {
                      momentDate = moment(dateStr, "DD-MMM-YYYY");
                    }
                    if (!momentDate.isValid()) {
                      momentDate = moment(dateStr);
                    }
                    return momentDate.isValid()
                      ? momentDate.format("DD-MM-YYYY")
                      : dateStr;
                  };

                  const dataMatch =
                    normalizeDate(p.data) === normalizeDate(r.data);
                  const importoMatch =
                    Math.abs(importoPiano - importoRata) < 0.01; // tolleranza per differenze di arrotondamento

                  // console.log("EditCorso - Confronto rata:", {
                  //   piano: { data: p.data, normalized: normalizeDate(p.data), importo: importoPiano },
                  //   status: { data: r.data, normalized: normalizeDate(r.data), importo: importoRata, status: r.status },
                  //   dataMatch,
                  //   importoMatch
                  // });

                  return dataMatch && importoMatch;
                });

                if (rataCorrispondente && r.status === "PAGATA") {
                  ratePagate++;
                }
              }
            }

            // Aggiorna il campo rate_pagate
            if (totaleRate > 0) {
              studente.rate_pagate = `${ratePagate}/${totaleRate}`;
            } else {
              studente.rate_pagate = "N/A";
            }
          } catch (error) {
            console.error(
              "Errore nel ricaricamento rate per studente",
              studente.id,
              error,
            );
            studente.rate_pagate = "Errore";
          }

          return studente;
        }),
      );

      // Aggiorna gli stati degli studenti
      this.studentiAttivi = updatedStudenti.filter((s) => {
        const corsiList = s.corsi
          .split(/[;,]/)
          .map((id) => id.trim())
          .filter((id) => id);
        const isEnrolled = corsiList.includes(currentCourse);
        const isWithdrawn =
          s.corsi_ritiro && s.corsi_ritiro.includes(currentCourse + ";");
        return isEnrolled && !isWithdrawn;
      });

      this.studentiInattivi = updatedStudenti.filter((s) => {
        const corsiList = s.corsi
          .split(/[;,]/)
          .map((id) => id.trim())
          .filter((id) => id);
        const isEnrolled = corsiList.includes(currentCourse);
        const isWithdrawn =
          s.corsi_ritiro && s.corsi_ritiro.includes(currentCourse + ";");
        return isEnrolled && isWithdrawn;
      });

      // Forza l'aggiornamento del componente
      this.setState({});
      console.log("EditCorso: Dati rate aggiornati con successo");
    } catch (error) {
      console.error(
        "EditCorso: Errore durante l'aggiornamento dei dati rate:",
        error,
      );
    }
  }

  async loadScontistiche() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    try {
      const response = await getScontisticheCorso(
        username,
        token,
        currentCourse,
      );
      if (
        response &&
        response.result === "ok" &&
        response.scontistiche !== undefined
      ) {
        this.setState({
          scontistiche: response.scontistiche,
          files: response.files || null,
        });
      }
    } catch (error) {
      console.error("Errore nel caricamento delle scontistiche:", error);
    }
  }

  async saveScontistiche() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    try {
      this.setState({ isLoading: true });
      const response = await updateScontisticheCorso(
        username,
        token,
        currentCourse,
        this.state.scontistiche,
        this.state.files,
      );
      this.setState({ isLoading: false });

      if (response && response.result === "ok") {
        alert("Scontistiche aggiornate con successo");
      } else {
        alert(
          "Si è verificato un errore durante il salvataggio delle scontistiche",
        );
      }
    } catch (error) {
      this.setState({ isLoading: false });
      console.error("Errore nel salvataggio delle scontistiche:", error);
      alert(
        "Si è verificato un errore durante il salvataggio delle scontistiche",
      );
    }
  }

  render() {
    var headCells = [
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      {
        id: "frequencyPercent",
        numeric: true,
        disablePadding: false,
        label: "Assenze",
      },
      { id: "quote", numeric: true, disablePadding: false, label: "Quote" },
      {
        id: "rate_pagate",
        numeric: true,
        disablePadding: false,
        label: "Rate pagate",
      },
      {
        id: "mediaEsami",
        numeric: true,
        disablePadding: false,
        label: "Media voti",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    var headCellsAnagrafica = [
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      {
        id: "mail",
        numeric: true,
        disablePadding: false,
        label: "Mail",
      },
      {
        id: "telefono",
        numeric: true,
        disablePadding: false,
        label: "Telefono",
      },
      {
        id: "citta",
        numeric: true,
        disablePadding: false,
        label: "Città di residenza",
      },
      {
        id: "citta_nascita",
        numeric: true,
        disablePadding: false,
        label: "Città nascita",
      },
      {
        id: "data_nascita",
        numeric: false,
        disablePadding: true,
        label: "Data nascita",
      },
      { id: "note", numeric: false, disablePadding: true, label: "Note" },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    var headCellsEsami = [
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      { id: "data", numeric: true, disablePadding: false, label: "Data" },
    ];

    var headCellsDispense = [
      {
        id: "nome_dispensa",
        numeric: false,
        disablePadding: true,
        label: "Nome",
      },
      {
        id: "descrizione",
        numeric: false,
        disablePadding: true,
        label: "Descrizione",
      },
      {
        id: "data",
        numeric: true,
        disablePadding: false,
        label: "Data di consegna/invio",
      },
      {
        id: "_",
        numeric: true,
        disablePadding: false,
        label: "",
      },
    ];

    var headCellsCompiti = [
      { id: "titolo", numeric: false, disablePadding: true, label: "Nome" },
      {
        id: "descrizione",
        numeric: true,
        disablePadding: false,
        label: "Descrizione",
      },
      {
        id: "data_creazione",
        numeric: true,
        disablePadding: false,
        label: "Data invio",
      },
      {
        id: "data_consegna",
        numeric: true,
        disablePadding: false,
        label: "Data consegna",
      },
      {
        id: "_",
        numeric: true,
        disablePadding: false,
        label: "",
      },
    ];

    this.searchCols = ["nome", "cognome", "mail"];
    this.searchColsEsami = ["data", "nome"];
    this.searchColsDispense = ["nome_dispensa", "data"];
    this.searchColsCompiti = [
      "titolo",
      "descrizione",
      "data_creazione",
      "data_consegna",
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 &&
      this.userslist.map((v, k) => {
        rows.push(createData(v.username, v.name, v.surname));
      });

    const cookies = new Cookies();
    const currentCourse = cookies.get("currentCourse", { path: "/" });
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const optionsCategoria = this.state.categorieCorso.map((corso) => ({
      value: corso.id,
      label: corso.name,
    }));

    if (this.state.corso == undefined) return <div />;

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title={this.pageTitle}
            button="STAMPA CALENDARIO"
            secondButton="ARCHIVIA CORSO"
            thirdButton="VAI AL CALENDARIO"
            onClick={() => {
              window.location.href = "/#/app/pdfCalendarioCorso";
            }}
            onSecondClick={async () => {
              if (
                window.confirm("Sei sicuro di voler archiviare il corso?") ==
                false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await updateCorsoStatus(username, token, this.corso.id, 0);
              window.location.href = "/#/app/corsi";
            }}
            onThirdClick={() => {
              window.location.href = "#/app/schedule";
            }}
          />
          <div style={{ display: "flex" }}>
            <div key={Math.random()}>
              <SelectInput
                value={this.state.selectedCategoriaCorso}
                name="Categoria"
                hidable={false}
                options={optionsCategoria}
                isMulti={false}
                onChange={(option) =>
                  this.setState({ selectedCategoriaCorso: option })
                }
              />
            </div>

            <br />

            <MyDatePicker
              ref={this.startDateRef}
              name={"Data inizio"}
              value={this.state.corso.dateStart}
            />

            <TextInput
              name={"Anno accademico"}
              value={this.state.corso.anno_accademico}
              onChange={(text) => {
                this.setState((prevState) => ({
                  corso: {
                    ...prevState.corso,
                    anno_accademico: text,
                  },
                }));
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextInput
              name={"Nome"}
              value={this.state.corso.name}
              onChange={(text) => {
                this.setState((prevState) => ({
                  corso: {
                    ...prevState.corso,
                    name: text,
                  },
                }));
              }}
            />

            <br />

            <MyDatePicker
              ref={this.endDateRef}
              name={"Data fine"}
              value={this.state.corso.dateEnd}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                gap: "10px",
              }}
            >
              <FixButton
                editCorso
                title={"Salva"}
                callback={this.save.bind(this)}
              />
              <FixButton
                title={"Elimina Corso"}
                callback={this.deleteCorsoHandler.bind(this)}
                style={{
                  backgroundColor: "#dc3545",
                  color: "white",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>

          <div>
            Visibile da Studenti
            <CheckBox
              checked={this.state.corso.visibleStudent == 1 ? true : false}
              name={"Visibile"}
              onElementCheck={(val) => {
                this.setState((prevState) => ({
                  corso: {
                    ...prevState.corso,
                    visibleStudent: val == true ? 1 : 0,
                  },
                }));
              }}
            />
          </div>

          <br />

          <br />

          <br />
          <div>
            Numero di ore di lezione attualmente inserite: {this.numeroOre}
          </div>

          <PageTitle
            title="Info studenti corso"
            button="STAMPA MEDIE DEL CORSO"
            secondButton="INVIA EMAIL"
            thirdButton="AGGIORNA RATE"
            onClick={() => {
              window.location.href = "/#/app/pdfFullCourse";
            }}
            onSecondClick={() => {
              this.setState({ sendMailShow: true });
            }}
            onThirdClick={async () => {
              console.log("EditCorso: Aggiornamento manuale rate richiesto...");
              this.setState({ isLoading: true });
              try {
                await this.loadRateUpdatedData();
                alert("Rate aggiornate con successo!");
              } catch (error) {
                console.error(
                  "Errore durante l'aggiornamento delle rate:",
                  error,
                );
                alert("Errore durante l'aggiornamento delle rate. Riprova.");
              } finally {
                this.setState({ isLoading: false });
              }
            }}
          />
          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          {this.state.sendMailShow && (
            <SendMailToClassWidget
              show={this.state.sendMailShow}
              onClose={() => {
                this.setState({ sendMailShow: false });
              }}
              studentiAttivi={this.studentiAttivi}
              onSend={async (subject, body, file, selectedEmails) => {
                console.log("=== INIZIO INVIO EMAIL ===");
                console.log("Subject:", subject);
                console.log("Body:", body);
                console.log("File:", file);
                console.log("Selected Emails:", selectedEmails);
                console.log("Studenti disponibili:", this.studenti.length);

                const cookies = new Cookies();
                const username = cookies.get("username", { path: "/" });
                const token = cookies.get("token", { path: "/" });

                console.log("Username:", username);
                console.log("Token:", token ? "presente" : "assente");

                this.mail = await getSetting(
                  username,
                  token,
                  "sendingMailAddress",
                );
                this.mailPassword = await getSetting(
                  username,
                  token,
                  "sendingMailPassword",
                );

                console.log("Mail mittente:", this.mail);
                console.log(
                  "Password mail:",
                  this.mailPassword ? "presente" : "assente",
                );

                // Salvataggio file (se presente) una volta sola
                if (file !== undefined) {
                  console.log("Salvataggio file:", file.name);
                  this.filePath = await saveFile(
                    username,
                    token,
                    file.name,
                    file.base64,
                  );
                  console.log("File salvato:", this.filePath);
                }

                // Controllo se esistono studenti selezionati, usando il parametro passato
                if (!selectedEmails || selectedEmails.length === 0) {
                  console.error("❌ ERRORE: Nessun studente selezionato");
                  alert("Nessun studente selezionato");
                  return;
                }

                console.log(`✓ ${selectedEmails.length} email selezionate`);

                // Itera su tutti gli studenti selezionati per inviare l'email
                let emailInviate = 0;
                let emailFallite = 0;

                for (const email of selectedEmails) {
                  console.log(`\n--- Processando email: ${email} ---`);

                  const studente = this.studenti.find(
                    (s) => s.mail.trim() === email.trim(),
                  );

                  if (!studente) {
                    console.error(
                      `❌ Studente non trovato per email: ${email}`,
                    );
                    emailFallite++;
                    continue;
                  }

                  console.log(
                    `✓ Studente trovato: ${studente.nome} ${studente.cognome}`,
                  );

                  studente.mail = studente.mail.trim();

                  // Controlla la validità dell'indirizzo email
                  if (
                    studente.mail !== "" &&
                    !Utils.validateEmail(studente.mail)
                  ) {
                    console.error(`❌ Email non valida: ${studente.mail}`);
                    alert("L'indirizzo " + studente.mail + " non è valido");
                    emailFallite++;
                    continue;
                  }

                  // Invia l'email se l'indirizzo è valido
                  if (studente.mail !== "") {
                    try {
                      console.log(`📧 Invio email a: ${studente.mail}`);
                      console.log(
                        `   Nome destinatario: ${studente.nome} ${studente.cognome}`,
                      );
                      console.log(`   Mittente: ${this.mail}`);
                      console.log(
                        `   Allegato: ${file ? this.filePath.name : "nessuno"}`,
                      );

                      const result = await sendMail(
                        username,
                        token,
                        this.mail,
                        "Accademia Nazionale del Cinema",
                        this.mailPassword,
                        studente.mail,
                        studente.nome + " " + studente.cognome,
                        file ? this.filePath.name : "",
                        subject,
                        body,
                      );

                      console.log(
                        `✅ Email inviata con successo a ${studente.mail}`,
                        result,
                      );
                      emailInviate++;

                      // Piccola pausa tra le email per evitare rate limiting SMTP
                      if (selectedEmails.length > 1) {
                        await new Promise((resolve) =>
                          setTimeout(resolve, 500),
                        );
                      }
                    } catch (error) {
                      console.error(
                        `❌ Errore invio email a ${studente.mail}:`,
                        error,
                      );
                      // Mostra un alert con il dettaglio dell'errore
                      console.error(
                        `Dettaglio errore: ${error.message || error}`,
                      );
                      emailFallite++;
                    }
                  } else {
                    console.warn(
                      `⚠️ Email vuota per studente: ${studente.nome} ${studente.cognome}`,
                    );
                    emailFallite++;
                  }
                }

                console.log("\n=== RIEPILOGO INVIO EMAIL ===");
                console.log(`✅ Email inviate con successo: ${emailInviate}`);
                console.log(`❌ Email fallite: ${emailFallite}`);
                console.log(`📊 Totale: ${emailInviate + emailFallite}`);

                if (emailInviate > 0 && emailFallite > 0) {
                  alert(
                    `⚠️ Invio parziale:\n\n✅ Email inviate: ${emailInviate}\n❌ Email fallite: ${emailFallite}\n\nVerifica la console (F12) per i dettagli degli errori.`,
                  );
                } else if (emailInviate > 0) {
                  alert(
                    `✅ Tutte le email sono state inviate con successo!\n\nEmail inviate: ${emailInviate}`,
                  );
                } else {
                  alert(
                    "Nessuna email è stata inviata. Controlla la console per i dettagli.",
                  );
                }

                // Nasconde il dialogo di attesa e quello di invio email
                this.setState({
                  waitDialogVisible: false,
                  sendMailShow: false,
                });
              }}
            />
          )}

          <Table
            key={this.state._dummyUpdate || "default"}
            headCells={headCells}
            searchCols={this.searchCols}
            currentCourse={currentCourse}
            assenze={true}
            addPerson={true}
            removePerson={true}
            students={true}
            calendar={false}
            pdf={false}
            excel={false}
            rows={this.studentiAttivi}
            onCellClick={(row, columnId) => {
              if (columnId === "quote") {
                // Trova l'oggetto studente completo usando l'ID
                const currentStudent = this.studenti.filter(
                  (studente) => studente.id == row,
                );

                if (currentStudent.length > 0) {
                  // Imposta il cookie con solo l'ID dello studente (come si aspetta StudenteDetails)
                  cookies.set("currentStudente", currentStudent[0].id, {
                    path: "/",
                  });
                  window.location.href = "/#/app/billing/studenteDetails";
                } else {
                  // Prova anche in studentiAttivi
                  const currentStudentAttivo = this.studentiAttivi.filter(
                    (studente) => studente.id == row,
                  );

                  if (currentStudentAttivo.length > 0) {
                    cookies.set("currentStudente", currentStudentAttivo[0].id, {
                      path: "/",
                    });
                    window.location.href = "/#/app/billing/studenteDetails";
                  } else {
                    alert(
                      "Errore: Studente non trovato. Verifica che lo studente esista.",
                    );
                  }
                }
              } else if (columnId === "rate_pagate") {
                // Quando l'utente clicca su rate_pagate, aggiorna i dati e vai alla gestione billing
                console.log(
                  "EditCorso: Click su rate_pagate, aggiornando dati...",
                );
                this.loadRateUpdatedData().then(() => {
                  const currentStudent = this.studenti.filter(
                    (studente) => studente.id == row,
                  );

                  if (currentStudent.length > 0) {
                    cookies.set("currentStudente", currentStudent[0].id, {
                      path: "/",
                    });
                    window.location.href = "/#/app/billing/studenteDetails";
                  } else {
                    alert(
                      "Errore: Studente non trovato. Verifica che lo studente esista.",
                    );
                  }
                });
              } else if (columnId === "mediaEsami") {
                // Quando l'utente clicca sulla media voti, mostra il modale direttamente nella scheda "Dettaglio esami"
                const esamiStudente = this.valutazioni.filter(
                  (esame) =>
                    esame.id_studente == row && esame.valutazione != -1,
                );

                var examsDetails = [];
                const esamiGiaMostrati = new Set(); // Traccia gli esami già inseriti per evitare duplicati

                // Prima aggiungi gli esami del corso corrente
                this.esami.forEach((esameCorso) => {
                  esamiStudente.forEach((esameStudente) => {
                    if (esameCorso.id == esameStudente.id_esame) {
                      // Add this exam to the list in state
                      var nota = [];
                      // La data è già formattata in DD/MM/YYYY da loadEsami()
                      const dataFormattata = esameCorso.data || "";
                      nota.push(
                        esameCorso.nome.toUpperCase() + ": " + dataFormattata,
                      );
                      nota.push(esameStudente.valutazione);
                      examsDetails.push(nota);
                      // Traccia l'esame con la chiave normalizzata
                      esamiGiaMostrati.add(
                        esameCorso.nome.replace(/\s+/g, "").toLowerCase(),
                      );
                    }
                  });
                });

                // Se ci sono voti dal corso precedente, aggiungiamoli (solo quelli NON già mostrati)
                const prevRecord = this.state.votiPrecedenti.find(
                  (item) => item.id_studente == row,
                );

                console.log(
                  "[DEBUG] State votiPrecedenti completo:",
                  this.state.votiPrecedenti,
                );
                console.log(
                  "[DEBUG] prevRecord per studente",
                  row,
                  ":",
                  prevRecord,
                );

                if (prevRecord && prevRecord._esamiOriginali) {
                  console.log(
                    "[DEBUG] _esamiOriginali:",
                    prevRecord._esamiOriginali,
                  );
                  // Usa i dati completi degli esami dai corsi precedenti
                  for (let key in prevRecord._esamiOriginali) {
                    const esameInfo = prevRecord._esamiOriginali[key];
                    const chiaveNormalizzata = key.toLowerCase();

                    // Aggiungi solo se NON è già stato mostrato dal corso corrente
                    if (
                      !esamiGiaMostrati.has(chiaveNormalizzata) &&
                      esameInfo.valutazione !== undefined &&
                      esameInfo.valutazione !== null &&
                      esameInfo.valutazione != -1
                    ) {
                      var nota = [];
                      // Usa il nome originale dell'esame + la data se disponibile
                      const dataFormattataPrec = esameInfo.data
                        ? moment(esameInfo.data).format("DD/MM/YYYY")
                        : null;
                      const nomeCompleto = dataFormattataPrec
                        ? `${esameInfo.nome.toUpperCase()}: ${dataFormattataPrec} (CORSO PREC.)`
                        : `${esameInfo.nome.toUpperCase()} (CORSO PREC.)`;
                      nota.push(nomeCompleto);
                      nota.push(esameInfo.valutazione);
                      examsDetails.push(nota);
                      console.log(
                        "[DEBUG] Aggiunto esame precedente:",
                        esameInfo.nome,
                        "voto:",
                        esameInfo.valutazione,
                      );
                    } else if (esamiGiaMostrati.has(chiaveNormalizzata)) {
                      console.log(
                        "[DEBUG] Esame già mostrato dal corso corrente:",
                        esameInfo.nome,
                      );
                    }
                  }
                } else {
                  console.log(
                    "[DEBUG] Nessun voto precedente trovato per studente",
                    row,
                  );
                }

                const currentStudent = this.studenti.filter(
                  (studente) => studente.id == row,
                );
                const studentFullName =
                  currentStudent[0].cognome + " " + currentStudent[0].nome;

                // Carichiamo anche i dettagli di presenza per completezza (ma verranno visualizzati solo se l'utente cambia scheda)
                var details = [];
                this.lezioniSvolteEffettive.sort((l1, l2) => {
                  var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
                  var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
                  return data1 < data2 ? -1 : 1;
                });

                for (const l of this.lezioniSvolteEffettive) {
                  var presenza = this.presenzeCorsoEffettive.filter(
                    (p) => p.id_lezione == l.id && p.id_studente == row,
                  );

                  // Solo se c'è una gestione presenza per questa lezione, crea una voce nel modal
                  if (presenza.length > 0) {
                    var nota = [];
                    var val =
                      presenza == undefined || presenza[0].presenza == -1
                        ? "ASSENTE"
                        : "PRESENTE";

                    nota.push(l.data);
                    nota.push(l.argomento ? l.argomento : "");
                    nota.push(val);
                    nota.push(presenza[0].id_recupero_lezioni);
                    nota.push(l.id); // id_lezione
                    nota.push(row); // id_studente
                    if (presenza[0].ore != "")
                      nota[1] += " " + presenza[0].ore + "/" + l.durata / 60;
                    if (presenza[0].id_recupero_lezioni !== null) {
                      nota.push("RICHIESTA RECUPERO");
                    }
                    details.push(nota);
                  }
                }

                const recuperoId = details.find((detail) => detail[3])
                  ? details.find((detail) => detail[3])[3]
                  : null;

                this.setState({
                  detailsShow: true,
                  details: details,
                  exams: examsDetails,
                  retiredDetails: currentStudent[0].corsi_ritiro.includes(
                    this.corso.id + ";",
                  ),
                  studentDetails: studentFullName,
                  currentStudentObject: currentStudent[0], // Aggiungiamo l'oggetto studente completo
                  det: recuperoId,
                  showExams: true, // Apertura sulla scheda "Dettaglio esami" per la colonna "mediaEsami"
                  singleMode: true, // Mostra solo la tab "Dettaglio esami"
                });
              } else {
                // Per il click su altre celle, chiamiamo la stessa logica di onEventClick,
                // ma assicurandoci che showExams sia false (default su "dettagli presenza")
                this.handleStudentClick(row, false);
              }
            }}
            onEventClick={(row) => {
              // Per il click sulla riga in generale, chiamiamo la funzione comune
              // Impostiamo esplicitamente showExams a false per aprire sulla scheda "dettagli presenza"
              this.handleStudentClick(row, false);
            }}
            onAddStudent={async (row) => {
              if (
                window.confirm(
                  "Vuoi davvero ammettere nuovamente questo studente al corso?",
                )
              ) {
                this.studenti.forEach(async (studente) => {
                  if (studente.id == row) {
                    var corsiRitiroStr = studente.corsi_ritiro;

                    var newRitiriStr = "";
                    Utils.parseCorsi(corsiRitiroStr).forEach((corso) => {
                      if (corso != currentCourse) newRitiriStr += corso + ";";
                    });

                    await updateCorsiRitiroStudente(
                      username,
                      token,
                      studente.id,
                      newRitiriStr,
                    );

                    // Riattiva lo studente: disabled = 0
                    await setSospensioneStudente(
                      username,
                      token,
                      studente.id,
                      0,
                    );

                    alert(
                      "Studente " +
                        studente.nome +
                        " " +
                        studente.cognome +
                        " ammesso al corso con successo.",
                    );
                    await this.loadComponent();
                  }
                });
              }
            }}
            onRemoveStudent={async (row) => {
              if (
                window.confirm(
                  "Vuoi davvero impostare questo studente come ritirato da questo corso?",
                )
              ) {
                this.studenti.forEach(async (studente) => {
                  if (studente.id == row) {
                    var corsiRitiroStr = studente.corsi_ritiro;
                    if (!Utils.hasCorso(corsiRitiroStr, currentCourse))
                      corsiRitiroStr += currentCourse + ";";

                    await updateCorsiRitiroStudente(
                      username,
                      token,
                      row,
                      corsiRitiroStr,
                    );

                    // Sospendi lo studente: disabled = 1 e data_sospensione = NOW()
                    await setSospensioneStudente(
                      username,
                      token,
                      studente.id,
                      1,
                    );

                    alert(
                      "Studente " +
                        studente.nome +
                        " " +
                        studente.cognome +
                        " ritirato dal corso con successo.",
                    );
                    await this.loadComponent();
                  }
                });
              }
            }}
            onPdfClicked={(row) => {
              const currentStudent = this.studenti.filter(
                (studente) => studente.id == row,
              )[0];
              const media = currentStudent.mediaEsami;

              const cookies = new Cookies();
              cookies.set("requestedStudent", row, { path: "/" });
              cookies.set("studentAvg", media, { path: "/" });
              window.location.href = "/#/app/pdfEsameSingoloPage";
            }}
            onAssenze={(row) => {
              cookies.set("currentStudente", row, { path: "/" });
              window.location.href =
                "/#/app/gestioneAssenze?corso=" + this.corso.id;
            }}
            onEditStudent={(row) => {
              cookies.set("currentStudente", row, { path: "/" });
              window.location.href = "/#/app/editStudente";
            }}
          />
          <br />
          <PageTitle title="Anagrafica studenti" />
          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          <Table
            headCells={headCellsAnagrafica}
            searchCols={this.searchCols}
            currentCourse={currentCourse}
            assenze={false}
            addPerson={false}
            removePerson={false}
            students={true}
            calendar={false}
            pdf={false}
            excel={false}
            rows={this.studentiAttivi}
            onEventClick={(row) => {
              cookies.set("currentStudente", row, { path: "/" });
              window.location.href = "/#/app/editStudente";
            }}
          />
          <br />
          <PageTitle
            title="Lista studenti sospesi"
            button={this.state.showText}
            onClick={() => {
              this.setState({
                showText: this.state.showRitirati ? "MOSTRA" : "NASCONDI",
                showRitirati: !this.state.showRitirati,
              });
            }}
          />

          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          {this.state.showRitirati && (
            <Table
              headCells={headCells}
              searchCols={this.searchCols}
              currentCourse={currentCourse}
              addPerson={true}
              removePerson={true}
              students={true}
              calendar={false}
              pdf={false}
              excel={false}
              rows={this.studentiInattivi}
              onCellClick={(row, columnId) => {
                if (columnId === "quote") {
                  // Trova l'oggetto studente completo usando l'ID (prima cerca in studentiInattivi)
                  const currentStudent = this.studentiInattivi.filter(
                    (studente) => studente.id == row,
                  );

                  if (currentStudent.length > 0) {
                    // Imposta il cookie con solo l'ID dello studente (come si aspetta StudenteDetails)
                    cookies.set("currentStudente", currentStudent[0].id, {
                      path: "/",
                    });
                    window.location.href = "/#/app/billing/studenteDetails";
                  } else {
                    // Se non lo trova nei sospesi, prova nella lista generale
                    const currentStudentGeneral = this.studenti.filter(
                      (studente) => studente.id == row,
                    );

                    if (currentStudentGeneral.length > 0) {
                      cookies.set(
                        "currentStudente",
                        currentStudentGeneral[0].id,
                        {
                          path: "/",
                        },
                      );
                      window.location.href = "/#/app/billing/studenteDetails";
                    } else {
                      alert(
                        "Errore: Studente non trovato. Verifica che lo studente esista.",
                      );
                    }
                  }
                } else if (columnId === "rate_pagate") {
                  // Quando l'utente clicca su rate_pagate, aggiorna i dati e vai alla gestione billing
                  console.log(
                    "EditCorso: Click su rate_pagate (studente sospeso), aggiornando dati...",
                  );
                  this.loadRateUpdatedData().then(() => {
                    const currentStudent = this.studentiInattivi.filter(
                      (studente) => studente.id == row,
                    );

                    if (currentStudent.length > 0) {
                      cookies.set("currentStudente", currentStudent[0].id, {
                        path: "/",
                      });
                      window.location.href = "/#/app/billing/studenteDetails";
                    } else {
                      // Se non lo trova nei sospesi, prova nella lista generale
                      const currentStudentGeneral = this.studenti.filter(
                        (studente) => studente.id == row,
                      );

                      if (currentStudentGeneral.length > 0) {
                        cookies.set(
                          "currentStudente",
                          currentStudentGeneral[0].id,
                          {
                            path: "/",
                          },
                        );
                        window.location.href = "/#/app/billing/studenteDetails";
                      } else {
                        alert(
                          "Errore: Studente non trovato. Verifica che lo studente esista.",
                        );
                      }
                    }
                  });
                } else if (columnId === "mediaEsami") {
                  // Quando l'utente clicca sulla media voti, mostra il modale direttamente nella scheda "Dettaglio esami"
                  const esamiStudente = this.valutazioni.filter(
                    (esame) =>
                      esame.id_studente == row && esame.valutazione != -1,
                  );

                  var examsDetails = [];
                  const esamiGiaMostrati = new Set(); // Traccia gli esami già inseriti per evitare duplicati

                  // Prima aggiungi gli esami del corso corrente
                  this.esami.forEach((esameCorso) => {
                    esamiStudente.forEach((esameStudente) => {
                      if (esameCorso.id == esameStudente.id_esame) {
                        // Add this exam to the list in state
                        var nota = [];
                        // La data è già formattata in DD/MM/YYYY da loadEsami()
                        const dataFormattata = esameCorso.data || "";
                        nota.push(
                          esameCorso.nome.toUpperCase() + ": " + dataFormattata,
                        );
                        nota.push(esameStudente.valutazione);
                        examsDetails.push(nota);
                        // Traccia l'esame con la chiave normalizzata
                        esamiGiaMostrati.add(
                          esameCorso.nome.replace(/\s+/g, "").toLowerCase(),
                        );
                      }
                    });
                  });

                  // Se ci sono voti dal corso precedente, aggiungiamoli (solo quelli NON già mostrati)
                  const prevRecord = this.state.votiPrecedenti.find(
                    (item) => item.id_studente == row,
                  );

                  console.log(
                    "[DEBUG INATTIVI] prevRecord per studente",
                    row,
                    ":",
                    prevRecord,
                  );

                  if (prevRecord && prevRecord._esamiOriginali) {
                    console.log(
                      "[DEBUG INATTIVI] _esamiOriginali:",
                      prevRecord._esamiOriginali,
                    );
                    // Usa i dati completi degli esami dai corsi precedenti
                    for (let key in prevRecord._esamiOriginali) {
                      const esameInfo = prevRecord._esamiOriginali[key];
                      const chiaveNormalizzata = key.toLowerCase();

                      // Aggiungi solo se NON è già stato mostrato dal corso corrente
                      if (
                        !esamiGiaMostrati.has(chiaveNormalizzata) &&
                        esameInfo.valutazione !== undefined &&
                        esameInfo.valutazione !== null &&
                        esameInfo.valutazione != -1
                      ) {
                        var nota = [];
                        // Usa il nome originale dell'esame + la data se disponibile
                        const dataFormattataPrec = esameInfo.data
                          ? moment(esameInfo.data).format("DD/MM/YYYY")
                          : null;
                        const nomeCompleto = dataFormattataPrec
                          ? `${esameInfo.nome.toUpperCase()}: ${dataFormattataPrec} (CORSO PREC.)`
                          : `${esameInfo.nome.toUpperCase()} (CORSO PREC.)`;
                        nota.push(nomeCompleto);
                        nota.push(esameInfo.valutazione);
                        examsDetails.push(nota);
                        console.log(
                          "[DEBUG INATTIVI] Aggiunto esame precedente:",
                          esameInfo.nome,
                          "voto:",
                          esameInfo.valutazione,
                        );
                      } else if (esamiGiaMostrati.has(chiaveNormalizzata)) {
                        console.log(
                          "[DEBUG INATTIVI] Esame già mostrato dal corso corrente:",
                          esameInfo.nome,
                        );
                      }
                    }
                  } else {
                    console.log(
                      "[DEBUG INATTIVI] Nessun voto precedente trovato per studente",
                      row,
                    );
                  }

                  const currentStudent = this.studenti.filter(
                    (studente) => studente.id == row,
                  );
                  const studentFullName =
                    currentStudent[0].cognome + " " + currentStudent[0].nome;

                  // Carichiamo anche i dettagli di presenza per completezza (ma verranno visualizzati solo se l'utente cambia scheda)
                  var details = [];
                  this.lezioniSvolteEffettive.sort((l1, l2) => {
                    var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
                    var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
                    return data1 < data2 ? -1 : 1;
                  });

                  for (const l of this.lezioniSvolteEffettive) {
                    var presenza = this.presenzeCorsoEffettive.filter(
                      (p) => p.id_lezione == l.id && p.id_studente == row,
                    );

                    // Solo se c'è una gestione presenza per questa lezione, crea una voce nel modal
                    if (presenza.length > 0) {
                      var nota = [];
                      var val =
                        presenza == undefined || presenza[0].presenza == -1
                          ? "ASSENTE"
                          : "PRESENTE";

                      nota.push(l.data);
                      nota.push(l.argomento ? l.argomento : "");
                      nota.push(val);
                      nota.push(presenza[0].id_recupero_lezioni);
                      nota.push(l.id); // id_lezione
                      nota.push(row); // id_studente
                      if (presenza[0].ore != "")
                        nota[1] += " " + presenza[0].ore + "/" + l.durata / 60;
                      if (presenza[0].id_recupero_lezioni !== null) {
                        nota.push("RICHIESTA RECUPERO");
                      }
                      details.push(nota);
                    }
                  }

                  const recuperoId = details.find((detail) => detail[3])
                    ? details.find((detail) => detail[3])[3]
                    : null;

                  this.setState({
                    detailsShow: true,
                    details: details,
                    exams: examsDetails,
                    retiredDetails: currentStudent[0].corsi_ritiro.includes(
                      this.corso.id + ";",
                    ),
                    studentDetails: studentFullName,
                    currentStudentObject: currentStudent[0], // Aggiungiamo l'oggetto studente completo
                    det: recuperoId,
                    showExams: true, // Apertura sulla scheda "Dettaglio esami" per la colonna "mediaEsami"
                    singleMode: true, // Mostra solo la tab "Dettaglio esami"
                  });
                } else if (columnId === "frequencyPercent") {
                  // Quando l'utente clicca sulla colonna Assenze, mostra il modal direttamente nella scheda "dettagli presenza"
                  this.handleStudentClick(row, false);
                } else {
                  // Per il click su altre celle, chiamiamo la stessa logica di onEventClick,
                  // ma assicurandoci che showExams sia false (default su "dettagli presenza")
                  this.handleStudentClick(row, false);
                }
              }}
              onAddStudent={(row) => {
                // Imposta lo studente selezionato e mostra il modale
                this.setState({
                  showCambioClasseWidget: true,
                  selectedStudent: this.studenti.find((s) => s.id === row),
                });
              }}
              onPdfClicked={(row) => {
                const currentStudent = this.studenti.filter(
                  (studente) => studente.id == row,
                )[0];
                const media = currentStudent.mediaEsami;

                const cookies = new Cookies();
                cookies.set("requestedStudent", row, { path: "/" });
                cookies.set("studentAvg", media, { path: "/" });
                window.location.href = "/#/app/pdfEsameSingoloPage";
              }}
              onEventClick={(row) => {
                var details = [];

                this.lezioniSvolteEffettive.sort((l1, l2) => {
                  var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
                  var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
                  return data1 < data2 ? -1 : 1;
                });

                const esamiStudente = this.valutazioni.filter(
                  (esame) =>
                    esame.id_studente == row && esame.valutazione != -1,
                );

                var examsDetails = [];

                this.esami.forEach((esameCorso) => {
                  esamiStudente.forEach((esameStudente) => {
                    if (esameCorso.id == esameStudente.id_esame) {
                      // Add this exam to the list in state
                      var nota = [];
                      nota.push(
                        esameCorso.nome.toUpperCase() + ": " + esameCorso.data,
                      );
                      nota.push(esameStudente.valutazione);
                      examsDetails.push(nota);
                    }
                  });
                });

                this.lezioniSvolteEffettive.forEach((l) => {
                  var presenze = this.presenzeCorsoEffettive.filter(
                    (p) => p.id_lezione == l.id && p.id_studente == row,
                  );

                  // Solo se c'è una gestione presenza per questa lezione, crea una voce nel modal
                  if (presenze.length > 0) {
                    // Gestisce sia lezioni normali (1 presenza) che lezioni divise (2 presenze)
                    presenze.forEach((presenza) => {
                      console.log(`[Modal DEBUG] Presenza:`, presenza);
                      console.log(
                        `[Modal DEBUG] id_sessione = "${presenza.id_sessione}", tipo:`,
                        typeof presenza.id_sessione,
                      );

                      var nota = [];
                      let val =
                        presenza.presenza == -1 ? "ASSENTE" : "PRESENTE";

                      // Determina se è una sessione (metà giornata)
                      const hasSessione =
                        presenza.id_sessione &&
                        presenza.id_sessione !== null &&
                        presenza.id_sessione !== "null" &&
                        presenza.id_sessione !== "";

                      console.log(`[Modal DEBUG] hasSessione = ${hasSessione}`);
                      console.log(
                        `[Modal DEBUG] sessioniMap keys:`,
                        Object.keys(this.sessioniMap),
                      );

                      let sessioneLabel = "";
                      if (hasSessione) {
                        // Usa la mappa delle sessioni per ottenere l'ordine corretto
                        const sessione = this.sessioniMap[presenza.id_sessione];
                        console.log(
                          `[Modal DEBUG] Sessione trovata:`,
                          sessione,
                        );
                        if (sessione) {
                          sessioneLabel =
                            sessione.ordine === 1
                              ? " ☀ (Prima metà)"
                              : " ☾ (Seconda metà)";
                          console.log(
                            `[Modal] Sessione ${presenza.id_sessione}: ordine=${sessione.ordine}, label="${sessioneLabel}"`,
                          );
                        } else {
                          // Fallback: usa il modulo se la sessione non è stata trovata
                          sessioneLabel =
                            presenza.id_sessione % 2 === 1
                              ? " ☀ (Prima metà)"
                              : " ☾ (Seconda metà)";
                          console.warn(
                            `[Modal] Sessione ${presenza.id_sessione} non trovata nella mappa, usando fallback`,
                          );
                        }
                      }

                      // ✅ FIX: Per mezze giornate, usa l'orario della sessione invece di l.data
                      let dataPerNotaModal = l.data;
                      if (hasSessione) {
                        const sess = this.sessioniMap[presenza.id_sessione];
                        if (sess && sess.ora_inizio) {
                          const dp = l.data.split(" ")[0];
                          dataPerNotaModal = `${dp} ${sess.ora_inizio}`;
                        }
                      }
                      nota.push(dataPerNotaModal);
                      nota.push(
                        (l.argomento ? l.argomento : "") + sessioneLabel,
                      );
                      nota.push(val);
                      nota.push(presenza.id_recupero_lezioni);
                      nota.push(l.id); // id_lezione
                      nota.push(row); // id_studente

                      details.push(nota);
                    });
                  }
                });

                // AGGIUNTA: Includi le assenze precedenti nel modal
                // ✅ FIX: Mostra solo assenze precedenti se mantieni_assenze era attivo
                // Se dettagliAssenzePrecedenti è vuoto [], significa che erano state azzerate per mantieni_assenze=0
                if (
                  this.dettagliAssenzePrecedenti &&
                  this.dettagliAssenzePrecedenti[row] &&
                  this.dettagliAssenzePrecedenti[row].length > 0
                ) {
                  const assenzePrecedenti = this.dettagliAssenzePrecedenti[row];
                  console.log(
                    `[MODAL] Aggiungendo ${assenzePrecedenti.length} assenze precedenti per studente ${row}`,
                  );
                  console.log(
                    `[MODAL] Dettagli assenze precedenti:`,
                    assenzePrecedenti,
                  );

                  assenzePrecedenti.forEach((assenzaPrecedente) => {
                    console.log(
                      "[MODAL] Assenza precedente:",
                      assenzaPrecedente,
                    );
                    console.log(
                      "[MODAL DEBUG DATA] assenzaPrecedente.data:",
                      JSON.stringify(assenzaPrecedente.data),
                      "| tipo:",
                      typeof assenzaPrecedente.data,
                      "| data_lezione:",
                      JSON.stringify(assenzaPrecedente.data_lezione),
                      "| assenza:",
                      JSON.stringify(assenzaPrecedente.assenza),
                    );

                    var nota = [];
                    // Formato delle assenze precedenti potrebbe variare, adattare di conseguenza
                    let dataRaw =
                      assenzaPrecedente.data ||
                      assenzaPrecedente.data_lezione ||
                      "Data non disponibile";

                    // ✅ FIX: Se ha sessione_ora_inizio, sostituisci l'orario con quello reale
                    if (
                      assenzaPrecedente.sessione_ora_inizio &&
                      dataRaw &&
                      dataRaw !== "Data non disponibile"
                    ) {
                      const datePart = dataRaw.split(" ")[0];
                      dataRaw = `${datePart} ${assenzaPrecedente.sessione_ora_inizio}`;
                    }

                    const dataAssenza = dataRaw;
                    // ✅ FIX: Aggiungi label sessione se disponibile
                    const sessioneLabelModal = assenzaPrecedente.sessione_label
                      ? ` (${assenzaPrecedente.sessione_label})`
                      : "";

                    console.log(
                      "[MODAL DEBUG] dataAssenza finale:",
                      JSON.stringify(dataAssenza),
                      "sessioneLabel:",
                      sessioneLabelModal,
                    );

                    const argomentoAssenza =
                      assenzaPrecedente.argomento ||
                      assenzaPrecedente.materia ||
                      `Lezione da ${assenzaPrecedente.nomeCorso ||
                        "corso precedente"}`;

                    nota.push(dataAssenza); // posizione 0 - solo data, NO sessioneLabel
                    // Aggiungi label sessione all'argomento per DetailsDialog
                    const argomentoConLabel =
                      sessioneLabelModal &&
                      !argomentoAssenza.includes("Prima metà") &&
                      !argomentoAssenza.includes("Seconda metà")
                        ? `🔄 ${argomentoAssenza}${sessioneLabelModal}`
                        : `🔄 ${argomentoAssenza}`;
                    nota.push(argomentoConLabel); // posizione 1 - contiene "Prima metà"/"Seconda metà" per DetailsDialog
                    nota.push("ASSENTE");
                    nota.push(null); // Non ci sono recuperi per assenze precedenti, per ora
                    nota.push(`prev_${Math.random()}`); // ID temporaneo per assenze precedenti
                    nota.push(row); // id_studente

                    details.push(nota);
                  });
                } else {
                  console.log(
                    `[MODAL] ⚠️ Nessuna assenza precedente per studente ${row} (dettagliAssenzePrecedenti: ${
                      this.dettagliAssenzePrecedenti
                        ? this.dettagliAssenzePrecedenti[row]
                          ? `array length ${this.dettagliAssenzePrecedenti[row].length}`
                          : "undefined"
                        : "null"
                    })`,
                  );
                }

                const currentStudent = this.studenti.filter(
                  (studente) => studente.id == row,
                );
                const studentFullName =
                  currentStudent[0].cognome + " " + currentStudent[0].nome;

                this.setState({
                  detailsShow: true,
                  details: details,
                  exams: examsDetails,
                  retiredDetails: currentStudent[0].corsi_ritiro.includes(
                    this.corso.id + ";",
                  ),
                  studentDetails: studentFullName,
                  currentStudentObject: currentStudent[0], // Aggiungiamo l'oggetto studente completo
                  singleMode: true, // Mostra solo la tab richiesta
                });
              }}
            />
          )}

          {this.state.showCambioClasseWidget && (
            <CambioClasseWidget
              studente={this.state.selectedStudent.id}
              onClose={() => {
                this.setState({ showCambioClasseWidget: false });
                this.loadComponent();
              }}
              idCorsoAttuale={currentCourse}
            />
          )}

          {/* {this.state.showRitirati && (
						<Table
							headCells={headCells}
							searchCols={this.searchCols}
							currentCourse={currentCourse}
							addPerson={true}
							removePerson={true}
							students={true}
							calendar={false}
							pdf={false}
							excel={false}
							rows={this.studentiInattivi}
							onAddStudent={async row => {
								if (window.confirm("Vuoi davvero ammettere nuovamente questo studente al corso?")) {
									this.studenti.forEach(async studente => {
										if (studente.id == row) {
											var corsiRitiroStr = studente.corsi_ritiro;

											var newRitiriStr = "";
											Utils.parseCorsi(corsiRitiroStr).forEach(corso => {
												if (corso != currentCourse) newRitiriStr += corso + ";";
											});

											await updateCorsiRitiroStudente(username, token, studente.id, newRitiriStr);

											// Riattiva lo studente: disabled = 0 e data_sospensione = NULL
											await setSospensioneStudente(username, token, studente.id, 0);

											alert(
												"Studente " +
													studente.nome +
													" " +
													studente.cognome +
													" ammesso al corso con successo."
											);
											await this.loadComponent();
										}
									});
								}
							}}
							onPdfClicked={row => {
								const currentStudent = this.studenti.filter(studente => studente.id == row)[0];
								const media = currentStudent.mediaEsami;

								const cookies = new Cookies();
								cookies.set("requestedStudent", row, { path: "/" });
								cookies.set("studentAvg", media, { path: "/" });
								window.location.href = "/#/app/pdfEsameSingoloPage";
							}}
							onEventClick={row => {
								var details = [];

								this.lezioniSvolteEffettive.sort((l1, l2) => {
									var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
									var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
									return data1 < data2 ? -1 : 1;
								});

								const esamiStudente = this.valutazioni.filter(
									esame => esame.id_studente == row && esame.valutazione != -1
								);

								var examsDetails = [];

								this.esami.forEach(esameCorso => {
									esamiStudente.forEach(esameStudente => {
										if (esameCorso.id == esameStudente.id_esame) {
											// Add this exam to the list in state
											var nota = [];
											nota.push(esameCorso.nome.toUpperCase() + ": " + esameCorso.data);
											nota.push(esameStudente.valutazione);
											examsDetails.push(nota);
										}
									});
								});

								this.lezioniSvolteEffettive.forEach(l => {
									var presenza = this.presenzeCorsoEffettive.filter(
										p => p.id_lezione == l.id && p.id_studente == row
									);
									
									// Solo se c'è una gestione presenza per questa lezione, crea una voce nel modal
									if (presenza.length > 0) {
										var nota = [];
										let val =
											presenza == undefined || presenza[0].presenza == -1
												? "ASSENTE"
												: "PRESENTE";

										nota.push(l.data);
										nota.push(l.argomento ? l.argomento : "");
										nota.push(val);
										nota.push(presenza[0].id_recupero_lezioni);
										nota.push(l.id); // id_lezione
										nota.push(row); // id_studente
										if (presenza[0].ore != "")
											nota[1] += " " + presenza[0].ore + "/" + l.durata / 60;
										details.push(nota);
									}
								});

								const currentStudent = this.studenti.filter(studente => studente.id == row);
								const studentFullName = currentStudent[0].cognome + " " + currentStudent[0].nome;

								this.setState({
									detailsShow: true,
									details: details,
									exams: examsDetails,
									retiredDetails: currentStudent[0].corsi_ritiro.includes(this.corso.id + ";"),
									studentDetails: studentFullName,
									currentStudentObject: currentStudent[0], // Aggiungiamo l'oggetto studente completo
									singleMode: true, // Mostra solo la tab richiesta
								});
							}}
						/>
					)} */}
          <br />
          <PageTitle
            title="Dispense e libri"
            button="AGGIUNGI"
            onClick={() => {
              this.setState({ uploadDocumentShow: true });
            }}
          />

          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          {this.state.uploadDocumentShow && (
            <UploadDocument
              corso={this.state.corso}
              show={this.state.uploadDocumentShow}
              onClose={async () => {
                this.setState({ uploadDocumentShow: false });
                this.setState({});
                await this.loadDispense();
              }}
            />
          )}
          <Table
            headCells={headCellsDispense}
            searchCols={this.searchColsDispense}
            calendar={false}
            excel={false}
            pdf={false}
            rows={this.state.dispense}
            onViewFile={this.handleViewFile}
            fileType="dispense"
            onDelete={async (id) => {
              if (
                window.confirm(
                  "Sei sicuro di voler eliminare questa dispensa?",
                ) == false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteDispensa(username, token, id);
              await this.loadDispense();
              this.setState({});
            }}
          />
          <br />
          <PageTitle
            title="Compiti"
            button="AGGIUNGI"
            onClick={() => {
              this.setState({ uploadCompitiShow: true });
            }}
          />

          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          {this.state.uploadCompitiShow && (
            <UploadCompiti
              corso={this.state.corso}
              show={this.state.uploadCompitiShow}
              onClose={async () => {
                this.setState({ uploadCompitiShow: false });
                this.setState({});
                await this.loadCompiti();
              }}
            />
          )}
          <Table
            headCells={headCellsCompiti}
            searchCols={this.searchColsCompiti}
            calendar={false}
            excel={false}
            pdf={false}
            rows={this.state.compiti}
            onViewFile={this.handleViewFile}
            fileType="compiti"
            onEventClick={(id) => this.handleCompitoClick(id)}
            onDelete={async (id) => {
              if (
                window.confirm(
                  "Sei sicuro di voler eliminare questo compito?",
                ) == false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteCompito(username, token, id);
              await this.loadCompiti();
              this.setState({});
            }}
          />
          <br />

          <PageTitle
            title="Esami"
            button="AGGIUNGI"
            onClick={() => {
              this.setState({ insertEsameShow: true });
            }}
          />

          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          <Table
            headCells={headCellsEsami}
            searchCols={this.searchColsEsami}
            calendar={false}
            excel={false}
            pdf={false}
            rows={this.esami}
            onPdfClicked={(row) => {
              const cookies = new Cookies();
              cookies.set("selectedExam", row, { path: "/" });
              window.location.href = "/#/app/pdfExam";
            }}
            onEventClick={(row) => {
              const cookies = new Cookies();
              cookies.set("currentEsame", row, { path: "/" });
              window.location.href = "/#/app/esameDetails";
            }}
            onDelete={async (id) => {
              if (
                window.confirm("Cancellare l'esame e tutti i voti presenti?") ==
                false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteEsame(username, token, id);
              await this.loadEsami();
              await this.loadVotiEsami();
              await this.loadVotiUnificati(); // Ricarica anche i voti unificati
              this.setState({});
            }}
          />

          <InsertEsame
            key={Math.random()}
            show={this.state.insertEsameShow}
            onCancel={() => this.setState({ insertEsameShow: false })}
            onOkClicked={async (data, titolo) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });

              this.setState({ insertEsameShow: false });
              var resp = await addEsame(
                username,
                token,
                this.corso.id,
                data,
                titolo,
              );
              await this.loadEsami();
              await this.loadVotiEsami();
              await this.loadVotiUnificati(); // Ricarica anche i voti unificati
              await this.setState({});
              if (resp.result == "ok") alert("Esame inserito con successo");
              else alert("Si è verificato un errore");
            }}
          />

          <PageTitle title="Voti Esami" />

          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          {/* Tabella unificata dei voti */}
          {this.state.headCellsVotiUnificati.length > 0 && (
            <div>
              <p
                style={{
                  marginBottom: "10px",
                  fontSize: "14px",
                  color: "#666",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#d4edda",
                    border: "1px solid #c3e6cb",
                    marginRight: "5px",
                    verticalAlign: "middle",
                  }}
                ></span>
                <strong>Verde:</strong> Voto trasferito da un altro corso (lo
                studente aveva già il voto)
                <br />
                <span
                  style={{
                    display: "inline-block",
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#f8d7da",
                    border: "1px solid #f5c6cb",
                    marginRight: "5px",
                    marginLeft: "0",
                    verticalAlign: "middle",
                  }}
                ></span>
                <strong>Rosso:</strong> Voto recuperato (lo studente non aveva
                il voto, poi lo ha sostenuto)
                <br />
                <span
                  style={{
                    marginLeft: "17px",
                    fontSize: "13px",
                    fontStyle: "italic",
                  }}
                >
                  "(-)" indica che lo studente deve ancora sostenere l'esame
                </span>
              </p>
              <Table
                headCells={this.state.headCellsVotiUnificati}
                searchCols={["nome", "cognome"]}
                calendar={false}
                excel={false}
                pdf={false}
                rows={this.state.votiUnificati}
                votiUnificati={true} // Flag per indicare che è una tabella con voti unificati
                onPdfClicked={(row) => {
                  const cookies = new Cookies();
                  cookies.set("selectedExam", row, { path: "/" });
                  window.location.href = "/#/app/pdfExam";
                }}
              />
            </div>
          )}

          {this.state.detailsShow && (
            <DetailsDialog
              key={`details-${this.state.details?.[0]?.[5]}-${Date.now()}`}
              title="Dettagli presenza"
              retired={this.state.retiredDetails}
              studentDetails={this.state.studentDetails}
              studente={this.state.currentStudentObject}
              details={this.state.details}
              exams={this.state.exams}
              show={this.state.detailsShow}
              showExams={this.state.showExams}
              singleMode={this.state.singleMode}
              onClose={async () => {
                // Chiudi il modal
                this.setState({ detailsShow: false });

                // Ricarica i dati quando il modal viene chiuso così quando lo riapri sono aggiornati
                const studentId =
                  this.state.details && this.state.details.length > 0
                    ? this.state.details[0][5]
                    : null;

                if (studentId) {
                  console.log(
                    "EditCorso: Modal chiuso, ricaricando dati unificati studente",
                  );

                  // 🔐 VERIFICA SE ASSENZE ERANO AZZERATE PER mantieni_assenze=0
                  const deveMantenerAssenze = this.shouldMantainAssenze(
                    studentId,
                  );

                  if (
                    !deveMantenerAssenze &&
                    this.assenzePrecedentiMap &&
                    this.assenzePrecedentiMap[studentId] === 0
                  ) {
                    console.log(
                      `[onClose] 🔒 mantieni_assenze=0: NON ricarico assenze, mantengo a 0`,
                    );
                    // Non fare niente, lascia i valori azzerati
                    return;
                  }

                  // 🆕 USA IL SISTEMA UNIFICATO invece del vecchio reloadStudentDetails
                  const cookies = new Cookies();
                  const username = cookies.get("username", { path: "/" });
                  const token = cookies.get("token", { path: "/" });
                  const currentCourse = cookies.get("currentCourse", {
                    path: "/",
                  });

                  try {
                    const presenzeUnificate = await getPresenzeStudente(
                      username,
                      token,
                      studentId,
                      currentCourse,
                    );

                    // Separa per corso
                    const corsoCorrente = presenzeUnificate.filter(
                      (p) => p.id_corso == currentCourse,
                    );
                    const corsiPrecedenti = presenzeUnificate.filter(
                      (p) => p.id_corso != currentCourse,
                    );

                    // Ricalcola statistiche
                    const stats = this.calcolaStatistichePresenze(
                      presenzeUnificate,
                      currentCourse,
                    );

                    // 🔐 AZZERA ASSENZE PRECEDENTI SE mantieni_assenze=0
                    if (!deveMantenerAssenze) {
                      console.log(
                        `[onClose] 🚫 mantieni_assenze=0: azzerando assenze precedenti (erano ${stats.assenzePrecedenti})`,
                      );
                      stats.assenzePrecedenti = 0;
                      stats.assenzeEffettive = Math.max(
                        0,
                        stats.assenzeCorrente - stats.recuperiCompletati,
                      );
                      console.log(
                        `[onClose] ✅ Nuove assenze effettive: ${stats.assenzeEffettive}`,
                      );
                    }

                    // Aggiorna la mappa
                    this.presenzeStudenteMap[studentId] = {
                      tutte: presenzeUnificate,
                      corsoCorrente,
                      corsiPrecedenti: deveMantenerAssenze
                        ? corsiPrecedenti
                        : [], // Svuota se flag=0
                      statistiche: stats,
                    };

                    // Aggiorna il counter nella tabella
                    const studentIndex = this.studentiAttivi.findIndex(
                      (s) => s.id == studentId,
                    );
                    if (studentIndex !== -1) {
                      this.studentiAttivi[
                        studentIndex
                      ].frequencyPercent = `${stats.assenzeEffettive}/${this.lezioniSvolteEffettive.length}`;
                      this.setState({ _dummyUpdate: Date.now() });
                    }

                    console.log(
                      `[onClose] ✅ Dati unificati aggiornati: ${stats.assenzeEffettive} assenze effettive`,
                    );
                  } catch (error) {
                    console.error(
                      "[onClose] Errore ricaricamento dati:",
                      error,
                    );
                  }
                }
              }}
              onRefresh={async () => {
                // Callback per aggiornamenti: recupero assenze precedenti, creazione richieste recupero, ecc.
                console.log(
                  "EditCorso: onRefresh chiamato - Ricaricando tutti i dati",
                );
                const studentId =
                  this.state.details && this.state.details.length > 0
                    ? this.state.details[0][5] // id_studente nella posizione 5
                    : null;

                // Ricarica le assenze precedenti
                await this.loadAssenzePrecedenti();

                // Se abbiamo uno studentId, ricarica anche i suoi dettagli
                if (studentId) {
                  await this.reloadStudentDetails(studentId);
                }

                // Ricarica la tabella principale per aggiornare i counters
                await this.reloadPresenzeData();
              }}
              onReload={async () => {
                // Ricarica i details specifici dello studente E la tabella principale
                console.log(
                  "EditCorso: Ricaricando details studente dopo aggiornamento recupero",
                );
                const studentId =
                  this.state.details && this.state.details.length > 0
                    ? this.state.details[0][5] // id_studente nella posizione 5
                    : null;
                if (studentId) {
                  // ❌ RIMOSSO: loadAssenzePrecedenti() - dati statici già caricati, non cambiano durante modal
                  // Ricarica solo lo stato aggiornato dei recuperi per questo studente
                  await this.reloadStudentDetails(studentId);
                  // IMPORTANTE: Ricarica anche la tabella principale per aggiornare il counter
                  console.log(
                    "EditCorso: Ricaricando tabella principale per aggiornare counter assenze",
                  );
                  await this.reloadPresenzeData();
                }
              }}
              det={this.state.det}
            />
          )}

          {/* Sezione Scontistiche */}
          <PageTitle
            title="Scontistiche"
            button="SALVA"
            onClick={() => this.saveScontistiche()}
          />
          <div
            style={{
              flex: 1,
              borderTop: "2px solid #e61f29",
              marginBottom: "20px",
            }}
          />

          <div style={{ padding: "10px 0" }}>
            <textarea
              style={{
                width: "100%",
                minHeight: "200px",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ddd",
                fontFamily: "inherit",
                fontSize: "14px",
                marginBottom: "20px",
              }}
              placeholder="Inserisci qui tutte le informazioni relative alle scontistiche applicabili al corso..."
              value={this.state.scontistiche}
              onChange={(e) => this.setState({ scontistiche: e.target.value })}
            />

            <div style={{ marginTop: "20px" }}>
              <h4 style={{ marginBottom: "10px" }}>Documenti allegati</h4>
              <FileUploader
                files={this.state.files}
                onChange={(files) => this.setState({ files })}
              />
            </div>
          </div>
        </LoadingOverlay>

        {/* Modal per visualizzare studenti che hanno completato il compito */}
        <CompitoStudentiModal
          isOpen={this.state.showCompitoStudentiModal}
          onClose={() => this.setState({ showCompitoStudentiModal: false })}
          titoloCompito={this.state.selectedCompitoTitolo}
          studenti={this.state.compitoStudenti}
          isLoading={this.state.loadingCompitoStudenti}
        />
      </>
    );
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const xStartDate = this.startDateRef.current.getDate();
    const xEndDate = this.endDateRef.current.getDate();

    let startDate = moment(xStartDate).format("yyyy-MM-DD");
    let endDate = moment(xEndDate).format("yyyy-MM-DD");

    if (xEndDate < xStartDate) {
      alert("Controlla le date del corso per favore");
      return;
    }

    if (!this.state.selectedCategoriaCorso) {
      alert("Seleziona una categoria per il corso");
      return;
    }

    let startHour = moment(xStartDate).format("HH");
    let startMinutes = moment(xStartDate).format("mm");
    let endHour = moment(xEndDate).format("HH");
    let endMinutes = moment(xEndDate).format("mm");

    await updateCorso(
      username,
      token,
      this.state.corso.id,
      this.state.corso.name,
      startDate,
      endDate,
      this.state.corso.visibleStudent,
      this.state.corso.anno_accademico,
      this.state.selectedCategoriaCorso.value,
    );
    window.location.href = "/#/app/corsi";

    /* let ret = await addCorso (username, token, this.state.nomeCorso, startDate, endDate);

      if (ret.result == 'ok'){
        window.location.href = '/#/app/corsi';
      }
      else {
        alert ('An error occurred while creating a new event.')
      }
      */
  }

  async deleteCorsoHandler() {
    if (
      !window.confirm(
        `ATTENZIONE!\n\nStai per eliminare DEFINITIVAMENTE il corso:\n"${this.state.corso.name}"\n\nQuesta operazione:\n- Eliminerà TUTTI i dati associati (lezioni, presenze, esami, etc.)\n- NON può essere annullata\n- Rimuoverà completamente il corso dal database\n\nSei SICURO di voler procedere?`,
      )
    ) {
      return;
    }

    // Doppia conferma per sicurezza
    const conferma = window.prompt(
      `Per confermare l'eliminazione definitiva del corso "${this.state.corso.name}", digita esattamente: ELIMINA`,
    );

    if (conferma !== "ELIMINA") {
      alert("Eliminazione annullata.");
      return;
    }

    try {
      this.setState({ isLoading: true });

      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });

      await deleteCorso(username, token, this.state.corso.id);

      alert(
        `Corso "${this.state.corso.name}" eliminato completamente dal database.`,
      );
      window.location.href = "/#/app/corsi";
    } catch (error) {
      console.error("Errore durante l'eliminazione del corso:", error);
      alert("Si è verificato un errore durante l'eliminazione. Riprova.");
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async handleStudentClick(row, showExams) {
    console.log(`[handleStudentClick] Inizio per studente ${row}`);

    // 🆕 NUOVO SISTEMA: Usa i dati unificati se disponibili
    const useNewSystem = true; // Flag per testare gradualmente

    if (useNewSystem) {
      console.log(`[handleStudentClick] 🆕 Usando nuovo sistema unificato`);

      // Se non abbiamo già i dati, caricali
      if (!this.presenzeStudenteMap[row]) {
        await this.loadPresenzeUnificate(row);
      }

      const presenzeData = this.presenzeStudenteMap[row];
      if (presenzeData) {
        console.log(
          `[handleStudentClick] ✅ Dati unificati disponibili: ${presenzeData.tutte.length} presenze totali`,
        );

        // 📊 AGGIORNA CONTATORI NELLA TABELLA
        const stats = presenzeData.statistiche;
        const studentIndex = this.studentiAttivi.findIndex((s) => s.id == row);
        if (studentIndex !== -1) {
          console.log(
            `[handleStudentClick] 📊 Aggiornamento contatori per studente ${row}:`,
            stats,
          );
          console.log(
            `[handleStudentClick] 📊 PRIMA - frequencyPercent:`,
            this.studentiAttivi[studentIndex].frequencyPercent,
          );

          // AGGIORNA ANCHE LA MAPPA DELLE ASSENZE PRECEDENTI (sistema vecchio)
          // In modo che al prossimo refresh il calcolo sia corretto
          if (stats.assenzePrecedenti > 0) {
            if (!this.assenzePrecedentiMap) {
              this.assenzePrecedentiMap = {};
            }
            this.assenzePrecedentiMap[row] = stats.assenzePrecedenti;
            console.log(
              `[handleStudentClick] 📝 Aggiornata assenzePrecedentiMap[${row}] = ${stats.assenzePrecedenti}`,
            );
          }

          // CREA UN NUOVO ARRAY COMPLETAMENTE da zero
          // Clona ogni oggetto per forzare React a vedere il cambio
          const nuovoArray = this.studentiAttivi.map((studente, idx) => {
            if (idx === studentIndex) {
              // Questo è lo studente da aggiornare - crea un nuovo oggetto
              return {
                ...studente,
                assenzeEffettive: stats.assenzeEffettive,
                assenzeCorrente: stats.assenzeCorrente,
                assenzePrecedenti: stats.assenzePrecedenti,
                recuperiCompletati: stats.recuperiCompletati,
                richiesteInCorso: stats.richiesteInCorso,
                frequencyPercent: `${stats.assenzeEffettive}/${this.lezioniSvolteEffettive.length}`,
              };
            }
            // Gli altri studenti restano uguali ma li cloniamo comunque
            return { ...studente };
          });

          // Assegna il nuovo array
          this.studentiAttivi = nuovoArray;

          console.log(
            `[handleStudentClick] 📊 DOPO - frequencyPercent:`,
            this.studentiAttivi[studentIndex].frequencyPercent,
          );
          console.log(
            `[handleStudentClick] ✅ Counter aggiornato: ${stats.assenzeEffettive}/${this.lezioniSvolteEffettive.length}`,
          );
          console.log(
            `[handleStudentClick] 🔄 Nuovo array studentiAttivi creato con ${nuovoArray.length} studenti`,
          );

          // Forza React a re-renderizzare TUTTO il componente
          // Usiamo setState per triggerare il re-render invece di forceUpdate()
          this.setState({ _dummyUpdate: Date.now() });
          console.log(
            `[handleStudentClick] 🔄 setState chiamato con _dummyUpdate:`,
            Date.now(),
          );
        }

        // 🔐 FILTRA ASSENZE PRECEDENTI SE mantieni_assenze=0
        let presenzeFiltered = { ...presenzeData };
        const deveMantenerAssenze = this.shouldMantainAssenze(row);

        if (!deveMantenerAssenze) {
          console.log(
            `[handleStudentClick] 🚫 mantieni_assenze=0 per studente ${row}: filtrando assenze corsi precedenti`,
          );
          // Mantieni solo le assenze del corso corrente
          presenzeFiltered.tutte = presenzeData.tutte.filter(
            (p) => p.id_corso == this.corso.id,
          );
          presenzeFiltered.corsiPrecedenti = []; // Svuota corsi precedenti
          console.log(
            `[handleStudentClick] ✅ Filtrate ${presenzeData.tutte.length} → ${presenzeFiltered.tutte.length} presenze (solo corso corrente)`,
          );
        } else {
          console.log(
            `[handleStudentClick] ✓ mantieni_assenze=1 per studente ${row}: mostrando tutte le ${presenzeData.tutte.length} assenze`,
          );
        }

        // Costruisci l'array details dal nuovo sistema (ora con dati filtrati)
        const details = this.buildDetailsFromPresenzeUnificate(
          presenzeFiltered,
          row,
        );

        // Carica esami
        const esamiStudente = this.valutazioni.filter(
          (esame) => esame.id_studente == row && esame.valutazione != -1,
        );
        var examsDetails = [];
        this.esami.forEach((esameCorso) => {
          esamiStudente.forEach((esameStudente) => {
            if (esameCorso.id == esameStudente.id_esame) {
              examsDetails.push([
                esameCorso.nome,
                esameStudente.valutazione,
                esameStudente.data_valutazione,
                esameStudente.id,
                esameCorso.id,
              ]);
            }
          });
        });

        // Info studente
        const currentStudent = this.studenti.filter(
          (studente) => studente.id == row,
        );
        const studentFullName =
          currentStudent[0].cognome + " " + currentStudent[0].nome;
        const recuperoId = details.find((detail) => detail[3])
          ? details.find((detail) => detail[3])[3]
          : null;

        // Aggiorna state con i nuovi dati
        console.log(
          `[handleStudentClick] 📦 Details da passare al modal:`,
          details,
        );
        console.log(
          `[handleStudentClick] 📦 Prima riga details[0]:`,
          details[0],
        );
        console.log(
          `[handleStudentClick] 📦 Ultima riga details[${details.length - 1}]:`,
          details[details.length - 1],
        );

        // DEEP CLONE usando JSON per evitare qualsiasi riferimento condiviso
        const detailsClone = JSON.parse(JSON.stringify(details));
        console.log(
          `[handleStudentClick] 📦 JSON Clonato details, ultima riga clone[${detailsClone.length -
            1}]:`,
          detailsClone[detailsClone.length - 1],
        );

        this.setState({
          detailsShow: true,
          details: detailsClone,
          exams: examsDetails,
          retiredDetails: currentStudent[0].corsi_ritiro.includes(
            this.corso.id + ";",
          ),
          studentDetails: studentFullName,
          currentStudentObject: currentStudent[0],
          det: recuperoId,
          showExams: showExams,
          singleMode: true, // Mostra solo la tab richiesta
        });

        console.log(
          `[handleStudentClick] 🎉 Modal popolato con nuovo sistema: ${details.length} righe`,
        );
        return; // Esci, non usare il vecchio sistema
      }
    }

    // ⚠️ VECCHIO SISTEMA: Manteniamo per ora come fallback
    console.log(
      `[handleStudentClick] dettagliAssenzePrecedenti disponibili:`,
      Object.keys(this.dettagliAssenzePrecedenti || {}),
    );
    console.log(
      `[handleStudentClick] dettagliAssenzePrecedenti[${row}]:`,
      this.dettagliAssenzePrecedenti?.[row],
    );
    console.log(
      `[handleStudentClick] assenzePrecedentiMap[${row}]:`,
      this.assenzePrecedentiMap?.[row],
    );

    // Carica tutti i recuperi per trovare quelli completati
    const username = localStorage.getItem("username");
    const token = localStorage.getItem("token");
    const recuperiResponse = await getRecuperi(username, token);
    const tuttiRecuperi = Array.isArray(recuperiResponse)
      ? recuperiResponse
      : recuperiResponse?.data || recuperiResponse?.recuperi || [];

    // ✅ NUOVO: Combina recuperi del corso corrente con recuperi precedenti
    let recuperiStudente = tuttiRecuperi.filter((r) => r.id_studente == row);

    // Aggiungi recuperi precedenti dalla mappa (se esistono)
    const recuperiPrecedenti = this.recuperiPrecedentiMap?.[row] || [];
    if (recuperiPrecedenti.length > 0) {
      console.log(
        `[handleStudentClick] 🔄 Aggiungendo ${recuperiPrecedenti.length} recuperi precedenti per studente ${row}`,
      );
      recuperiStudente = [...recuperiStudente, ...recuperiPrecedenti];
    }

    console.log(
      `[handleStudentClick] Recuperi totali caricati per studente ${row}: ${
        recuperiStudente.length
      } (${
        tuttiRecuperi.filter((r) => r.id_studente == row).length
      } attuali + ${recuperiPrecedenti.length} precedenti)`,
    );

    var details = [];
    this.lezioniSvolteEffettive.sort((l1, l2) => {
      var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
      var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
      return data1 < data2 ? -1 : 1;
    });

    const esamiStudente = this.valutazioni.filter(
      (esame) => esame.id_studente == row && esame.valutazione != -1,
    );

    var examsDetails = [];

    this.esami.forEach((esameCorso) => {
      esamiStudente.forEach((esameStudente) => {
        if (esameCorso.id == esameStudente.id_esame) {
          // Add this exam to the list in state
          var nota = [];
          // La data è già formattata in DD/MM/YYYY da loadEsami(), non serve ri-formattarla
          const dataFormattata = esameCorso.data || "";
          nota.push(esameCorso.nome.toUpperCase() + ": " + dataFormattata);
          nota.push(esameStudente.valutazione);
          examsDetails.push(nota);
        }
      });
    });

    // === AGGIUNGI VOTI DEI CORSI PRECEDENTI ===
    console.log(
      `[handleStudentClick] Aggiunta voti corsi precedenti per studente ${row}`,
    );
    const votiPrecedentiStudente = this.state.votiPrecedenti?.find(
      (item) => item.id_studente == row,
    );

    if (votiPrecedentiStudente && votiPrecedentiStudente._esamiOriginali) {
      console.log(
        `[handleStudentClick] Trovati ${
          Object.keys(votiPrecedentiStudente._esamiOriginali).length
        } esami precedenti`,
      );

      // Itera sugli esami originali
      for (const chiaveEsame in votiPrecedentiStudente._esamiOriginali) {
        const esame = votiPrecedentiStudente._esamiOriginali[chiaveEsame];

        // Verifica se questo esame è già presente nel corso attuale
        const esameGiaPresente = this.esami.some(
          (esameCorso) =>
            esameCorso.nome.replace(/\s+/g, "").toLowerCase() === chiaveEsame,
        );

        if (!esameGiaPresente) {
          // Esame non presente nel corso attuale, aggiungilo come voto precedente
          var nota = [];
          const dataFormatted = esame.data
            ? moment(esame.data).format("DD/MM/YYYY")
            : "Data non disponibile";
          nota.push(
            `${esame.nome.toUpperCase()} (CORSO PRECEDENTE): ${dataFormatted}`,
          );
          nota.push(esame.valutazione);
          examsDetails.push(nota);
          console.log(
            `[handleStudentClick] ✓ Aggiunto voto precedente: ${esame.nome} = ${esame.valutazione}`,
          );
        } else {
          console.log(
            `[handleStudentClick] ⚠️ Esame ${esame.nome} già presente nel corso attuale, skip`,
          );
        }
      }
    } else {
      console.log(
        `[handleStudentClick] Nessun voto precedente trovato per studente ${row}`,
      );
    }

    for (const l of this.lezioniSvolteEffettive) {
      var presenze = this.presenzeCorsoEffettive.filter(
        (p) => p.id_lezione == l.id && p.id_studente == row,
      );

      // Solo se c'è una gestione presenza per questa lezione, crea una voce nel modal
      if (presenze.length > 0) {
        // Gestisce sia lezioni normali (1 presenza) che lezioni divise (2+ presenze)
        presenze.forEach((presenza) => {
          console.log(`[Modal DEBUG handleStudentClick] Presenza:`, presenza);
          console.log(
            `[Modal DEBUG handleStudentClick] id_sessione = "${presenza.id_sessione}", tipo:`,
            typeof presenza.id_sessione,
          );

          var nota = [];
          var val = presenza.presenza == -1 ? "ASSENTE" : "PRESENTE";

          // Determina se è una sessione (metà giornata)
          const hasSessione =
            presenza.id_sessione &&
            presenza.id_sessione !== null &&
            presenza.id_sessione !== "null" &&
            presenza.id_sessione !== "";

          console.log(
            `[Modal DEBUG handleStudentClick] hasSessione = ${hasSessione}`,
          );
          console.log(
            `[Modal DEBUG handleStudentClick] sessioniMap keys:`,
            Object.keys(this.sessioniMap || {}),
          );

          let sessioneLabel = "";
          if (hasSessione) {
            // Usa la mappa delle sessioni per ottenere l'ordine corretto
            const sessione = this.sessioniMap[presenza.id_sessione];
            console.log(
              `[Modal DEBUG handleStudentClick] Sessione trovata:`,
              sessione,
            );
            if (sessione) {
              sessioneLabel =
                sessione.ordine === 1 ? " ☀ (Prima metà)" : " ☾ (Seconda metà)";
              console.log(
                `[Modal handleStudentClick] Sessione ${presenza.id_sessione}: ordine=${sessione.ordine}, label="${sessioneLabel}"`,
              );
            } else {
              // Fallback: usa il modulo se la sessione non è stata trovata
              sessioneLabel =
                presenza.id_sessione % 2 === 1
                  ? " ☀ (Prima metà)"
                  : " ☾ (Seconda metà)";
              console.warn(
                `[Modal handleStudentClick] Sessione ${presenza.id_sessione} non trovata nella mappa, usando fallback`,
              );
            }
          }

          // ✅ FIX: Per mezze giornate, usa l'orario della sessione invece di l.data (che ha 08:00 default)
          let dataPerNota = l.data;
          if (hasSessione) {
            const sessione = this.sessioniMap[presenza.id_sessione];
            if (sessione && sessione.ora_inizio) {
              // Sostituisci l'orario di l.data con ora_inizio della sessione
              const datePart = l.data.split(" ")[0];
              dataPerNota = `${datePart} ${sessione.ora_inizio}`;
            }
          }
          nota.push(dataPerNota);
          nota.push((l.argomento ? l.argomento : "") + sessioneLabel);
          nota.push(val);

          // MODIFICA: Cerca il recupero anche se id_recupero_lezioni è null
          let idRecuperoLezioni = presenza.id_recupero_lezioni;

          // Se il backend ha cancellato id_recupero_lezioni, cerca nella lista recuperi
          // FIX: Match ESATTO tra presenza.id_sessione e recupero.id_sessione
          // - Se presenza ha sessione, recupero DEVE avere la STESSA sessione
          // - Se presenza NON ha sessione, recupero NON deve avere sessione
          if (!idRecuperoLezioni && val === "ASSENTE") {
            const recuperoCompletato = recuperiStudente.find(
              (r) =>
                r.id_assenza_originale == l.id &&
                r.id_lezione_recupero !== null &&
                // ✅ MATCH ESATTO: entrambi null O stessa sessione
                ((r.id_sessione == null && presenza.id_sessione == null) ||
                  r.id_sessione == presenza.id_sessione),
            );
            if (recuperoCompletato) {
              idRecuperoLezioni = recuperoCompletato.id;
              console.log(
                `[handleStudentClick] ✅ Recupero completato trovato per lezione ${l.id}, sessione ${presenza.id_sessione}: recupero ID ${idRecuperoLezioni}`,
              );
            } else {
              console.log(
                `[handleStudentClick] ⚠️ Nessun recupero trovato per lezione ${l.id}, sessione ${presenza.id_sessione}`,
              );
            }
          }

          nota.push(idRecuperoLezioni);
          nota.push(l.id); // id_lezione (posizione 4)
          nota.push(row); // id_studente (posizione 5)
          nota.push(presenza.id_sessione || null); // id_sessione (posizione 6) - AGGIUNTO per gestire recuperi parziali

          if (presenza.ore != "")
            nota[1] += " " + presenza.ore + "/" + l.durata / 60;
          if (idRecuperoLezioni !== null) {
            nota.push("RICHIESTA RECUPERO");
          }

          details.push(nota);
        });
      }
    }

    // AGGIUNTA: Include le assenze precedenti dal sistema di cambio corso
    const assenzePrecedentiStudente =
      this.dettagliAssenzePrecedenti?.[row] || [];
    console.log(
      `[handleStudentClick] Aggiungendo ${assenzePrecedentiStudente.length} assenze precedenti per studente ${row}`,
    );
    console.log(
      `[handleStudentClick] Details prima assenze precedenti:`,
      details.length,
      "elementi",
    );

    // Deduplicazione delle assenze precedenti per evitare duplicati
    // IMPORTANTE: Includere id_sessione nella chiave per distinguere mezze giornate
    const assenzeUniche = new Map();
    assenzePrecedentiStudente.forEach((assenza) => {
      const chiaveUnica = `${assenza.data}_${
        assenza.idLezione
      }_${assenza.id_sessione || "full"}`;
      if (!assenzeUniche.has(chiaveUnica)) {
        assenzeUniche.set(chiaveUnica, assenza);
      }
    });

    console.log(
      `[handleStudentClick] Assenze deduplicate: ${assenzeUniche.size} su ${assenzePrecedentiStudente.length} originali`,
    );

    // Crea un Set con le coppie lezione+sessione già presenti nei details (per evitare duplicati)
    const lezioniSessioniGiaPresenti = new Set(
      details.map((d) => {
        // d[4] = id_lezione, d[6] = id_sessione
        const idLezione = d[4];
        const idSessione = d[6];
        const lezioneNormalized =
          typeof idLezione === "string" && idLezione.startsWith("prev_")
            ? idLezione.replace("prev_", "")
            : idLezione;
        // Crea chiave unica: "lezione_sessione" (se sessione è null usa "null")
        return `${lezioneNormalized}_${idSessione || "null"}`;
      }),
    );

    console.log(
      `[handleStudentClick] Lezioni+Sessioni già presenti nei details:`,
      Array.from(lezioniSessioniGiaPresenti),
    );

    // IMPORTANTE: Cerca se esistono richieste di recupero per queste assenze precedenti
    assenzeUniche.forEach((assenza) => {
      // Controlla se questa coppia lezione+sessione è già presente (evita duplicati)
      const chiaveControllo = `${assenza.idLezione}_${assenza.id_sessione ||
        "null"}`;

      // Cerca se esiste una richiesta di recupero per questa assenza cross-corso
      console.log(
        `[handleStudentClick] 🔍 Cerco recupero per lezione ${assenza.idLezione} sessione ${assenza.id_sessione}`,
      );
      const richiestaRecupero = recuperiStudente.find((r) => {
        const lezioneMatch = r.id_assenza_originale == assenza.idLezione;
        const sessioneMatch =
          (r.id_sessione == null && assenza.id_sessione == null) ||
          r.id_sessione == assenza.id_sessione;

        if (lezioneMatch) {
          console.log(
            `[handleStudentClick]   → Recupero ${r.id}: lezione match ✓, r.id_sessione=${r.id_sessione}, assenza.id_sessione=${assenza.id_sessione}, sessioneMatch=${sessioneMatch}`,
          );
        }

        return lezioneMatch && sessioneMatch;
      });
      const idRecuperoLezioni = richiestaRecupero ? richiestaRecupero.id : null;

      if (richiestaRecupero) {
        console.log(
          `[handleStudentClick] ✅ Trovato recupero ${richiestaRecupero.id} per lezione ${assenza.idLezione} sessione ${assenza.id_sessione}`,
        );
      }

      if (lezioniSessioniGiaPresenti.has(chiaveControllo)) {
        // Se l'assenza cross-corso HA un recupero, SOSTITUISCI la riga del corso corrente
        if (idRecuperoLezioni) {
          console.log(
            `[handleStudentClick] 🔄 SOSTITUZIONE - Assenza lezione ${assenza.idLezione} sessione ${assenza.id_sessione} già presente ma cross-corso ha recupero ${idRecuperoLezioni}, sostituisco`,
          );

          // Trova e rimuovi la riga esistente
          const indexToReplace = details.findIndex((d) => {
            const dIdLezione =
              typeof d[4] === "string" && d[4].startsWith("prev_")
                ? d[4].replace("prev_", "")
                : d[4];
            const dIdSessione = d[6];
            return (
              dIdLezione == assenza.idLezione &&
              dIdSessione == assenza.id_sessione
            );
          });

          if (indexToReplace !== -1) {
            details.splice(indexToReplace, 1);
            console.log(
              `[handleStudentClick] ✅ Rimossa riga corso corrente all'indice ${indexToReplace}`,
            );
          }
          // Continua per aggiungere la riga cross-corso con recupero
        } else {
          // Se cross-corso NON ha recupero, skippa (mantieni riga corso corrente)
          console.log(
            `[handleStudentClick] ⚠️ SKIP - Assenza lezione ${assenza.idLezione} sessione ${assenza.id_sessione} già presente nei details e cross-corso non ha recupero`,
          );
          return; // Skip questa assenza
        }
      }

      console.log(
        `[handleStudentClick] Aggiungendo assenza precedente unica:`,
        assenza,
      );

      // La richiesta è già stata cercata sopra, riutilizza idRecuperoLezioni

      console.log(
        `[handleStudentClick] Assenza precedente lezione ${
          assenza.idLezione
        }: richiesta recupero ${
          idRecuperoLezioni
            ? "TROVATA (ID: " + idRecuperoLezioni + ")"
            : "NON TROVATA"
        }`,
      );

      var nota = [];
      // ✅ FIX: Formatta la data usando ora_inizio della sessione se disponibile
      let displayDate = assenza.data;
      if (
        assenza.sessione_ora_inizio &&
        displayDate &&
        displayDate !== "Data non disponibile"
      ) {
        // Sostituisci l'orario con quello reale della sessione
        const datePart = displayDate.split(" ")[0];
        displayDate = `${datePart} ${assenza.sessione_ora_inizio}`;
      }
      const dataFormatted =
        displayDate && displayDate !== "Data non disponibile"
          ? new Date(displayDate.replace(" ", "T")).toLocaleString("it-IT", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : displayDate;
      // ✅ FIX: Label sessione (Prima metà / Seconda metà) per DetailsDialog
      const sessioneLabel = assenza.sessione_label
        ? ` (${assenza.sessione_label})`
        : "";

      nota.push(dataFormatted); // data lezione formattata (posizione 0) — NO sessioneLabel qui, DetailsDialog la legge da det[1]
      // ✅ Mostra nome corso + label sessione in argomento (det[1]) per DetailsDialog
      let argomentoBase =
        assenza.argomento &&
        assenza.argomento.trim() !== "" &&
        !assenza.argomento.startsWith(" ")
          ? assenza.argomento
          : assenza.nomeCorso || "Corso precedente";
      // Aggiungi label sessione a det[1] se non già presente (DetailsDialog cerca "Prima metà"/"Seconda metà" in det[1])
      const argomentoDisplay =
        sessioneLabel &&
        !argomentoBase.includes("Prima metà") &&
        !argomentoBase.includes("Seconda metà")
          ? argomentoBase + sessioneLabel
          : argomentoBase;
      nota.push(argomentoDisplay); // argomento con label sessione (posizione 1)
      // ✅ FIX: Cambia lo stato in base al recupero
      const statoAssenza = idRecuperoLezioni
        ? "RECUPERATA ✅"
        : "ASSENTE 🔄 recuperabile";
      nota.push(statoAssenza); // stato con indicatore (posizione 2)
      nota.push(idRecuperoLezioni); // id_recupero_lezioni (posizione 3) ← ORA VALORIZZATO SE ESISTE
      nota.push(`prev_${assenza.idLezione}`); // id_lezione con prefisso per identificare assenze precedenti (posizione 4)
      nota.push(row); // id_studente (posizione 5)
      nota.push(assenza.id_sessione || null); // ✅ FIXATO: Usa id_sessione dall'assenza precedente (posizione 6)
      console.log(`[handleStudentClick] Nota assenza precedente creata:`, nota);
      details.push(nota);
      console.log(
        `[handleStudentClick] Details dopo aggiunta:`,
        details.length,
        "elementi",
      );
    });

    console.log(
      `[handleStudentClick] Details finali prima del setState:`,
      details.length,
      "elementi totali",
    );

    const currentStudent = this.studenti.filter(
      (studente) => studente.id == row,
    );
    const studentFullName =
      currentStudent[0].cognome + " " + currentStudent[0].nome;
    const recuperoId = details.find((detail) => detail[3])
      ? details.find((detail) => detail[3])[3]
      : null;

    this.setState({
      detailsShow: true,
      details: details,
      exams: examsDetails,
      retiredDetails: currentStudent[0].corsi_ritiro.includes(
        this.corso.id + ";",
      ),
      studentDetails: studentFullName,
      currentStudentObject: currentStudent[0], // Aggiungiamo l'oggetto studente completo
      det: recuperoId,
      showExams: showExams, // Impostiamo showExams in base al parametro passato
      singleMode: true, // Mostra solo la tab richiesta
    });
  }

  // Metodo per ricaricare solo i dati di presenze e recuperi senza reload completo
  async reloadPresenzeData() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    try {
      // Ricarica solo i dati delle presenze e recuperi
      this.presenzeCorso = await getPresenzeCorso(
        username,
        token,
        currentCourse,
      );

      // Rigenera anche il filtro delle presenze effettive
      const lezioniEffettiveIds = new Set(
        this.lezioniSvolteEffettive.map((l) => l.id),
      );
      this.presenzeCorsoEffettive = this.presenzeCorso.filter((presenza) =>
        lezioniEffettiveIds.has(presenza.id_lezione),
      );

      // Ricarica le informazioni di recupero COMPLETATO per tutti gli studenti
      this.lezioniRecuperateMap = {};

      // Carica tutti i recuperi in una volta sola
      const recuperiResponse = await getRecuperi(username, token);

      // FIX: L'API restituisce {success: true, data: [...]}, gestiamo entrambi i formati
      const tuttiRecuperi = Array.isArray(recuperiResponse)
        ? recuperiResponse
        : recuperiResponse?.data || recuperiResponse?.recuperi || [];

      console.log(
        `[RELOAD DEBUG RECUPERI] Tipo risposta recuperi:`,
        typeof recuperiResponse,
      );
      console.log(
        `[RELOAD DEBUG RECUPERI] Recuperi totali caricati:`,
        tuttiRecuperi.length,
      );

      const assenzeConIdRecupero = this.presenzeCorso.filter(
        (p) =>
          p.presenza == -1 &&
          p.id_recupero_lezioni !== null &&
          p.id_recupero_lezioni !== "" &&
          p.id_recupero_lezioni !== undefined,
      );

      console.log(
        `[RELOAD DEBUG RECUPERI] Totale presenze con assenza: ${
          this.presenzeCorso.filter((p) => p.presenza == -1).length
        }`,
      );
      console.log(
        `[RELOAD DEBUG RECUPERI] Assenze con id_recupero_lezioni: ${assenzeConIdRecupero.length}`,
      );

      // Per ogni assenza, cerca il recupero corrispondente
      for (const presenza of assenzeConIdRecupero) {
        const recupero = tuttiRecuperi.find(
          (r) => r.id == presenza.id_recupero_lezioni,
        );

        // Se il recupero ha id_lezione_recupero, conta come recuperato
        if (recupero && recupero.id_lezione_recupero) {
          // Determina il peso del recupero: 0.5 per sessione, 1.0 per giornata intera
          const hasSessione =
            presenza.id_sessione &&
            presenza.id_sessione !== null &&
            presenza.id_sessione !== "null" &&
            presenza.id_sessione !== "";
          const pesoRecupero = hasSessione ? 0.5 : 1.0;

          if (!this.lezioniRecuperateMap[presenza.id_studente]) {
            this.lezioniRecuperateMap[presenza.id_studente] = pesoRecupero;
          } else {
            this.lezioniRecuperateMap[presenza.id_studente] += pesoRecupero;
          }
        }
      }

      console.log(
        `[RELOAD DEBUG RECUPERI] Recuperi completati (corso corrente):`,
        this.lezioniRecuperateMap,
      );

      // ✅ NUOVO: Aggiungi anche i recuperi completati delle assenze precedenti
      // Carica TUTTI i recuperi dal backend e verifica quali corrispondono alle assenze precedenti
      try {
        const recuperiResponse = await getRecuperi(username, token);
        const tuttiRecuperi =
          recuperiResponse?.success && recuperiResponse?.data
            ? recuperiResponse.data
            : [];

        console.log(
          `[RELOAD DEBUG RECUPERI PRECEDENTI] Totale recuperi caricati: ${tuttiRecuperi.length}`,
        );

        // Per ogni studente con assenze precedenti
        for (const idStudente of Object.keys(
          this.dettagliAssenzePrecedenti || {},
        )) {
          const assenzePrecedenti = this.dettagliAssenzePrecedenti[idStudente];
          if (!assenzePrecedenti || assenzePrecedenti.length === 0) continue;

          console.log(
            `[RELOAD DEBUG RECUPERI PRECEDENTI] Processando studente ${idStudente}, ${assenzePrecedenti.length} assenze precedenti`,
          );

          // Filtra i recuperi di questo studente
          const recuperiStudente = tuttiRecuperi.filter(
            (r) => r.id_studente == idStudente,
          );

          console.log(
            `[RELOAD DEBUG RECUPERI PRECEDENTI] Trovati ${recuperiStudente.length} recuperi per studente ${idStudente}`,
          );

          // Per ogni assenza precedente, cerca se ha un recupero completato
          for (const assenza of assenzePrecedenti) {
            // Trova il recupero corrispondente a questa assenza (match su id_lezione E id_sessione)
            const recuperoCorrispondente = recuperiStudente.find((r) => {
              const lezioneMatch = r.id_assenza_originale == assenza.idLezione;
              const sessioneMatch =
                (r.id_sessione == null && assenza.id_sessione == null) ||
                r.id_sessione == assenza.id_sessione;
              const isCompletato =
                r.id_lezione_recupero !== null &&
                r.id_lezione_recupero !== undefined;

              return lezioneMatch && sessioneMatch && isCompletato;
            });

            if (recuperoCorrispondente) {
              // Determina il peso del recupero
              const hasSessione =
                assenza.id_sessione &&
                assenza.id_sessione !== null &&
                assenza.id_sessione !== "null" &&
                assenza.id_sessione !== "";
              const pesoRecupero = hasSessione ? 0.5 : 1.0;

              console.log(
                `[RELOAD DEBUG RECUPERI PRECEDENTI] ✓ Assenza precedente lezione ${assenza.idLezione} sessione ${assenza.id_sessione} recuperata - peso=${pesoRecupero}`,
              );

              if (!this.lezioniRecuperateMap[idStudente]) {
                this.lezioniRecuperateMap[idStudente] = pesoRecupero;
              } else {
                this.lezioniRecuperateMap[idStudente] += pesoRecupero;
              }
            }
          }
        }
      } catch (error) {
        console.error(
          `[RELOAD DEBUG RECUPERI PRECEDENTI] ❌ Errore caricando recuperi:`,
          error,
        );
      }

      console.log(
        `[RELOAD DEBUG RECUPERI] Recuperi completati (corso corrente + precedenti):`,
        this.lezioniRecuperateMap,
      );

      // Ricalcola le percentuali di frequenza per gli studenti attivi
      this.studentiAttivi.forEach((studente, index) => {
        const presenze = this.presenzeCorsoEffettive.filter(
          (p) => p.id_studente == studente.id && p.presenza == 1,
        );

        // Conta TUTTE le assenze dello studente direttamente da presenzeCorso
        // IMPORTANTE: Include sia lezioni passate che future (come in loadVotiUnificati)
        const assenzeStudente = this.presenzeCorso.filter((p) => {
          if (p.id_studente != studente.id) return false;
          if (p.presenza != -1 && p.presenza != 0) return false;

          const lezione = this.lezioniSvolteEffettive.find(
            (l) => l.id == p.id_lezione,
          );
          if (!lezione) return false;

          // ✅ FIX: RIMOSSO il filtro per data per consistenza con loadVotiUnificati
          // Conta tutte le assenze, passate e future
          return true;
        });

        // Calcola il peso delle assenze: 0.5 per sessioni, 1.0 per lezioni intere
        const assenzeContatePerModal = assenzeStudente.reduce((sum, p) => {
          // Gestisce sia null che stringhe "null" o undefined
          const hasSessione =
            p.id_sessione &&
            p.id_sessione !== null &&
            p.id_sessione !== "null" &&
            p.id_sessione !== "";
          const peso = hasSessione ? 0.5 : 1.0;

          console.log(
            `[DEBUG Peso RELOAD] Studente ${studente.nome} ${
              studente.cognome
            }, Presenza ID ${p.id}: id_lezione=${p.id_lezione}, id_sessione="${
              p.id_sessione
            }", hasSessione=${hasSessione}, peso=${peso}, TOTALE PARZIALE=${sum +
              peso}`,
          );

          return sum + peso;
        }, 0);

        // Log finale per vedere il totale
        if (assenzeStudente.length > 0) {
          console.log(
            `[DEBUG Totale RELOAD] Studente ${studente.nome} ${studente.cognome}: ${assenzeStudente.length} record di assenza, peso totale=${assenzeContatePerModal}`,
          );
        }

        const recuperiCompletati = this.lezioniRecuperateMap[studente.id] || 0;
        // ✅ FIX: NON sottrarre qui i recuperi completati!
        // Le assenze vanno sottratte SOLO alla fine nel calcolo di finalAbsences
        // Altrimenti vengono sottratte due volte causando un conteggio errato
        const currentAbsences = assenzeContatePerModal;

        // Il denominatore è sempre il numero totale di lezioni programmate (esclusi pagamenti quota)
        const totalRealLessons = this.lezioniSvolteEffettive.length;
        const previousAbsences =
          this.assenzePrecedentiMap && this.assenzePrecedentiMap[studente.id]
            ? this.assenzePrecedentiMap[studente.id]
            : 0;
        const totalAbsences = currentAbsences + previousAbsences;
        // ✅ FIX: Il denominatore è SOLO le lezioni del corso ATTUALE, non sommare le assenze precedenti!
        // Es: 3 assenze precedenti + 10 lezioni attuali = 3/10 (NON 3/13)
        const totalLessons = totalRealLessons;

        // SCORCIATOIA: Se le assenze sono pari al totale delle lezioni, resetta a 0
        // Significa che sono tutti record auto-generati, non assenze reali
        // IMPORTANTE: NON resettare se ci sono presenze con id_sessione (lezioni divise realmente assenti)
        const hasAssenzeConSessioni = assenzeStudente.some((p) => {
          const hasSessione =
            p.id_sessione &&
            p.id_sessione !== null &&
            p.id_sessione !== "null" &&
            p.id_sessione !== "";
          return hasSessione;
        });

        // ✅ FIX: Non resettare a 0 se ci sono assenze precedenti (sono legittime!)
        // Il reset serve solo per eliminare assenze auto-generate del corso ATTUALE
        // ✅ FIX: Usa currentAbsences (solo corso attuale) per il check di reset, non totalAbsences
        // Altrimenti le assenze precedenti farebbero scattare il reset anche se sono legittime
        // ✅ NUOVO FIX: Sottrai i recuperi completati dalle assenze totali
        let finalAbsences =
          previousAbsences > 0
            ? totalAbsences // Se ci sono assenze precedenti, mantienile sempre
            : currentAbsences >= totalLessons && !hasAssenzeConSessioni
            ? 0
            : totalAbsences;

        // Sottrai i recuperi completati (non può andare sotto zero)
        finalAbsences = Math.max(0, finalAbsences - recuperiCompletati);

        // Debug
        if (
          currentAbsences > 0 ||
          assenzeContatePerModal > 0 ||
          finalAbsences != totalAbsences
        ) {
          console.log(
            `[RELOAD DEBUG] Studente: ${studente.nome} ${studente.cognome}`,
          );
          console.log(
            `[RELOAD DEBUG] - Assenze contate (stile modal): ${assenzeContatePerModal}`,
          );
          console.log(
            `[RELOAD DEBUG] - Recuperi completati: ${recuperiCompletati}`,
          );
          console.log(`[RELOAD DEBUG] - Assenze correnti: ${currentAbsences}`);
          console.log(
            `[RELOAD DEBUG] - Assenze precedenti: ${previousAbsences}`,
          );
          console.log(
            `[RELOAD DEBUG] - Assenze totali calcolate: ${totalAbsences}`,
          );
          console.log(
            `[RELOAD DEBUG] - Assenze finali (dopo reset): ${finalAbsences}`,
          );
          console.log(
            `[RELOAD DEBUG] - Risultato: ${finalAbsences}/${totalLessons}`,
          );
        }

        // Formatta con decimali se necessario
        const finalAbsencesFormatted = Number.isInteger(finalAbsences)
          ? finalAbsences
          : finalAbsences.toFixed(1);

        this.studentiAttivi[
          index
        ].frequencyPercent = `${finalAbsencesFormatted}/${totalLessons}`;
      });

      // Forza il re-render per aggiornare la UI
      this.setState({});

      console.log(
        "EditCorso: Dati presenze e recuperi ricaricati con successo",
      );
    } catch (error) {
      console.error("Errore nel ricaricamento dei dati di presenze:", error);
    }
  }

  // Metodo per ricaricare i details di uno studente specifico
  async reloadStudentDetails(studentId) {
    console.log(
      `[reloadStudentDetails] 🔄 Inizio reload per studente ${studentId}`,
    );

    // ✅ USA IL SISTEMA UNIFICATO invece del vecchio metodo
    // Ricarica i dati unificati (corso corrente + precedenti)
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCorso = this.state.corso.id;

    console.log(
      `[reloadStudentDetails] Ricaricando presenze unificate per studente ${studentId}, corso ${currentCorso}`,
    );

    // Ricarica le presenze unificate per questo studente
    const presenzeUnificateResponse = await getPresenzeStudente(
      username,
      token,
      studentId,
      currentCorso,
    );

    console.log(
      `[reloadStudentDetails] Risposta getPresenzeStudente (raw):`,
      presenzeUnificateResponse,
    );

    // Verifica struttura risposta
    if (
      !presenzeUnificateResponse ||
      !Array.isArray(presenzeUnificateResponse)
    ) {
      console.error(
        `[reloadStudentDetails] ❌ getPresenzeStudente ha restituito null/undefined o non è un array`,
      );
      return;
    }

    // ✅ FIX: getPresenzeStudente restituisce un array, ma buildDetailsFromPresenzeUnificate
    // si aspetta un oggetto con struttura {tutte: [...], correnti: [...], precedenti: [...]}
    // Creiamo questa struttura separando per corso
    const presenzeStrutturate = {
      tutte: presenzeUnificateResponse,
      correnti: presenzeUnificateResponse.filter(
        (p) => p.id_corso == currentCorso,
      ),
      precedenti: presenzeUnificateResponse.filter(
        (p) => p.id_corso != currentCorso,
      ),
    };

    console.log(
      `[reloadStudentDetails] Presenze strutturate: ${presenzeStrutturate.tutte.length} totali (${presenzeStrutturate.correnti.length} correnti + ${presenzeStrutturate.precedenti.length} precedenti)`,
    );

    // Aggiorna lo state.presenzeUnificate con i nuovi dati STRUTTURATI
    const nuovePresenzeUnificate = {
      ...this.state.presenzeUnificate,
      [studentId]: presenzeStrutturate,
    };

    await this.setState({
      presenzeUnificate: nuovePresenzeUnificate,
    });

    console.log(
      `[reloadStudentDetails] State.presenzeUnificate aggiornato per studente ${studentId}`,
      presenzeStrutturate,
    );

    // Ora usa buildDetailsFromPresenzeUnificate per costruire i details
    const details = this.buildDetailsFromPresenzeUnificate(
      presenzeStrutturate,
      studentId,
    );

    console.log(
      `[reloadStudentDetails] ✅ Details costruiti: ${details.length} assenze`,
      details,
    );

    // ✅ IMPORTANTE: Ricarica anche i voti unificati per mantenere i colori (verde=trasferito, rosso=recuperato)
    console.log(
      `[reloadStudentDetails] 🔄 Ricaricando voti unificati per mantenere colori...`,
    );
    await this.loadVotiUnificati();

    // Aggiorna lo state con i nuovi details
    this.setState({ details: details });

    console.log(
      `EditCorso: Details studente aggiornati con ${details.length} assenze, voti ricaricati`,
    );
  }

  // Funzione per gestire la visualizzazione dei file
  handleViewFile = async (idDocumento, nomeFile, tipoFile) => {
    try {
      console.log("Visualizzazione file richiesta:", {
        idDocumento,
        nomeFile,
        tipoFile,
      });

      let result;

      if (tipoFile === "compiti") {
        result = await viewCompito(idDocumento);
      } else if (tipoFile === "dispense") {
        result = await viewDispensa(idDocumento);
      }

      if (!result.success) {
        alert(`Errore nella visualizzazione del file: ${result.error}`);
      }
    } catch (error) {
      console.error("Errore durante la visualizzazione:", error);
      alert("Errore durante la visualizzazione del file: " + error.message);
    }
  };
}
